{
  "metadata": {
    "title": "UK second-year nursing medical knowledge MCQ bank",
    "version": "1.0",
    "created_date": "2026-06-16",
    "intended_use": "Revision, formative assessment, and question bank seeding for UK second-year nursing students; review locally before summative use.",
    "sources_consulted": [
      "NMC Code",
      "Royal College of Physicians NEWS2",
      "NICE sepsis guidance",
      "NICE medicines optimisation guidance"
    ],
    "question_count": 500,
    "schema": {
      "id": "string",
      "level": "string",
      "domain": "string",
      "question": "string",
      "options": "object A-D",
      "correct_answer": "A|B|C|D",
      "rationale": "string"
    },
    "revision": "Removed repeated generic evidence-based guidance questions and replaced with clinical MCQs"
  },
  "questions": [
    {
      "id": "UKN-Y2-001",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Anatomy and physiology",
      "question": "Which structure is the main site of gaseous exchange in the lungs?",
      "options": {
        "A": "Bronchi",
        "B": "Alveoli",
        "C": "Trachea",
        "D": "Pleura"
      },
      "correct_answer": "B",
      "rationale": "Alveoli have thin walls and a rich capillary supply, allowing oxygen and carbon dioxide to diffuse efficiently."
    },
    {
      "id": "UKN-Y2-002",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Anatomy and physiology",
      "question": "Which blood component is primarily responsible for oxygen transport?",
      "options": {
        "A": "Platelets",
        "B": "Erythrocytes",
        "C": "Leukocytes",
        "D": "Plasma proteins"
      },
      "correct_answer": "B",
      "rationale": "Erythrocytes contain haemoglobin, which binds and transports oxygen."
    },
    {
      "id": "UKN-Y2-003",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Anatomy and physiology",
      "question": "Which chamber pumps oxygenated blood to the body?",
      "options": {
        "A": "Right atrium",
        "B": "Right ventricle",
        "C": "Left atrium",
        "D": "Left ventricle"
      },
      "correct_answer": "D",
      "rationale": "The left ventricle ejects oxygenated blood through the aorta into systemic circulation."
    },
    {
      "id": "UKN-Y2-004",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Anatomy and physiology",
      "question": "Which part of the nephron performs the initial filtration of blood?",
      "options": {
        "A": "Collecting duct",
        "B": "Glomerulus",
        "C": "Loop of Henle",
        "D": "Distal tubule"
      },
      "correct_answer": "B",
      "rationale": "The glomerulus filters plasma into Bowman\u2019s capsule to begin urine formation."
    },
    {
      "id": "UKN-Y2-005",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Anatomy and physiology",
      "question": "Which hormone lowers blood glucose?",
      "options": {
        "A": "Glucagon",
        "B": "Insulin",
        "C": "Adrenaline",
        "D": "Cortisol"
      },
      "correct_answer": "B",
      "rationale": "Insulin promotes uptake and storage of glucose, reducing blood glucose concentration."
    },
    {
      "id": "UKN-Y2-006",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Anatomy and physiology",
      "question": "What is the primary role of platelets?",
      "options": {
        "A": "Oxygen transport",
        "B": "Immune defence",
        "C": "Blood clotting",
        "D": "Acid-base regulation"
      },
      "correct_answer": "C",
      "rationale": "Platelets aggregate and support clot formation at sites of vascular injury."
    },
    {
      "id": "UKN-Y2-007",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Anatomy and physiology",
      "question": "Which valve lies between the left atrium and left ventricle?",
      "options": {
        "A": "Tricuspid",
        "B": "Mitral",
        "C": "Pulmonary",
        "D": "Aortic"
      },
      "correct_answer": "B",
      "rationale": "The mitral valve prevents backflow from the left ventricle into the left atrium."
    },
    {
      "id": "UKN-Y2-008",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Anatomy and physiology",
      "question": "Which organ produces bile?",
      "options": {
        "A": "Pancreas",
        "B": "Liver",
        "C": "Gallbladder",
        "D": "Spleen"
      },
      "correct_answer": "B",
      "rationale": "The liver produces bile; the gallbladder stores and concentrates it."
    },
    {
      "id": "UKN-Y2-009",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Anatomy and physiology",
      "question": "What is the normal adult pH range for arterial blood?",
      "options": {
        "A": "6.80-7.00",
        "B": "7.35-7.45",
        "C": "7.80-8.00",
        "D": "8.10-8.20"
      },
      "correct_answer": "B",
      "rationale": "Normal arterial blood pH is tightly regulated around 7.35 to 7.45."
    },
    {
      "id": "UKN-Y2-010",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Anatomy and physiology",
      "question": "Which cranial nerve is mainly involved in facial expression?",
      "options": {
        "A": "Trigeminal",
        "B": "Facial",
        "C": "Vagus",
        "D": "Optic"
      },
      "correct_answer": "B",
      "rationale": "The facial nerve, cranial nerve VII, controls muscles of facial expression."
    },
    {
      "id": "UKN-Y2-011",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Anatomy and physiology",
      "question": "Which electrolyte is most important for cardiac electrical conduction?",
      "options": {
        "A": "Potassium",
        "B": "Fluoride",
        "C": "Iodide",
        "D": "Zinc"
      },
      "correct_answer": "A",
      "rationale": "Potassium has a major role in myocardial action potentials and rhythm stability."
    },
    {
      "id": "UKN-Y2-012",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Anatomy and physiology",
      "question": "Which structure connects muscle to bone?",
      "options": {
        "A": "Ligament",
        "B": "Tendon",
        "C": "Cartilage",
        "D": "Fascia"
      },
      "correct_answer": "B",
      "rationale": "Tendons attach skeletal muscle to bone and transmit force for movement."
    },
    {
      "id": "UKN-Y2-013",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Anatomy and physiology",
      "question": "Which blood vessel usually carries oxygenated blood from the heart?",
      "options": {
        "A": "Pulmonary artery",
        "B": "Vena cava",
        "C": "Aorta",
        "D": "Portal vein"
      },
      "correct_answer": "C",
      "rationale": "The aorta carries oxygenated blood from the left ventricle to the systemic circulation."
    },
    {
      "id": "UKN-Y2-014",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Anatomy and physiology",
      "question": "Which part of the brain is strongly associated with balance and coordination?",
      "options": {
        "A": "Cerebellum",
        "B": "Hypothalamus",
        "C": "Medulla",
        "D": "Pituitary"
      },
      "correct_answer": "A",
      "rationale": "The cerebellum coordinates balance, posture and fine motor control."
    },
    {
      "id": "UKN-Y2-015",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Anatomy and physiology",
      "question": "What is the main function of the large intestine?",
      "options": {
        "A": "Protein digestion",
        "B": "Water absorption",
        "C": "Bile production",
        "D": "Insulin secretion"
      },
      "correct_answer": "B",
      "rationale": "The large intestine absorbs water and electrolytes and forms faeces."
    },
    {
      "id": "UKN-Y2-016",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Anatomy and physiology",
      "question": "Which cells produce antibodies?",
      "options": {
        "A": "Red cells",
        "B": "Plasma cells",
        "C": "Platelets",
        "D": "Neutrophils"
      },
      "correct_answer": "B",
      "rationale": "Plasma cells are differentiated B lymphocytes that produce antibodies."
    },
    {
      "id": "UKN-Y2-017",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Anatomy and physiology",
      "question": "Which muscle is the primary muscle of inspiration?",
      "options": {
        "A": "Intercostal muscle",
        "B": "Diaphragm",
        "C": "Trapezius",
        "D": "Pectoralis major"
      },
      "correct_answer": "B",
      "rationale": "The diaphragm contracts and flattens, increasing thoracic volume during inspiration."
    },
    {
      "id": "UKN-Y2-018",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Anatomy and physiology",
      "question": "Which organ is the main site of insulin production?",
      "options": {
        "A": "Liver",
        "B": "Pancreas",
        "C": "Kidney",
        "D": "Adrenal gland"
      },
      "correct_answer": "B",
      "rationale": "Beta cells in the pancreatic islets produce insulin."
    },
    {
      "id": "UKN-Y2-019",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Anatomy and physiology",
      "question": "What is the main role of haemoglobin?",
      "options": {
        "A": "Clot formation",
        "B": "Oxygen carriage",
        "C": "Hormone production",
        "D": "Bile storage"
      },
      "correct_answer": "B",
      "rationale": "Haemoglobin binds oxygen in red blood cells and transports it to tissues."
    },
    {
      "id": "UKN-Y2-020",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Anatomy and physiology",
      "question": "Which nervous system division supports \u201cfight or flight\u201d responses?",
      "options": {
        "A": "Parasympathetic",
        "B": "Sympathetic",
        "C": "Somatic sensory",
        "D": "Enteric only"
      },
      "correct_answer": "B",
      "rationale": "The sympathetic nervous system increases heart rate, bronchodilation and glucose availability during stress."
    },
    {
      "id": "UKN-Y2-021",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Clinical observations and deterioration",
      "question": "A respiratory rate of 30/min in an adult should be interpreted as:",
      "options": {
        "A": "Normal at rest",
        "B": "A sign of possible deterioration",
        "C": "Expected during sleep",
        "D": "Only relevant if temperature is high"
      },
      "correct_answer": "B",
      "rationale": "Marked tachypnoea is an early sign of physiological deterioration and requires prompt assessment and escalation."
    },
    {
      "id": "UKN-Y2-022",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Clinical observations and deterioration",
      "question": "A patient is newly confused with cool, mottled skin. What is the priority?",
      "options": {
        "A": "Offer tea",
        "B": "Escalate urgently",
        "C": "Wait for routine ward round",
        "D": "Document only"
      },
      "correct_answer": "B",
      "rationale": "New confusion and poor perfusion may indicate serious illness such as sepsis or shock and require urgent escalation."
    },
    {
      "id": "UKN-Y2-023",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Clinical observations and deterioration",
      "question": "Which tool is commonly used in UK hospitals to identify acute deterioration in adults?",
      "options": {
        "A": "MUST",
        "B": "NEWS2",
        "C": "Waterlow",
        "D": "GAD-7"
      },
      "correct_answer": "B",
      "rationale": "NEWS2 combines physiological observations to support recognition and escalation of acute deterioration."
    },
    {
      "id": "UKN-Y2-024",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Clinical observations and deterioration",
      "question": "What does AVPU assess?",
      "options": {
        "A": "Pain severity",
        "B": "Conscious level",
        "C": "Nutritional risk",
        "D": "Moving and handling risk"
      },
      "correct_answer": "B",
      "rationale": "AVPU assesses whether a patient is Alert, responds to Voice, responds to Pain, or is Unresponsive."
    },
    {
      "id": "UKN-Y2-025",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Clinical observations and deterioration",
      "question": "A falling oxygen saturation should first prompt the nurse to:",
      "options": {
        "A": "Ignore if the patient is talking",
        "B": "Assess airway, breathing and equipment, then escalate as needed",
        "C": "Remove all oxygen permanently",
        "D": "Give oral fluids"
      },
      "correct_answer": "B",
      "rationale": "The nurse should rapidly assess the patient and oxygen delivery system, intervene within competence and escalate if abnormal."
    },
    {
      "id": "UKN-Y2-026",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Clinical observations and deterioration",
      "question": "Which observation is most concerning in an acutely ill adult?",
      "options": {
        "A": "RR 16/min",
        "B": "HR 72/min",
        "C": "Systolic BP 82 mmHg",
        "D": "Temperature 36.8\u00b0C"
      },
      "correct_answer": "C",
      "rationale": "Systolic hypotension can indicate shock or severe deterioration and needs urgent assessment."
    },
    {
      "id": "UKN-Y2-027",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Clinical observations and deterioration",
      "question": "A patient has chest pain, sweating and nausea. The priority action is to:",
      "options": {
        "A": "Reassure and reassess tomorrow",
        "B": "Initiate local chest pain/emergency protocol",
        "C": "Offer a large meal",
        "D": "Encourage walking"
      },
      "correct_answer": "B",
      "rationale": "Symptoms may indicate acute coronary syndrome, requiring urgent assessment, ECG and escalation."
    },
    {
      "id": "UKN-Y2-028",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Clinical observations and deterioration",
      "question": "Which finding suggests increased work of breathing?",
      "options": {
        "A": "Speaking full sentences comfortably",
        "B": "Use of accessory muscles",
        "C": "Warm hands",
        "D": "Normal skin colour"
      },
      "correct_answer": "B",
      "rationale": "Accessory muscle use suggests respiratory distress and increased effort to breathe."
    },
    {
      "id": "UKN-Y2-029",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Clinical observations and deterioration",
      "question": "A NEWS2 score has increased since the last set of observations. The nurse should:",
      "options": {
        "A": "Assume equipment error only",
        "B": "Follow escalation policy and reassess",
        "C": "Reduce observation frequency",
        "D": "Discharge the patient"
      },
      "correct_answer": "B",
      "rationale": "A rising score suggests deterioration and should trigger escalation according to local policy."
    },
    {
      "id": "UKN-Y2-030",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Clinical observations and deterioration",
      "question": "Which is an early sign of clinical deterioration in many patients?",
      "options": {
        "A": "Reduced respiratory rate only",
        "B": "Change in respiratory rate",
        "C": "Improved appetite",
        "D": "Increased mobility"
      },
      "correct_answer": "B",
      "rationale": "Respiratory rate often changes early in acute illness and is a sensitive observation."
    },
    {
      "id": "UKN-Y2-031",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Clinical observations and deterioration",
      "question": "A patient is unresponsive. What is the first priority?",
      "options": {
        "A": "Complete food chart",
        "B": "Assess airway and call for urgent help",
        "C": "Take a full social history",
        "D": "Delay until relatives arrive"
      },
      "correct_answer": "B",
      "rationale": "Airway and urgent assistance are immediate priorities for an unresponsive patient."
    },
    {
      "id": "UKN-Y2-032",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Clinical observations and deterioration",
      "question": "Capillary refill time is mainly used to assess:",
      "options": {
        "A": "Nutrition",
        "B": "Peripheral perfusion",
        "C": "Hearing",
        "D": "Visual acuity"
      },
      "correct_answer": "B",
      "rationale": "Prolonged capillary refill may indicate poor peripheral perfusion."
    },
    {
      "id": "UKN-Y2-033",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Clinical observations and deterioration",
      "question": "Which temperature is pyrexial in most adult clinical contexts?",
      "options": {
        "A": "35.5\u00b0C",
        "B": "36.6\u00b0C",
        "C": "38.3\u00b0C",
        "D": "37.0\u00b0C"
      },
      "correct_answer": "C",
      "rationale": "A temperature above 38\u00b0C is generally considered fever and may indicate infection or inflammation."
    },
    {
      "id": "UKN-Y2-034",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Clinical observations and deterioration",
      "question": "A patient with oxygen prescribed target 88\u201392% has SpO2 91%. This is:",
      "options": {
        "A": "Within target range",
        "B": "Always dangerously low",
        "C": "An indication to stop monitoring",
        "D": "A documentation error"
      },
      "correct_answer": "A",
      "rationale": "For patients prescribed 88\u201392%, 91% is within the intended target range."
    },
    {
      "id": "UKN-Y2-035",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Clinical observations and deterioration",
      "question": "Why is trend in observations important?",
      "options": {
        "A": "Single readings are never useful",
        "B": "Deterioration may be shown by gradual change",
        "C": "It replaces clinical judgement",
        "D": "It is only for research"
      },
      "correct_answer": "B",
      "rationale": "Trends reveal improvement or deterioration and support timely escalation."
    },
    {
      "id": "UKN-Y2-036",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Clinical observations and deterioration",
      "question": "Which action supports safe escalation?",
      "options": {
        "A": "Using SBAR to communicate concern",
        "B": "Waiting until end of shift",
        "C": "Avoiding documentation",
        "D": "Only telling another student"
      },
      "correct_answer": "A",
      "rationale": "SBAR structures key information and helps communicate clinical concern clearly."
    },
    {
      "id": "UKN-Y2-037",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Clinical observations and deterioration",
      "question": "A patient has RR 8/min after opioid analgesia. This may indicate:",
      "options": {
        "A": "Respiratory depression",
        "B": "Improved fitness",
        "C": "Hyperventilation",
        "D": "Normal response to pain"
      },
      "correct_answer": "A",
      "rationale": "Opioids can depress respiratory drive; bradypnoea after opioids requires urgent assessment."
    },
    {
      "id": "UKN-Y2-038",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Clinical observations and deterioration",
      "question": "Which is the best immediate response to severe breathlessness?",
      "options": {
        "A": "Leave patient flat",
        "B": "Sit patient upright if tolerated and assess ABCDE",
        "C": "Give a sleeping tablet",
        "D": "Delay observations"
      },
      "correct_answer": "B",
      "rationale": "Upright positioning may aid ventilation while ABCDE assessment identifies life-threatening problems."
    },
    {
      "id": "UKN-Y2-039",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Clinical observations and deterioration",
      "question": "What does \u201cE\u201d in ABCDE assessment include?",
      "options": {
        "A": "Exposure and environment",
        "B": "Electrolytes only",
        "C": "Eating pattern",
        "D": "Exercise plan"
      },
      "correct_answer": "A",
      "rationale": "Exposure involves looking for rashes, bleeding, wounds, temperature issues and maintaining dignity/warmth."
    },
    {
      "id": "UKN-Y2-040",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Clinical observations and deterioration",
      "question": "Which finding requires urgent escalation?",
      "options": {
        "A": "New facial droop and arm weakness",
        "B": "Stable chronic knee pain",
        "C": "Mild thirst before lunch",
        "D": "Patient requests a blanket"
      },
      "correct_answer": "A",
      "rationale": "New focal neurological signs may indicate stroke and require immediate stroke pathway activation."
    },
    {
      "id": "UKN-Y2-041",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Medicines management and pharmacology",
      "question": "Before administering a medicine, what must the nurse check?",
      "options": {
        "A": "Only the tablet colour",
        "B": "Patient identity, prescription, allergies, dose, route and time",
        "C": "The patient\u2019s favourite drink",
        "D": "The ward stock level only"
      },
      "correct_answer": "B",
      "rationale": "Safe administration requires confirmation of the right patient, medicine, dose, route, time and allergy status."
    },
    {
      "id": "UKN-Y2-042",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Medicines management and pharmacology",
      "question": "Which blood test is used to monitor warfarin effect?",
      "options": {
        "A": "HbA1c",
        "B": "INR",
        "C": "CRP",
        "D": "Troponin"
      },
      "correct_answer": "B",
      "rationale": "INR assesses anticoagulation intensity for patients taking warfarin."
    },
    {
      "id": "UKN-Y2-043",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Medicines management and pharmacology",
      "question": "A patient reports penicillin anaphylaxis. The nurse should:",
      "options": {
        "A": "Administer penicillin slowly",
        "B": "Check and document allergy and withhold penicillin pending review",
        "C": "Ignore if reaction was years ago",
        "D": "Ask another patient"
      },
      "correct_answer": "B",
      "rationale": "A history of anaphylaxis is a serious allergy; administration must be withheld and escalated."
    },
    {
      "id": "UKN-Y2-044",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Medicines management and pharmacology",
      "question": "Which medicine class increases bleeding risk?",
      "options": {
        "A": "Anticoagulants",
        "B": "Antacids",
        "C": "Emollients",
        "D": "Laxatives"
      },
      "correct_answer": "A",
      "rationale": "Anticoagulants reduce clotting and increase bleeding risk."
    },
    {
      "id": "UKN-Y2-045",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Medicines management and pharmacology",
      "question": "What is the safest action if a prescribed dose seems unusually high?",
      "options": {
        "A": "Give it to avoid delay",
        "B": "Check relevant guidance and escalate before administration",
        "C": "Ask the patient to decide",
        "D": "Hide the error"
      },
      "correct_answer": "B",
      "rationale": "A suspected unsafe dose must be clarified before administration to prevent harm."
    },
    {
      "id": "UKN-Y2-046",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Medicines management and pharmacology",
      "question": "Which route gives medicine directly into a vein?",
      "options": {
        "A": "Oral",
        "B": "Intravenous",
        "C": "Subcutaneous",
        "D": "Topical"
      },
      "correct_answer": "B",
      "rationale": "Intravenous administration delivers medication directly into the bloodstream."
    },
    {
      "id": "UKN-Y2-047",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Medicines management and pharmacology",
      "question": "Which medication can cause respiratory depression?",
      "options": {
        "A": "Morphine",
        "B": "Paracetamol at normal dose",
        "C": "Lactulose",
        "D": "Simple saline spray"
      },
      "correct_answer": "A",
      "rationale": "Opioids such as morphine can depress respiratory drive, especially at high doses or in vulnerable patients."
    },
    {
      "id": "UKN-Y2-048",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Medicines management and pharmacology",
      "question": "Why should renal function matter before some medicines?",
      "options": {
        "A": "Kidneys affect drug clearance",
        "B": "It only affects appetite",
        "C": "It changes hair colour",
        "D": "It is never relevant"
      },
      "correct_answer": "A",
      "rationale": "Reduced renal function can impair excretion and increase toxicity risk for renally cleared medicines."
    },
    {
      "id": "UKN-Y2-049",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Medicines management and pharmacology",
      "question": "Which is an example of a medication error?",
      "options": {
        "A": "Documenting administration correctly",
        "B": "Giving the wrong dose",
        "C": "Checking allergies",
        "D": "Using two identifiers"
      },
      "correct_answer": "B",
      "rationale": "Wrong dose administration is a medication error and should be managed according to policy."
    },
    {
      "id": "UKN-Y2-050",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Medicines management and pharmacology",
      "question": "What should the nurse do after a medication error that reaches a patient?",
      "options": {
        "A": "Conceal it",
        "B": "Assess patient, escalate, document and report according to policy",
        "C": "Blame the patient",
        "D": "Ignore if no immediate harm"
      },
      "correct_answer": "B",
      "rationale": "Patient assessment, escalation, transparent documentation and incident reporting support safety and learning."
    },
    {
      "id": "UKN-Y2-051",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Medicines management and pharmacology",
      "question": "Which medicine is commonly used for severe hypoglycaemia when the patient cannot swallow?",
      "options": {
        "A": "Glucagon",
        "B": "Aspirin",
        "C": "Furosemide",
        "D": "Omeprazole"
      },
      "correct_answer": "A",
      "rationale": "Glucagon may be used when oral glucose is unsafe, according to local protocol."
    },
    {
      "id": "UKN-Y2-052",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Medicines management and pharmacology",
      "question": "Which adverse effect is associated with furosemide?",
      "options": {
        "A": "Fluid retention only",
        "B": "Hypokalaemia and dehydration",
        "C": "Severe constipation only",
        "D": "Hyperglycaemia in all patients"
      },
      "correct_answer": "B",
      "rationale": "Loop diuretics can cause fluid and electrolyte loss, including low potassium."
    },
    {
      "id": "UKN-Y2-053",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Medicines management and pharmacology",
      "question": "Which medication should usually be taken with attention to blood pressure monitoring?",
      "options": {
        "A": "Antihypertensives",
        "B": "Simple emollient",
        "C": "Artificial tears",
        "D": "Saline nasal drops"
      },
      "correct_answer": "A",
      "rationale": "Antihypertensives can lower blood pressure and may contribute to hypotension."
    },
    {
      "id": "UKN-Y2-054",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Medicines management and pharmacology",
      "question": "Why is medicines reconciliation important on admission?",
      "options": {
        "A": "To increase paperwork",
        "B": "To identify and resolve discrepancies in medicines",
        "C": "To stop all medicines permanently",
        "D": "To replace clinical judgement"
      },
      "correct_answer": "B",
      "rationale": "Reconciliation helps ensure accurate medication history and reduces unintended omissions or duplications."
    },
    {
      "id": "UKN-Y2-055",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Medicines management and pharmacology",
      "question": "A patient cannot swallow tablets safely. The nurse should:",
      "options": {
        "A": "Crush all tablets automatically",
        "B": "Seek pharmacist/prescriber advice before altering formulation",
        "C": "Hide tablets in food without consent",
        "D": "Withhold forever without telling anyone"
      },
      "correct_answer": "B",
      "rationale": "Some tablets must not be crushed; alternatives require professional advice and prescription review."
    },
    {
      "id": "UKN-Y2-056",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Medicines management and pharmacology",
      "question": "Which analgesic is an opioid?",
      "options": {
        "A": "Morphine",
        "B": "Ibuprofen",
        "C": "Paracetamol",
        "D": "Lidocaine patch only"
      },
      "correct_answer": "A",
      "rationale": "Morphine is an opioid analgesic used for moderate to severe pain."
    },
    {
      "id": "UKN-Y2-057",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Medicines management and pharmacology",
      "question": "Which medicine is commonly associated with gastric irritation and bleeding risk?",
      "options": {
        "A": "NSAIDs",
        "B": "Simple saline",
        "C": "Emollients",
        "D": "Lactulose"
      },
      "correct_answer": "A",
      "rationale": "NSAIDs can irritate the gastric mucosa and increase gastrointestinal bleeding risk."
    },
    {
      "id": "UKN-Y2-058",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Medicines management and pharmacology",
      "question": "What should be checked before administering insulin?",
      "options": {
        "A": "Blood glucose and prescription details",
        "B": "Eye colour",
        "C": "Shoe size",
        "D": "Meal preference only"
      },
      "correct_answer": "A",
      "rationale": "Insulin administration requires checking blood glucose, insulin type, dose, timing and food intake context."
    },
    {
      "id": "UKN-Y2-059",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Medicines management and pharmacology",
      "question": "Why should nurses avoid using unclear abbreviations in medicine documentation?",
      "options": {
        "A": "They save no time",
        "B": "They can be misread and cause medication errors",
        "C": "They are legally required in all notes",
        "D": "They improve clarity"
      },
      "correct_answer": "B",
      "rationale": "Unsafe abbreviations can be misinterpreted, leading to wrong medicine, dose or route."
    },
    {
      "id": "UKN-Y2-060",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Medicines management and pharmacology",
      "question": "A controlled drug administration normally requires:",
      "options": {
        "A": "No documentation",
        "B": "Local controlled drug procedures and accurate records",
        "C": "Patient self-selection from cupboard",
        "D": "Only verbal memory"
      },
      "correct_answer": "B",
      "rationale": "Controlled drugs require strict storage, checking and record-keeping according to law and local policy."
    },
    {
      "id": "UKN-Y2-061",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Infection prevention and control",
      "question": "The most important routine measure to reduce healthcare-associated infection is:",
      "options": {
        "A": "Hand hygiene",
        "B": "Wearing gloves continuously",
        "C": "Opening windows only",
        "D": "Avoiding all patient contact"
      },
      "correct_answer": "A",
      "rationale": "Effective hand hygiene interrupts transmission of microorganisms between patients, staff and environments."
    },
    {
      "id": "UKN-Y2-062",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Infection prevention and control",
      "question": "When should gloves be worn?",
      "options": {
        "A": "For every interaction regardless of risk",
        "B": "When contact with blood, body fluids, mucous membranes or contaminated items is anticipated",
        "C": "Only when the patient asks",
        "D": "Instead of hand hygiene"
      },
      "correct_answer": "B",
      "rationale": "Gloves are indicated for exposure risk but do not replace hand hygiene."
    },
    {
      "id": "UKN-Y2-063",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Infection prevention and control",
      "question": "What is aseptic non-touch technique designed to protect?",
      "options": {
        "A": "Key parts and key sites from contamination",
        "B": "Staff footwear",
        "C": "Meal ordering",
        "D": "Shift allocation"
      },
      "correct_answer": "A",
      "rationale": "ANTT prevents contamination of sterile equipment parts and vulnerable patient sites."
    },
    {
      "id": "UKN-Y2-064",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Infection prevention and control",
      "question": "A patient has diarrhoea and vomiting. The nurse should consider:",
      "options": {
        "A": "Infection control precautions and isolation according to policy",
        "B": "Moving them to the dining room",
        "C": "Ignoring stool frequency",
        "D": "Stopping hand hygiene"
      },
      "correct_answer": "A",
      "rationale": "Gastrointestinal symptoms may be infectious and require prompt IPC measures."
    },
    {
      "id": "UKN-Y2-065",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Infection prevention and control",
      "question": "Which waste usually requires sharps disposal?",
      "options": {
        "A": "Used needle",
        "B": "Paper towel",
        "C": "Empty water cup",
        "D": "Clean packaging"
      },
      "correct_answer": "A",
      "rationale": "Needles and similar items must be disposed of immediately in approved sharps containers."
    },
    {
      "id": "UKN-Y2-066",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Infection prevention and control",
      "question": "What should be done after removing gloves?",
      "options": {
        "A": "Hand hygiene",
        "B": "Touch clean equipment first",
        "C": "Store gloves for reuse",
        "D": "Skip documentation"
      },
      "correct_answer": "A",
      "rationale": "Hands can become contaminated during glove removal; hand hygiene is required."
    },
    {
      "id": "UKN-Y2-067",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Infection prevention and control",
      "question": "Which is a standard precaution?",
      "options": {
        "A": "Hand hygiene",
        "B": "Only isolating known infections",
        "C": "Never cleaning equipment",
        "D": "Using antibiotics for all fevers"
      },
      "correct_answer": "A",
      "rationale": "Standard precautions apply to all patients to reduce infection risk."
    },
    {
      "id": "UKN-Y2-068",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Infection prevention and control",
      "question": "A cannula site is red, painful and swollen. This may indicate:",
      "options": {
        "A": "Phlebitis or infection",
        "B": "Normal healing always",
        "C": "Improved circulation",
        "D": "Correct placement only"
      },
      "correct_answer": "A",
      "rationale": "Inflammation at a cannula site may indicate phlebitis or infection and requires assessment/escalation."
    },
    {
      "id": "UKN-Y2-069",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Infection prevention and control",
      "question": "Why should clinical equipment be cleaned between patients?",
      "options": {
        "A": "To reduce cross-contamination",
        "B": "To improve decoration",
        "C": "To reduce noise",
        "D": "To save storage space"
      },
      "correct_answer": "A",
      "rationale": "Shared equipment can transmit organisms unless cleaned appropriately."
    },
    {
      "id": "UKN-Y2-070",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Infection prevention and control",
      "question": "Which patients are most vulnerable to infection?",
      "options": {
        "A": "Immunosuppressed patients",
        "B": "Patients with perfect immunity only",
        "C": "Patients with no wounds ever",
        "D": "Only visitors"
      },
      "correct_answer": "A",
      "rationale": "Immunosuppression reduces host defences and increases infection risk."
    },
    {
      "id": "UKN-Y2-071",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Infection prevention and control",
      "question": "What is the best action if PPE is visibly contaminated?",
      "options": {
        "A": "Continue using it all shift",
        "B": "Remove safely and replace according to policy",
        "C": "Share with colleague",
        "D": "Wash disposable PPE for reuse"
      },
      "correct_answer": "B",
      "rationale": "Contaminated PPE can spread organisms and should be changed safely."
    },
    {
      "id": "UKN-Y2-072",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Infection prevention and control",
      "question": "Which condition requires careful antimicrobial stewardship?",
      "options": {
        "A": "Suspected bacterial infection",
        "B": "Hair washing",
        "C": "Routine tooth brushing",
        "D": "Making a bed"
      },
      "correct_answer": "A",
      "rationale": "Antibiotics should be used appropriately to treat likely bacterial infection while reducing resistance risk."
    },
    {
      "id": "UKN-Y2-073",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Infection prevention and control",
      "question": "What does \u201csource isolation\u201d aim to do?",
      "options": {
        "A": "Prevent pathogens spreading from an infected/colonised patient",
        "B": "Increase ward noise",
        "C": "Improve nutrition only",
        "D": "Replace diagnosis"
      },
      "correct_answer": "A",
      "rationale": "Source isolation reduces transmission from a patient who may spread infection."
    },
    {
      "id": "UKN-Y2-074",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Infection prevention and control",
      "question": "Which is the correct approach to hand hygiene?",
      "options": {
        "A": "Use appropriate technique at key moments",
        "B": "Only wash at start of shift",
        "C": "Only clean palms",
        "D": "Use gloves instead"
      },
      "correct_answer": "A",
      "rationale": "Hand hygiene must be performed at appropriate moments using correct technique."
    },
    {
      "id": "UKN-Y2-075",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Infection prevention and control",
      "question": "Why is vaccination relevant to healthcare workers?",
      "options": {
        "A": "It can reduce risk of preventable infection transmission",
        "B": "It replaces PPE",
        "C": "It treats all bacterial infections",
        "D": "It removes need for training"
      },
      "correct_answer": "A",
      "rationale": "Vaccination protects staff and patients by reducing risk of vaccine-preventable disease."
    },
    {
      "id": "UKN-Y2-076",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Infection prevention and control",
      "question": "A wound dressing change should be performed using:",
      "options": {
        "A": "Technique appropriate to wound and local policy, maintaining asepsis",
        "B": "Bare hands to feel the wound",
        "C": "Non-sterile kitchen towel",
        "D": "No hand hygiene"
      },
      "correct_answer": "A",
      "rationale": "Aseptic technique reduces contamination during wound care."
    },
    {
      "id": "UKN-Y2-077",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Infection prevention and control",
      "question": "Which sign may suggest wound infection?",
      "options": {
        "A": "Increasing redness, pain, swelling or purulent discharge",
        "B": "Stable clean dry wound",
        "C": "Improved mobility only",
        "D": "Normal appetite only"
      },
      "correct_answer": "A",
      "rationale": "Local inflammatory signs and pus can indicate wound infection."
    },
    {
      "id": "UKN-Y2-078",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Infection prevention and control",
      "question": "Why are invasive devices infection risks?",
      "options": {
        "A": "They can provide a route for organisms into the body",
        "B": "They sterilise blood",
        "C": "They prevent all bacteria",
        "D": "They remove skin flora"
      },
      "correct_answer": "A",
      "rationale": "Cannulas, catheters and drains bypass natural barriers and can introduce microorganisms."
    },
    {
      "id": "UKN-Y2-079",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Infection prevention and control",
      "question": "A catheter bag should generally be kept:",
      "options": {
        "A": "Below bladder level without touching the floor",
        "B": "Above the patient\u2019s head",
        "C": "On the bed beside wound dressings",
        "D": "Disconnected routinely"
      },
      "correct_answer": "A",
      "rationale": "Keeping the bag below bladder level supports drainage and reduces backflow risk."
    },
    {
      "id": "UKN-Y2-080",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Infection prevention and control",
      "question": "Which action reduces catheter-associated infection risk?",
      "options": {
        "A": "Reviewing ongoing need and removing promptly when no longer required",
        "B": "Leaving indefinitely",
        "C": "Breaking the closed system frequently",
        "D": "Ignoring perineal hygiene"
      },
      "correct_answer": "A",
      "rationale": "Minimising catheter duration and maintaining a closed system reduce infection risk."
    },
    {
      "id": "UKN-Y2-081",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Diabetes and endocrine nursing",
      "question": "A patient with sweating, tremor and confusion may be experiencing:",
      "options": {
        "A": "Hypoglycaemia",
        "B": "Hypercalcaemia",
        "C": "Fluid overload",
        "D": "Stroke recovery"
      },
      "correct_answer": "A",
      "rationale": "These are typical adrenergic/neuroglycopenic symptoms of low blood glucose."
    },
    {
      "id": "UKN-Y2-082",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Diabetes and endocrine nursing",
      "question": "Which test reflects average blood glucose over roughly 2\u20133 months?",
      "options": {
        "A": "HbA1c",
        "B": "INR",
        "C": "Urea",
        "D": "D-dimer"
      },
      "correct_answer": "A",
      "rationale": "HbA1c reflects glycaemic control over the lifespan of red blood cells."
    },
    {
      "id": "UKN-Y2-083",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Diabetes and endocrine nursing",
      "question": "Before giving rapid-acting insulin, the nurse should particularly check:",
      "options": {
        "A": "Meal timing and blood glucose",
        "B": "Hearing aid battery",
        "C": "Skin colour only",
        "D": "Water temperature"
      },
      "correct_answer": "A",
      "rationale": "Rapid insulin can cause hypoglycaemia if not matched to glucose and food intake."
    },
    {
      "id": "UKN-Y2-084",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Diabetes and endocrine nursing",
      "question": "Which condition is a serious acute complication of type 1 diabetes?",
      "options": {
        "A": "Diabetic ketoacidosis",
        "B": "Otitis externa",
        "C": "Cataract only",
        "D": "Tension headache"
      },
      "correct_answer": "A",
      "rationale": "DKA is caused by insulin deficiency and can be life-threatening."
    },
    {
      "id": "UKN-Y2-085",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Diabetes and endocrine nursing",
      "question": "A conscious patient with mild hypoglycaemia who can swallow usually needs:",
      "options": {
        "A": "Fast-acting carbohydrate per protocol",
        "B": "Immediate walking exercise",
        "C": "Insulin bolus",
        "D": "Fluid restriction"
      },
      "correct_answer": "A",
      "rationale": "Fast-acting carbohydrate raises blood glucose promptly when oral intake is safe."
    },
    {
      "id": "UKN-Y2-086",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Diabetes and endocrine nursing",
      "question": "Polyuria and polydipsia are common signs of:",
      "options": {
        "A": "Hyperglycaemia",
        "B": "Hypothermia",
        "C": "Hyponatraemia only",
        "D": "Bradycardia"
      },
      "correct_answer": "A",
      "rationale": "High glucose causes osmotic diuresis, leading to thirst and frequent urination."
    },
    {
      "id": "UKN-Y2-087",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Diabetes and endocrine nursing",
      "question": "Foot assessment in diabetes is important because of risk of:",
      "options": {
        "A": "Neuropathy and ulceration",
        "B": "Improved sensation",
        "C": "Instant fracture only",
        "D": "Reduced infection risk"
      },
      "correct_answer": "A",
      "rationale": "Diabetes can cause neuropathy and vascular disease, increasing ulcer risk."
    },
    {
      "id": "UKN-Y2-088",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Diabetes and endocrine nursing",
      "question": "Which hormone raises blood glucose?",
      "options": {
        "A": "Glucagon",
        "B": "Insulin",
        "C": "Oxytocin",
        "D": "Calcitonin"
      },
      "correct_answer": "A",
      "rationale": "Glucagon promotes glycogen breakdown and glucose release."
    },
    {
      "id": "UKN-Y2-089",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Diabetes and endocrine nursing",
      "question": "Sick-day guidance for diabetes is important because illness can:",
      "options": {
        "A": "Destabilise glucose and increase dehydration/ketone risk",
        "B": "Always cure diabetes",
        "C": "Make monitoring unnecessary",
        "D": "Stop need for fluids"
      },
      "correct_answer": "A",
      "rationale": "Acute illness can increase glucose variability and precipitate complications."
    },
    {
      "id": "UKN-Y2-090",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Diabetes and endocrine nursing",
      "question": "A diabetic patient with fruity breath, vomiting and deep breathing needs assessment for:",
      "options": {
        "A": "Ketoacidosis",
        "B": "Simple indigestion only",
        "C": "Low cholesterol",
        "D": "Anaemia only"
      },
      "correct_answer": "A",
      "rationale": "Kussmaul breathing, vomiting and ketotic breath are concerning for DKA."
    },
    {
      "id": "UKN-Y2-091",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Respiratory nursing",
      "question": "Which sign suggests acute respiratory distress?",
      "options": {
        "A": "Unable to complete sentences",
        "B": "Comfortable conversation",
        "C": "Pink warm skin only",
        "D": "Normal walking pace"
      },
      "correct_answer": "A",
      "rationale": "Inability to speak in full sentences indicates significant breathlessness."
    },
    {
      "id": "UKN-Y2-092",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Respiratory nursing",
      "question": "In COPD with risk of hypercapnic respiratory failure, oxygen should be:",
      "options": {
        "A": "Titrated to prescribed target range",
        "B": "Given at maximum flow without review",
        "C": "Withheld from all patients",
        "D": "Used only for anxiety"
      },
      "correct_answer": "A",
      "rationale": "Controlled oxygen reduces hypoxaemia while limiting risk of worsening CO2 retention."
    },
    {
      "id": "UKN-Y2-093",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Respiratory nursing",
      "question": "Wheeze is most associated with:",
      "options": {
        "A": "Narrowed airways",
        "B": "Pleural effusion only",
        "C": "Fractured rib only",
        "D": "Renal failure"
      },
      "correct_answer": "A",
      "rationale": "Wheeze occurs when air flows through narrowed lower airways."
    },
    {
      "id": "UKN-Y2-094",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Respiratory nursing",
      "question": "Crackles on auscultation may indicate:",
      "options": {
        "A": "Fluid or secretions in airways/alveoli",
        "B": "Normal silence",
        "C": "Improved ventilation only",
        "D": "Low glucose"
      },
      "correct_answer": "A",
      "rationale": "Crackles can occur with pulmonary oedema, pneumonia or secretions."
    },
    {
      "id": "UKN-Y2-095",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Respiratory nursing",
      "question": "A peak flow meter is commonly used to monitor:",
      "options": {
        "A": "Airflow limitation in asthma",
        "B": "Urine output",
        "C": "Blood pressure",
        "D": "Pain score"
      },
      "correct_answer": "A",
      "rationale": "Peak expiratory flow helps assess airway obstruction and response to treatment."
    },
    {
      "id": "UKN-Y2-096",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Respiratory nursing",
      "question": "Pleuritic chest pain is typically:",
      "options": {
        "A": "Worse on inspiration or coughing",
        "B": "Only felt in the foot",
        "C": "Relieved by breathing deeply always",
        "D": "A urinary symptom"
      },
      "correct_answer": "A",
      "rationale": "Inflammation of pleura causes sharp pain worsened by respiratory movement."
    },
    {
      "id": "UKN-Y2-097",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Respiratory nursing",
      "question": "Which sputum change may suggest infection?",
      "options": {
        "A": "Purulent green/yellow sputum with systemic symptoms",
        "B": "Clear scant sputum always",
        "C": "No cough ever",
        "D": "Improved appetite only"
      },
      "correct_answer": "A",
      "rationale": "Purulent sputum with fever or deterioration can suggest respiratory infection."
    },
    {
      "id": "UKN-Y2-098",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Respiratory nursing",
      "question": "A patient using accessory muscles is showing:",
      "options": {
        "A": "Increased work of breathing",
        "B": "Normal sleep pattern",
        "C": "Improved lung capacity",
        "D": "Reduced anxiety only"
      },
      "correct_answer": "A",
      "rationale": "Accessory muscle use is a sign of respiratory effort."
    },
    {
      "id": "UKN-Y2-099",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Respiratory nursing",
      "question": "Which position often helps dyspnoea?",
      "options": {
        "A": "Upright supported sitting",
        "B": "Flat supine if not tolerated",
        "C": "Head lower than feet",
        "D": "Prone without assessment"
      },
      "correct_answer": "A",
      "rationale": "Sitting upright can improve chest expansion and reduce work of breathing."
    },
    {
      "id": "UKN-Y2-100",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Respiratory nursing",
      "question": "Cyanosis may indicate:",
      "options": {
        "A": "Poor oxygenation",
        "B": "Good perfusion always",
        "C": "High haemoglobin only",
        "D": "Normal finding"
      },
      "correct_answer": "A",
      "rationale": "Bluish discolouration can reflect reduced oxygen saturation or poor perfusion."
    },
    {
      "id": "UKN-Y2-101",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Cardiovascular nursing",
      "question": "Central crushing chest pain radiating to the arm may suggest:",
      "options": {
        "A": "Myocardial infarction",
        "B": "Urinary infection",
        "C": "Constipation only",
        "D": "Otitis media"
      },
      "correct_answer": "A",
      "rationale": "This is a classic presentation of acute coronary syndrome."
    },
    {
      "id": "UKN-Y2-102",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Cardiovascular nursing",
      "question": "Peripheral oedema can occur in:",
      "options": {
        "A": "Heart failure",
        "B": "Improved circulation only",
        "C": "Hypoglycaemia",
        "D": "Migraine"
      },
      "correct_answer": "A",
      "rationale": "Fluid retention and venous congestion can cause ankle or leg swelling."
    },
    {
      "id": "UKN-Y2-103",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Cardiovascular nursing",
      "question": "Which pulse finding requires escalation if new and symptomatic?",
      "options": {
        "A": "Irregular rapid pulse",
        "B": "Regular 72 bpm",
        "C": "Strong equal pulses",
        "D": "Pulse 68 after rest"
      },
      "correct_answer": "A",
      "rationale": "A new rapid irregular pulse may indicate arrhythmia such as atrial fibrillation."
    },
    {
      "id": "UKN-Y2-104",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Cardiovascular nursing",
      "question": "Orthostatic hypotension is assessed by:",
      "options": {
        "A": "Comparing lying/standing blood pressure",
        "B": "Measuring temperature only",
        "C": "Testing urine glucose",
        "D": "Checking hearing"
      },
      "correct_answer": "A",
      "rationale": "Postural BP changes help identify BP drops after standing."
    },
    {
      "id": "UKN-Y2-105",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Cardiovascular nursing",
      "question": "Which symptom is common in left-sided heart failure?",
      "options": {
        "A": "Breathlessness",
        "B": "Improved sleep flat",
        "C": "Excessive appetite only",
        "D": "Ear pain"
      },
      "correct_answer": "A",
      "rationale": "Pulmonary congestion from left heart failure causes dyspnoea."
    },
    {
      "id": "UKN-Y2-106",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Cardiovascular nursing",
      "question": "A very low blood pressure with cool peripheries may indicate:",
      "options": {
        "A": "Shock",
        "B": "Wellness",
        "C": "Hypertension",
        "D": "Hyperthyroidism only"
      },
      "correct_answer": "A",
      "rationale": "Hypotension and poor perfusion are signs of circulatory failure."
    },
    {
      "id": "UKN-Y2-107",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Cardiovascular nursing",
      "question": "A nitrate medicine may cause:",
      "options": {
        "A": "Headache and hypotension",
        "B": "Deafness always",
        "C": "Hyperkalaemia always",
        "D": "Constipation only"
      },
      "correct_answer": "A",
      "rationale": "Nitrates vasodilate, which can lower BP and cause headache."
    },
    {
      "id": "UKN-Y2-108",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Cardiovascular nursing",
      "question": "Which lifestyle advice supports hypertension management?",
      "options": {
        "A": "Reduce salt, stop smoking, activity as appropriate",
        "B": "Increase salt heavily",
        "C": "Avoid all monitoring",
        "D": "Only drink energy drinks"
      },
      "correct_answer": "A",
      "rationale": "Lifestyle measures can reduce cardiovascular risk and support BP control."
    },
    {
      "id": "UKN-Y2-109",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Cardiovascular nursing",
      "question": "Why monitor daily weight in heart failure?",
      "options": {
        "A": "To detect fluid retention",
        "B": "To assess hair growth",
        "C": "To replace ECG",
        "D": "To diagnose infection only"
      },
      "correct_answer": "A",
      "rationale": "Rapid weight gain may indicate fluid accumulation."
    },
    {
      "id": "UKN-Y2-110",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Cardiovascular nursing",
      "question": "Which investigation records heart electrical activity?",
      "options": {
        "A": "ECG",
        "B": "Urinalysis",
        "C": "Spirometry",
        "D": "MUST"
      },
      "correct_answer": "A",
      "rationale": "An ECG records cardiac electrical activity and rhythm."
    },
    {
      "id": "UKN-Y2-111",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Neurology and stroke",
      "question": "FAST is used to screen for:",
      "options": {
        "A": "Stroke",
        "B": "Sepsis",
        "C": "Diabetes",
        "D": "Fracture"
      },
      "correct_answer": "A",
      "rationale": "FAST assesses facial droop, arm weakness and speech disturbance as stroke signs."
    },
    {
      "id": "UKN-Y2-112",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Neurology and stroke",
      "question": "Unequal pupils after head injury may suggest:",
      "options": {
        "A": "Raised intracranial pressure",
        "B": "Normal ageing always",
        "C": "Low blood sugar only",
        "D": "Improved condition"
      },
      "correct_answer": "A",
      "rationale": "Pupil changes can indicate neurological deterioration and require urgent escalation."
    },
    {
      "id": "UKN-Y2-113",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Neurology and stroke",
      "question": "Which finding is a red flag after a fall?",
      "options": {
        "A": "New confusion or reduced consciousness",
        "B": "Mild embarrassment only",
        "C": "Normal speech",
        "D": "Stable observations"
      },
      "correct_answer": "A",
      "rationale": "Neurological change after trauma can indicate intracranial injury."
    },
    {
      "id": "UKN-Y2-114",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Neurology and stroke",
      "question": "GCS is used to assess:",
      "options": {
        "A": "Level of consciousness",
        "B": "Nutritional status",
        "C": "Skin integrity",
        "D": "Continence only"
      },
      "correct_answer": "A",
      "rationale": "Glasgow Coma Scale scores eye, verbal and motor responses."
    },
    {
      "id": "UKN-Y2-115",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Neurology and stroke",
      "question": "A patient with sudden unilateral weakness needs:",
      "options": {
        "A": "Urgent stroke pathway assessment",
        "B": "Routine appointment next month",
        "C": "Only reassurance",
        "D": "Immediate meal"
      },
      "correct_answer": "A",
      "rationale": "Sudden focal neurological deficit may be stroke and is time-critical."
    },
    {
      "id": "UKN-Y2-116",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Neurology and stroke",
      "question": "Dysphagia after stroke increases risk of:",
      "options": {
        "A": "Aspiration",
        "B": "Improved nutrition always",
        "C": "Low BP only",
        "D": "Fracture healing"
      },
      "correct_answer": "A",
      "rationale": "Swallowing impairment can allow food/fluid into the airway."
    },
    {
      "id": "UKN-Y2-117",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Neurology and stroke",
      "question": "Seizure first aid includes:",
      "options": {
        "A": "Protect from injury and time the seizure",
        "B": "Put objects in mouth",
        "C": "Restrain limbs firmly",
        "D": "Give oral fluids during seizure"
      },
      "correct_answer": "A",
      "rationale": "Safety, timing and airway support after seizure are priorities; objects/restraint are unsafe."
    },
    {
      "id": "UKN-Y2-118",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Neurology and stroke",
      "question": "A new severe \u201cthunderclap\u201d headache may suggest:",
      "options": {
        "A": "Subarachnoid haemorrhage",
        "B": "Simple tiredness always",
        "C": "Ear wax",
        "D": "Mild dehydration only"
      },
      "correct_answer": "A",
      "rationale": "Sudden worst headache is a neurological emergency."
    },
    {
      "id": "UKN-Y2-119",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Neurology and stroke",
      "question": "Which sign suggests meningism?",
      "options": {
        "A": "Neck stiffness with fever/photophobia",
        "B": "Improved appetite",
        "C": "Ankle swelling only",
        "D": "Dry skin"
      },
      "correct_answer": "A",
      "rationale": "Neck stiffness, fever and photophobia can occur with meningitis."
    },
    {
      "id": "UKN-Y2-120",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Neurology and stroke",
      "question": "Why perform neurological observations repeatedly?",
      "options": {
        "A": "To detect deterioration over time",
        "B": "To reduce paperwork only",
        "C": "To replace treatment",
        "D": "To assess diet preferences"
      },
      "correct_answer": "A",
      "rationale": "Serial observations identify trends such as declining consciousness or new deficits."
    },
    {
      "id": "UKN-Y2-121",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Renal and urinary nursing",
      "question": "Oliguria means:",
      "options": {
        "A": "Reduced urine output",
        "B": "Excessive appetite",
        "C": "High oxygen saturation",
        "D": "Normal stool"
      },
      "correct_answer": "A",
      "rationale": "Oliguria is abnormally low urine output and may indicate dehydration, obstruction or AKI."
    },
    {
      "id": "UKN-Y2-122",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Renal and urinary nursing",
      "question": "A rising creatinine may suggest:",
      "options": {
        "A": "Worsening kidney function",
        "B": "Improved liver function",
        "C": "Better oxygenation",
        "D": "Normal digestion"
      },
      "correct_answer": "A",
      "rationale": "Creatinine rises when renal filtration declines."
    },
    {
      "id": "UKN-Y2-123",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Renal and urinary nursing",
      "question": "Dysuria means:",
      "options": {
        "A": "Painful urination",
        "B": "Excessive sleep",
        "C": "Chest pain",
        "D": "Low mood only"
      },
      "correct_answer": "A",
      "rationale": "Dysuria is pain or burning on passing urine."
    },
    {
      "id": "UKN-Y2-124",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Renal and urinary nursing",
      "question": "Which is a UTI symptom?",
      "options": {
        "A": "Frequency and urgency",
        "B": "Improved hearing",
        "C": "Joint deformity only",
        "D": "Bradycardia only"
      },
      "correct_answer": "A",
      "rationale": "Urinary frequency and urgency are common lower UTI symptoms."
    },
    {
      "id": "UKN-Y2-125",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Renal and urinary nursing",
      "question": "Why measure fluid balance accurately?",
      "options": {
        "A": "To assess hydration and renal function trends",
        "B": "To count cups for catering only",
        "C": "To avoid observations",
        "D": "To diagnose fractures"
      },
      "correct_answer": "A",
      "rationale": "Input/output trends help identify dehydration, overload and kidney problems."
    },
    {
      "id": "UKN-Y2-126",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Renal and urinary nursing",
      "question": "A blocked urinary catheter may present with:",
      "options": {
        "A": "Low drainage and suprapubic discomfort",
        "B": "Improved drainage always",
        "C": "No symptoms possible ever",
        "D": "High appetite"
      },
      "correct_answer": "A",
      "rationale": "Obstruction can cause pain, bypassing and reduced urine output."
    },
    {
      "id": "UKN-Y2-127",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Renal and urinary nursing",
      "question": "Haematuria means:",
      "options": {
        "A": "Blood in urine",
        "B": "Glucose in blood",
        "C": "Protein in sputum",
        "D": "Fat in stool"
      },
      "correct_answer": "A",
      "rationale": "Haematuria is visible or microscopic blood in urine and needs assessment."
    },
    {
      "id": "UKN-Y2-128",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Renal and urinary nursing",
      "question": "Which electrolyte is commonly high in severe renal failure?",
      "options": {
        "A": "Potassium",
        "B": "Chloride only",
        "C": "Fluoride",
        "D": "Iodine"
      },
      "correct_answer": "A",
      "rationale": "Reduced renal excretion can cause hyperkalaemia, which is dangerous for the heart."
    },
    {
      "id": "UKN-Y2-129",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Renal and urinary nursing",
      "question": "A patient with AKI is at increased risk of:",
      "options": {
        "A": "Drug accumulation and electrolyte disturbance",
        "B": "Instant immunity",
        "C": "Better clearance of medicines",
        "D": "Reduced monitoring needs"
      },
      "correct_answer": "A",
      "rationale": "AKI impairs filtration and excretion, affecting medicines and electrolytes."
    },
    {
      "id": "UKN-Y2-130",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Renal and urinary nursing",
      "question": "Catheter care should include:",
      "options": {
        "A": "Maintaining closed drainage and reviewing need",
        "B": "Disconnecting daily without indication",
        "C": "Keeping bag above bladder",
        "D": "No hygiene"
      },
      "correct_answer": "A",
      "rationale": "Closed drainage and early removal reduce infection risk."
    },
    {
      "id": "UKN-Y2-131",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Gastrointestinal and nutrition",
      "question": "MUST is used to assess:",
      "options": {
        "A": "Malnutrition risk",
        "B": "Pressure ulcer risk",
        "C": "Consciousness",
        "D": "Falls only"
      },
      "correct_answer": "A",
      "rationale": "MUST is a malnutrition screening tool."
    },
    {
      "id": "UKN-Y2-132",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Gastrointestinal and nutrition",
      "question": "Dysphagia means:",
      "options": {
        "A": "Difficulty swallowing",
        "B": "Difficulty sleeping",
        "C": "Painful urination",
        "D": "Excessive thirst"
      },
      "correct_answer": "A",
      "rationale": "Dysphagia is swallowing difficulty and may increase aspiration risk."
    },
    {
      "id": "UKN-Y2-133",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Gastrointestinal and nutrition",
      "question": "Black tarry stool may indicate:",
      "options": {
        "A": "Upper gastrointestinal bleeding",
        "B": "Normal diet always",
        "C": "Hypoglycaemia",
        "D": "Urinary infection"
      },
      "correct_answer": "A",
      "rationale": "Melaena can occur when blood is digested from upper GI bleeding."
    },
    {
      "id": "UKN-Y2-134",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Gastrointestinal and nutrition",
      "question": "Which symptom may indicate bowel obstruction?",
      "options": {
        "A": "Vomiting, distension and constipation",
        "B": "Improved stool output",
        "C": "Clear urine only",
        "D": "Skin rash only"
      },
      "correct_answer": "A",
      "rationale": "Obstruction commonly causes abdominal distension, vomiting and reduced bowel output."
    },
    {
      "id": "UKN-Y2-135",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Gastrointestinal and nutrition",
      "question": "Why is nutrition important for wound healing?",
      "options": {
        "A": "Protein and energy support tissue repair",
        "B": "It replaces asepsis",
        "C": "It prevents all pain",
        "D": "It stops oxygen need"
      },
      "correct_answer": "A",
      "rationale": "Adequate protein, calories and micronutrients support immune function and repair."
    },
    {
      "id": "UKN-Y2-136",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Gastrointestinal and nutrition",
      "question": "A patient with persistent vomiting is at risk of:",
      "options": {
        "A": "Dehydration and electrolyte imbalance",
        "B": "Instant weight gain",
        "C": "Hyperoxygenation",
        "D": "Improved renal function"
      },
      "correct_answer": "A",
      "rationale": "Vomiting causes fluid and electrolyte losses."
    },
    {
      "id": "UKN-Y2-137",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Gastrointestinal and nutrition",
      "question": "Which is a sign of dehydration?",
      "options": {
        "A": "Dry mucous membranes and reduced urine output",
        "B": "Peripheral oedema only",
        "C": "Bradycardia always",
        "D": "Excessive tears"
      },
      "correct_answer": "A",
      "rationale": "Dry mouth and oliguria suggest fluid deficit."
    },
    {
      "id": "UKN-Y2-138",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Gastrointestinal and nutrition",
      "question": "Constipation risk is increased by:",
      "options": {
        "A": "Opioid medicines",
        "B": "High mobility only",
        "C": "High fibre always",
        "D": "Excess fluid only"
      },
      "correct_answer": "A",
      "rationale": "Opioids slow gut motility and commonly cause constipation."
    },
    {
      "id": "UKN-Y2-139",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Gastrointestinal and nutrition",
      "question": "Enteral feeding delivers nutrition via:",
      "options": {
        "A": "Gastrointestinal tract",
        "B": "Vein only",
        "C": "Skin surface",
        "D": "Bladder"
      },
      "correct_answer": "A",
      "rationale": "Enteral feeding uses the gut, such as via NG or PEG tube."
    },
    {
      "id": "UKN-Y2-140",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Gastrointestinal and nutrition",
      "question": "Ascites is:",
      "options": {
        "A": "Abnormal fluid in the peritoneal cavity",
        "B": "Air in bladder",
        "C": "Blood in urine",
        "D": "Fluid in pleural space only"
      },
      "correct_answer": "A",
      "rationale": "Ascites is accumulation of fluid within the abdomen."
    },
    {
      "id": "UKN-Y2-141",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Wound care and tissue viability",
      "question": "A pressure ulcer risk assessment tool commonly used in the UK is:",
      "options": {
        "A": "Waterlow or Braden",
        "B": "GCS",
        "C": "PHQ-9",
        "D": "Peak flow"
      },
      "correct_answer": "A",
      "rationale": "Waterlow and Braden are used to assess pressure damage risk."
    },
    {
      "id": "UKN-Y2-142",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Wound care and tissue viability",
      "question": "The most important intervention for pressure damage prevention is:",
      "options": {
        "A": "Regular repositioning and pressure relief based on risk",
        "B": "Leaving patient immobile",
        "C": "Massaging red bony prominences hard",
        "D": "Ignoring nutrition"
      },
      "correct_answer": "A",
      "rationale": "Pressure redistribution and repositioning reduce sustained tissue compression."
    },
    {
      "id": "UKN-Y2-143",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Wound care and tissue viability",
      "question": "Non-blanching erythema over a bony prominence suggests:",
      "options": {
        "A": "Category 1 pressure damage",
        "B": "Normal skin always",
        "C": "Deep laceration only",
        "D": "No risk"
      },
      "correct_answer": "A",
      "rationale": "Persistent non-blanching redness is early pressure damage."
    },
    {
      "id": "UKN-Y2-144",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Wound care and tissue viability",
      "question": "Which factor increases pressure ulcer risk?",
      "options": {
        "A": "Immobility",
        "B": "Good nutrition only",
        "C": "Frequent repositioning",
        "D": "Dry intact skin always"
      },
      "correct_answer": "A",
      "rationale": "Immobility increases duration of pressure over vulnerable tissues."
    },
    {
      "id": "UKN-Y2-145",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Wound care and tissue viability",
      "question": "A wound with increasing exudate, odour and pain may be:",
      "options": {
        "A": "Infected",
        "B": "Fully healed",
        "C": "Normal in all cases",
        "D": "Unrelated to wound status"
      },
      "correct_answer": "A",
      "rationale": "Worsening pain, odour and exudate may indicate wound infection."
    },
    {
      "id": "UKN-Y2-146",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Wound care and tissue viability",
      "question": "Why document wound size and appearance?",
      "options": {
        "A": "To monitor healing or deterioration",
        "B": "To replace clinical care",
        "C": "To avoid dressing changes",
        "D": "For decoration"
      },
      "correct_answer": "A",
      "rationale": "Objective wound documentation supports evaluation of progress and treatment effectiveness."
    },
    {
      "id": "UKN-Y2-147",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Wound care and tissue viability",
      "question": "Aseptic technique in wound care aims to:",
      "options": {
        "A": "Prevent contamination",
        "B": "Increase pain",
        "C": "Delay healing",
        "D": "Avoid consent"
      },
      "correct_answer": "A",
      "rationale": "Aseptic technique reduces introduction of microorganisms to vulnerable tissue."
    },
    {
      "id": "UKN-Y2-148",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Wound care and tissue viability",
      "question": "Which nutrition component is especially important in tissue repair?",
      "options": {
        "A": "Protein",
        "B": "Alcohol",
        "C": "Excess salt",
        "D": "Caffeine only"
      },
      "correct_answer": "A",
      "rationale": "Protein provides amino acids needed for tissue repair and immune response."
    },
    {
      "id": "UKN-Y2-149",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Wound care and tissue viability",
      "question": "Maceration around a wound is caused by:",
      "options": {
        "A": "Excess moisture",
        "B": "Complete dryness",
        "C": "Bone growth",
        "D": "Low oxygen saturation only"
      },
      "correct_answer": "A",
      "rationale": "Exudate or moisture can soften and damage surrounding skin."
    },
    {
      "id": "UKN-Y2-150",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Wound care and tissue viability",
      "question": "A heel is vulnerable to pressure damage because:",
      "options": {
        "A": "It has little soft tissue over bone",
        "B": "It has no blood supply ever",
        "C": "It is always moving",
        "D": "It is not weight-bearing in bed"
      },
      "correct_answer": "A",
      "rationale": "The heel has prominent bone with limited padding, making it pressure-prone."
    },
    {
      "id": "UKN-Y2-151",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Mental health and capacity",
      "question": "The Mental Capacity Act applies to decisions when a person may lack capacity and requires:",
      "options": {
        "A": "Decision-specific assessment",
        "B": "Permanent assumption of incapacity",
        "C": "Family decision in all cases",
        "D": "Ignoring best interests"
      },
      "correct_answer": "A",
      "rationale": "Capacity is assessed for the specific decision at the time it needs to be made."
    },
    {
      "id": "UKN-Y2-152",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Mental health and capacity",
      "question": "A patient expressing suicidal intent requires:",
      "options": {
        "A": "Immediate risk assessment and escalation",
        "B": "Reassurance only",
        "C": "Ignoring if busy",
        "D": "Discharge without review"
      },
      "correct_answer": "A",
      "rationale": "Suicidal ideation can indicate immediate risk and requires urgent assessment and safety planning."
    },
    {
      "id": "UKN-Y2-153",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Mental health and capacity",
      "question": "Which is a symptom of delirium?",
      "options": {
        "A": "Acute fluctuating confusion",
        "B": "Lifelong stable personality trait",
        "C": "Planned forgetfulness",
        "D": "Normal sleepiness only"
      },
      "correct_answer": "A",
      "rationale": "Delirium is acute and fluctuating disturbance in attention and cognition."
    },
    {
      "id": "UKN-Y2-154",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Mental health and capacity",
      "question": "A calm, non-judgemental approach is important in de-escalation because it:",
      "options": {
        "A": "Reduces threat and supports safety",
        "B": "Shows dominance",
        "C": "Avoids listening",
        "D": "Increases confrontation"
      },
      "correct_answer": "A",
      "rationale": "Therapeutic communication can reduce arousal and promote cooperation."
    },
    {
      "id": "UKN-Y2-155",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Mental health and capacity",
      "question": "Consent is valid when it is:",
      "options": {
        "A": "Informed, voluntary and given by a person with capacity",
        "B": "Always verbal only",
        "C": "Obtained by pressure",
        "D": "Assumed for all care"
      },
      "correct_answer": "A",
      "rationale": "Valid consent requires information, voluntariness and capacity."
    },
    {
      "id": "UKN-Y2-156",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Mental health and capacity",
      "question": "Which action supports dignity in personal care?",
      "options": {
        "A": "Providing privacy and explaining care",
        "B": "Leaving curtains open",
        "C": "Discussing loudly in corridor",
        "D": "Ignoring preferences"
      },
      "correct_answer": "A",
      "rationale": "Privacy, explanation and respect protect dignity."
    },
    {
      "id": "UKN-Y2-157",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Mental health and capacity",
      "question": "A person with dementia refuses care. The nurse should first:",
      "options": {
        "A": "Assess reasons, capacity and best interests as appropriate",
        "B": "Force care immediately",
        "C": "Ignore distress",
        "D": "Call security automatically"
      },
      "correct_answer": "A",
      "rationale": "Refusal requires person-centred assessment, communication and legal/ethical consideration."
    },
    {
      "id": "UKN-Y2-158",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Mental health and capacity",
      "question": "Therapeutic communication includes:",
      "options": {
        "A": "Active listening",
        "B": "Interrupting constantly",
        "C": "Using threats",
        "D": "Avoiding eye contact always"
      },
      "correct_answer": "A",
      "rationale": "Active listening helps understand concerns and build trust."
    },
    {
      "id": "UKN-Y2-159",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Mental health and capacity",
      "question": "Which condition can mimic or worsen confusion?",
      "options": {
        "A": "Infection or hypoxia",
        "B": "Good sleep only",
        "C": "Stable spectacles",
        "D": "Normal hydration"
      },
      "correct_answer": "A",
      "rationale": "Physical illness such as infection, hypoxia or dehydration can cause acute confusion."
    },
    {
      "id": "UKN-Y2-160",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Mental health and capacity",
      "question": "Safeguarding concern should be:",
      "options": {
        "A": "Escalated according to policy",
        "B": "Kept secret from all staff",
        "C": "Ignored without evidence",
        "D": "Managed only by student"
      },
      "correct_answer": "A",
      "rationale": "Safeguarding concerns require prompt reporting through appropriate channels."
    },
    {
      "id": "UKN-Y2-161",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Professional practice and law",
      "question": "The NMC Code is structured around:",
      "options": {
        "A": "Prioritise people, practise effectively, preserve safety, promote professionalism and trust",
        "B": "Diagnose, prescribe, operate, discharge",
        "C": "Observe, ignore, delegate, forget",
        "D": "Assess, blame, conceal, avoid"
      },
      "correct_answer": "A",
      "rationale": "These four themes summarise the professional standards expected by the NMC."
    },
    {
      "id": "UKN-Y2-162",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Professional practice and law",
      "question": "Duty of candour means:",
      "options": {
        "A": "Being open and honest when things go wrong",
        "B": "Concealing incidents",
        "C": "Only telling colleagues",
        "D": "Avoiding apologies"
      },
      "correct_answer": "A",
      "rationale": "Candour requires openness with patients/families when care causes or may cause harm."
    },
    {
      "id": "UKN-Y2-163",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Professional practice and law",
      "question": "Confidentiality can be breached when:",
      "options": {
        "A": "There is a lawful/public interest reason such as serious risk",
        "B": "A neighbour asks",
        "C": "It is interesting",
        "D": "A student is curious"
      },
      "correct_answer": "A",
      "rationale": "Information sharing must be lawful and proportionate, such as safeguarding or serious risk."
    },
    {
      "id": "UKN-Y2-164",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Professional practice and law",
      "question": "Delegation is safe when:",
      "options": {
        "A": "The task is appropriate and the person is competent/supervised",
        "B": "The nurse wants less work",
        "C": "No one documents it",
        "D": "The patient objects"
      },
      "correct_answer": "A",
      "rationale": "Accountable delegation considers competence, scope, supervision and patient safety."
    },
    {
      "id": "UKN-Y2-165",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Professional practice and law",
      "question": "Reflective practice helps nurses to:",
      "options": {
        "A": "Learn from experience and improve care",
        "B": "Avoid accountability",
        "C": "Replace evidence",
        "D": "Ignore feedback"
      },
      "correct_answer": "A",
      "rationale": "Reflection supports learning, professional development and safer practice."
    },
    {
      "id": "UKN-Y2-166",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Professional practice and law",
      "question": "Accurate documentation should be:",
      "options": {
        "A": "Clear, timely, factual and signed/attributable",
        "B": "Retrospective guesswork",
        "C": "Opinion only",
        "D": "Written for humour"
      },
      "correct_answer": "A",
      "rationale": "Records must provide accurate evidence of assessment, decisions and care."
    },
    {
      "id": "UKN-Y2-167",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Professional practice and law",
      "question": "Raising concerns is required when:",
      "options": {
        "A": "Patient safety may be at risk",
        "B": "It may annoy someone",
        "C": "There is no issue",
        "D": "Only after harm occurs"
      },
      "correct_answer": "A",
      "rationale": "The NMC Code expects nurses to act promptly when safety is compromised."
    },
    {
      "id": "UKN-Y2-168",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Professional practice and law",
      "question": "Person-centred care means:",
      "options": {
        "A": "Respecting individual needs, preferences and values",
        "B": "Treating everyone identically regardless of need",
        "C": "Ignoring communication needs",
        "D": "Making all decisions for patients"
      },
      "correct_answer": "A",
      "rationale": "Person-centred care tailors care to the person and involves them in decisions."
    },
    {
      "id": "UKN-Y2-169",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Professional practice and law",
      "question": "A student nurse must work:",
      "options": {
        "A": "Within competence and under appropriate supervision",
        "B": "As an independent prescriber always",
        "C": "Without asking questions",
        "D": "Outside policy"
      },
      "correct_answer": "A",
      "rationale": "Students must recognise limits and seek supervision to preserve safety."
    },
    {
      "id": "UKN-Y2-170",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Professional practice and law",
      "question": "Professional boundaries help to:",
      "options": {
        "A": "Maintain therapeutic and safe relationships",
        "B": "Create secrecy",
        "C": "Avoid compassion",
        "D": "Permit gifts of any value"
      },
      "correct_answer": "A",
      "rationale": "Boundaries protect patients and staff from exploitation or role confusion."
    },
    {
      "id": "UKN-Y2-171",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Pain and symptom management",
      "question": "In relation to pain score before and after analgesia, what is the safest nursing action?",
      "options": {
        "A": "Document only at the end of the week",
        "B": "Act outside competence to avoid delaying care",
        "C": "Give treatment without checking consent, identity or relevant risks",
        "D": "Assess the patient, follow local policy, document clearly and escalate concerns when indicated"
      },
      "correct_answer": "D",
      "rationale": "Safe UK nursing practice for pain score before and after analgesia requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-172",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Pain and symptom management",
      "question": "A patient scenario raises concern about pain score before and after analgesia. What should the nurse do first?",
      "options": {
        "A": "Ignore the concern unless the patient complains repeatedly",
        "B": "Reassure the patient and take no further action despite deterioration",
        "C": "Prioritise immediate safety using ABCDE or relevant assessment, then seek senior help if needed",
        "D": "Document only at the end of the week"
      },
      "correct_answer": "C",
      "rationale": "Safe UK nursing practice for pain score before and after analgesia requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-173",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Cardiovascular nursing",
      "question": "A patient prescribed digoxin reports nausea and visual disturbances. What should the nurse consider?",
      "options": {
        "A": "A possible sign of digoxin toxicity requiring assessment",
        "B": "A normal expected effect requiring no action",
        "C": "Evidence that the dose should be doubled",
        "D": "A reason to stop all medication permanently"
      },
      "correct_answer": "A",
      "rationale": "Digoxin toxicity may present with gastrointestinal symptoms and visual disturbance; assessment and escalation are required."
    },
    {
      "id": "UKN-Y2-174",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Pain and symptom management",
      "question": "Which response best demonstrates safe practice regarding non-pharmacological pain relief?",
      "options": {
        "A": "Ask an untrained person to manage the problem independently",
        "B": "Communicate clearly, maintain dignity and check understanding before proceeding",
        "C": "Reassure the patient and take no further action despite deterioration",
        "D": "Ignore the concern unless the patient complains repeatedly"
      },
      "correct_answer": "B",
      "rationale": "Safe UK nursing practice for non-pharmacological pain relief requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-175",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Pain and symptom management",
      "question": "A patient scenario raises concern about opioid side effects. What should the nurse do first?",
      "options": {
        "A": "Reassure the patient and take no further action despite deterioration",
        "B": "Ask an untrained person to manage the problem independently",
        "C": "Give treatment without checking consent, identity or relevant risks",
        "D": "Prioritise immediate safety using ABCDE or relevant assessment, then seek senior help if needed"
      },
      "correct_answer": "D",
      "rationale": "Safe UK nursing practice for opioid side effects requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-176",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Pain and symptom management",
      "question": "In relation to opioid side effects, what is the safest nursing action?",
      "options": {
        "A": "Reassure the patient and take no further action despite deterioration",
        "B": "Act outside competence to avoid delaying care",
        "C": "Assess the patient, follow local policy, document clearly and escalate concerns when indicated",
        "D": "Document only at the end of the week"
      },
      "correct_answer": "C",
      "rationale": "Safe UK nursing practice for opioid side effects requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-177",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Pain and symptom management",
      "question": "Which response best demonstrates safe practice regarding breakthrough pain?",
      "options": {
        "A": "Reassure the patient and take no further action despite deterioration",
        "B": "Act outside competence to avoid delaying care",
        "C": "Document only at the end of the week",
        "D": "Communicate clearly, maintain dignity and check understanding before proceeding"
      },
      "correct_answer": "D",
      "rationale": "Safe UK nursing practice for breakthrough pain requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-178",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Renal nursing",
      "question": "Which blood result is most closely associated with acute kidney injury?",
      "options": {
        "A": "Rising creatinine",
        "B": "Reduced cholesterol",
        "C": "Raised haemoglobin",
        "D": "Low body temperature"
      },
      "correct_answer": "A",
      "rationale": "Creatinine is used with urine output and clinical assessment when identifying acute kidney injury."
    },
    {
      "id": "UKN-Y2-179",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Pain and symptom management",
      "question": "In relation to neuropathic pain descriptors, what is the safest nursing action?",
      "options": {
        "A": "Assess the patient, follow local policy, document clearly and escalate concerns when indicated",
        "B": "Ask an untrained person to manage the problem independently",
        "C": "Give treatment without checking consent, identity or relevant risks",
        "D": "Reassure the patient and take no further action despite deterioration"
      },
      "correct_answer": "A",
      "rationale": "Safe UK nursing practice for neuropathic pain descriptors requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-180",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Pain and symptom management",
      "question": "A patient scenario raises concern about neuropathic pain descriptors. What should the nurse do first?",
      "options": {
        "A": "Act outside competence to avoid delaying care",
        "B": "Prioritise immediate safety using ABCDE or relevant assessment, then seek senior help if needed",
        "C": "Ask an untrained person to manage the problem independently",
        "D": "Document only at the end of the week"
      },
      "correct_answer": "B",
      "rationale": "Safe UK nursing practice for neuropathic pain descriptors requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-181",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Neurology",
      "question": "A patient develops sudden facial droop and arm weakness. What is the priority?",
      "options": {
        "A": "Arrange routine review next week",
        "B": "Treat as possible stroke and escalate urgently",
        "C": "Encourage sleep and reassess tomorrow",
        "D": "Offer a high sugar meal"
      },
      "correct_answer": "B",
      "rationale": "Sudden focal neurological symptoms require urgent stroke assessment."
    },
    {
      "id": "UKN-Y2-182",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Pain and symptom management",
      "question": "Which response best demonstrates safe practice regarding pain and dementia?",
      "options": {
        "A": "Ignore the concern unless the patient complains repeatedly",
        "B": "Document only at the end of the week",
        "C": "Reassure the patient and take no further action despite deterioration",
        "D": "Communicate clearly, maintain dignity and check understanding before proceeding"
      },
      "correct_answer": "D",
      "rationale": "Safe UK nursing practice for pain and dementia requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-183",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Pain and symptom management",
      "question": "A patient scenario raises concern about palliative symptom control. What should the nurse do first?",
      "options": {
        "A": "Document only at the end of the week",
        "B": "Prioritise immediate safety using ABCDE or relevant assessment, then seek senior help if needed",
        "C": "Act outside competence to avoid delaying care",
        "D": "Ask an untrained person to manage the problem independently"
      },
      "correct_answer": "B",
      "rationale": "Safe UK nursing practice for palliative symptom control requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-184",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Pain and symptom management",
      "question": "In relation to palliative symptom control, what is the safest nursing action?",
      "options": {
        "A": "Assess the patient, follow local policy, document clearly and escalate concerns when indicated",
        "B": "Ask an untrained person to manage the problem independently",
        "C": "Document only at the end of the week",
        "D": "Ignore the concern unless the patient complains repeatedly"
      },
      "correct_answer": "A",
      "rationale": "Safe UK nursing practice for palliative symptom control requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-185",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Pain and symptom management",
      "question": "Which response best demonstrates safe practice regarding antiemetics?",
      "options": {
        "A": "Give treatment without checking consent, identity or relevant risks",
        "B": "Reassure the patient and take no further action despite deterioration",
        "C": "Ask an untrained person to manage the problem independently",
        "D": "Communicate clearly, maintain dignity and check understanding before proceeding"
      },
      "correct_answer": "D",
      "rationale": "Safe UK nursing practice for antiemetics requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-186",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Clinical assessment",
      "question": "Which finding may indicate fluid overload?",
      "options": {
        "A": "Crackles on chest auscultation and increasing breathlessness",
        "B": "Dry mucous membranes only",
        "C": "Excessive thirst only",
        "D": "Low urine specific gravity only"
      },
      "correct_answer": "A",
      "rationale": "Fluid overload can cause pulmonary congestion and respiratory symptoms."
    },
    {
      "id": "UKN-Y2-187",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Pain and symptom management",
      "question": "In relation to constipation prevention with opioids, what is the safest nursing action?",
      "options": {
        "A": "Ask an untrained person to manage the problem independently",
        "B": "Give treatment without checking consent, identity or relevant risks",
        "C": "Document only at the end of the week",
        "D": "Assess the patient, follow local policy, document clearly and escalate concerns when indicated"
      },
      "correct_answer": "D",
      "rationale": "Safe UK nursing practice for constipation prevention with opioids requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-188",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Pain and symptom management",
      "question": "A patient scenario raises concern about constipation prevention with opioids. What should the nurse do first?",
      "options": {
        "A": "Act outside competence to avoid delaying care",
        "B": "Reassure the patient and take no further action despite deterioration",
        "C": "Prioritise immediate safety using ABCDE or relevant assessment, then seek senior help if needed",
        "D": "Ignore the concern unless the patient complains repeatedly"
      },
      "correct_answer": "C",
      "rationale": "Safe UK nursing practice for constipation prevention with opioids requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-189",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Respiratory nursing",
      "question": "Why are peak flow measurements used in asthma care?",
      "options": {
        "A": "To estimate airflow limitation",
        "B": "To diagnose fractures",
        "C": "To measure blood glucose",
        "D": "To replace all clinical observations"
      },
      "correct_answer": "A",
      "rationale": "Peak expiratory flow helps monitor airway obstruction and response to treatment."
    },
    {
      "id": "UKN-Y2-190",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Pain and symptom management",
      "question": "Which response best demonstrates safe practice regarding patient-controlled analgesia safety?",
      "options": {
        "A": "Communicate clearly, maintain dignity and check understanding before proceeding",
        "B": "Ignore the concern unless the patient complains repeatedly",
        "C": "Act outside competence to avoid delaying care",
        "D": "Give treatment without checking consent, identity or relevant risks"
      },
      "correct_answer": "A",
      "rationale": "Safe UK nursing practice for patient-controlled analgesia safety requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-191",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Perioperative nursing",
      "question": "In relation to pre-operative checklist, what is the safest nursing action?",
      "options": {
        "A": "Assess the patient, follow local policy, document clearly and escalate concerns when indicated",
        "B": "Give treatment without checking consent, identity or relevant risks",
        "C": "Act outside competence to avoid delaying care",
        "D": "Document only at the end of the week"
      },
      "correct_answer": "A",
      "rationale": "Safe UK nursing practice for pre-operative checklist requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-192",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Perioperative nursing",
      "question": "A patient scenario raises concern about pre-operative checklist. What should the nurse do first?",
      "options": {
        "A": "Ignore the concern unless the patient complains repeatedly",
        "B": "Ask an untrained person to manage the problem independently",
        "C": "Prioritise immediate safety using ABCDE or relevant assessment, then seek senior help if needed",
        "D": "Act outside competence to avoid delaying care"
      },
      "correct_answer": "C",
      "rationale": "Safe UK nursing practice for pre-operative checklist requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-193",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Cardiovascular nursing",
      "question": "A patient prescribed digoxin reports nausea and visual disturbances. What should the nurse consider?",
      "options": {
        "A": "A possible sign of digoxin toxicity requiring assessment",
        "B": "A normal expected effect requiring no action",
        "C": "Evidence that the dose should be doubled",
        "D": "A reason to stop all medication permanently"
      },
      "correct_answer": "A",
      "rationale": "Digoxin toxicity may present with gastrointestinal symptoms and visual disturbance; assessment and escalation are required."
    },
    {
      "id": "UKN-Y2-194",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Perioperative nursing",
      "question": "Which response best demonstrates safe practice regarding consent confirmation?",
      "options": {
        "A": "Communicate clearly, maintain dignity and check understanding before proceeding",
        "B": "Ask an untrained person to manage the problem independently",
        "C": "Ignore the concern unless the patient complains repeatedly",
        "D": "Document only at the end of the week"
      },
      "correct_answer": "A",
      "rationale": "Safe UK nursing practice for consent confirmation requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-195",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Perioperative nursing",
      "question": "A patient scenario raises concern about nil by mouth rationale. What should the nurse do first?",
      "options": {
        "A": "Document only at the end of the week",
        "B": "Prioritise immediate safety using ABCDE or relevant assessment, then seek senior help if needed",
        "C": "Ask an untrained person to manage the problem independently",
        "D": "Reassure the patient and take no further action despite deterioration"
      },
      "correct_answer": "B",
      "rationale": "Safe UK nursing practice for nil by mouth rationale requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-196",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Perioperative nursing",
      "question": "In relation to nil by mouth rationale, what is the safest nursing action?",
      "options": {
        "A": "Assess the patient, follow local policy, document clearly and escalate concerns when indicated",
        "B": "Reassure the patient and take no further action despite deterioration",
        "C": "Give treatment without checking consent, identity or relevant risks",
        "D": "Ask an untrained person to manage the problem independently"
      },
      "correct_answer": "A",
      "rationale": "Safe UK nursing practice for nil by mouth rationale requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-197",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Perioperative nursing",
      "question": "Which response best demonstrates safe practice regarding post-operative bleeding?",
      "options": {
        "A": "Ignore the concern unless the patient complains repeatedly",
        "B": "Give treatment without checking consent, identity or relevant risks",
        "C": "Reassure the patient and take no further action despite deterioration",
        "D": "Communicate clearly, maintain dignity and check understanding before proceeding"
      },
      "correct_answer": "D",
      "rationale": "Safe UK nursing practice for post-operative bleeding requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-198",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Renal nursing",
      "question": "Which blood result is most closely associated with acute kidney injury?",
      "options": {
        "A": "Rising creatinine",
        "B": "Reduced cholesterol",
        "C": "Raised haemoglobin",
        "D": "Low body temperature"
      },
      "correct_answer": "A",
      "rationale": "Creatinine is used with urine output and clinical assessment when identifying acute kidney injury."
    },
    {
      "id": "UKN-Y2-199",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Perioperative nursing",
      "question": "In relation to airway after anaesthesia, what is the safest nursing action?",
      "options": {
        "A": "Ask an untrained person to manage the problem independently",
        "B": "Act outside competence to avoid delaying care",
        "C": "Ignore the concern unless the patient complains repeatedly",
        "D": "Assess the patient, follow local policy, document clearly and escalate concerns when indicated"
      },
      "correct_answer": "D",
      "rationale": "Safe UK nursing practice for airway after anaesthesia requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-200",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Perioperative nursing",
      "question": "A patient scenario raises concern about airway after anaesthesia. What should the nurse do first?",
      "options": {
        "A": "Prioritise immediate safety using ABCDE or relevant assessment, then seek senior help if needed",
        "B": "Give treatment without checking consent, identity or relevant risks",
        "C": "Act outside competence to avoid delaying care",
        "D": "Ignore the concern unless the patient complains repeatedly"
      },
      "correct_answer": "A",
      "rationale": "Safe UK nursing practice for airway after anaesthesia requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-201",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Neurology",
      "question": "A patient develops sudden facial droop and arm weakness. What is the priority?",
      "options": {
        "A": "Arrange routine review next week",
        "B": "Treat as possible stroke and escalate urgently",
        "C": "Encourage sleep and reassess tomorrow",
        "D": "Offer a high sugar meal"
      },
      "correct_answer": "B",
      "rationale": "Sudden focal neurological symptoms require urgent stroke assessment."
    },
    {
      "id": "UKN-Y2-202",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Perioperative nursing",
      "question": "Which response best demonstrates safe practice regarding venous thromboembolism prevention?",
      "options": {
        "A": "Ask an untrained person to manage the problem independently",
        "B": "Communicate clearly, maintain dignity and check understanding before proceeding",
        "C": "Give treatment without checking consent, identity or relevant risks",
        "D": "Reassure the patient and take no further action despite deterioration"
      },
      "correct_answer": "B",
      "rationale": "Safe UK nursing practice for venous thromboembolism prevention requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-203",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Perioperative nursing",
      "question": "A patient scenario raises concern about surgical site infection signs. What should the nurse do first?",
      "options": {
        "A": "Document only at the end of the week",
        "B": "Prioritise immediate safety using ABCDE or relevant assessment, then seek senior help if needed",
        "C": "Act outside competence to avoid delaying care",
        "D": "Ignore the concern unless the patient complains repeatedly"
      },
      "correct_answer": "B",
      "rationale": "Safe UK nursing practice for surgical site infection signs requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-204",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Perioperative nursing",
      "question": "In relation to surgical site infection signs, what is the safest nursing action?",
      "options": {
        "A": "Reassure the patient and take no further action despite deterioration",
        "B": "Act outside competence to avoid delaying care",
        "C": "Assess the patient, follow local policy, document clearly and escalate concerns when indicated",
        "D": "Ignore the concern unless the patient complains repeatedly"
      },
      "correct_answer": "C",
      "rationale": "Safe UK nursing practice for surgical site infection signs requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-205",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Perioperative nursing",
      "question": "Which response best demonstrates safe practice regarding post-op pain assessment?",
      "options": {
        "A": "Communicate clearly, maintain dignity and check understanding before proceeding",
        "B": "Reassure the patient and take no further action despite deterioration",
        "C": "Ignore the concern unless the patient complains repeatedly",
        "D": "Document only at the end of the week"
      },
      "correct_answer": "A",
      "rationale": "Safe UK nursing practice for post-op pain assessment requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-206",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Clinical assessment",
      "question": "Which finding may indicate fluid overload?",
      "options": {
        "A": "Crackles on chest auscultation and increasing breathlessness",
        "B": "Dry mucous membranes only",
        "C": "Excessive thirst only",
        "D": "Low urine specific gravity only"
      },
      "correct_answer": "A",
      "rationale": "Fluid overload can cause pulmonary congestion and respiratory symptoms."
    },
    {
      "id": "UKN-Y2-207",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Perioperative nursing",
      "question": "In relation to urinary retention after surgery, what is the safest nursing action?",
      "options": {
        "A": "Reassure the patient and take no further action despite deterioration",
        "B": "Assess the patient, follow local policy, document clearly and escalate concerns when indicated",
        "C": "Act outside competence to avoid delaying care",
        "D": "Ask an untrained person to manage the problem independently"
      },
      "correct_answer": "B",
      "rationale": "Safe UK nursing practice for urinary retention after surgery requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-208",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Perioperative nursing",
      "question": "A patient scenario raises concern about urinary retention after surgery. What should the nurse do first?",
      "options": {
        "A": "Act outside competence to avoid delaying care",
        "B": "Prioritise immediate safety using ABCDE or relevant assessment, then seek senior help if needed",
        "C": "Give treatment without checking consent, identity or relevant risks",
        "D": "Reassure the patient and take no further action despite deterioration"
      },
      "correct_answer": "B",
      "rationale": "Safe UK nursing practice for urinary retention after surgery requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-209",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Respiratory nursing",
      "question": "Why are peak flow measurements used in asthma care?",
      "options": {
        "A": "To estimate airflow limitation",
        "B": "To diagnose fractures",
        "C": "To measure blood glucose",
        "D": "To replace all clinical observations"
      },
      "correct_answer": "A",
      "rationale": "Peak expiratory flow helps monitor airway obstruction and response to treatment."
    },
    {
      "id": "UKN-Y2-210",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Perioperative nursing",
      "question": "Which response best demonstrates safe practice regarding early mobilisation?",
      "options": {
        "A": "Give treatment without checking consent, identity or relevant risks",
        "B": "Document only at the end of the week",
        "C": "Reassure the patient and take no further action despite deterioration",
        "D": "Communicate clearly, maintain dignity and check understanding before proceeding"
      },
      "correct_answer": "D",
      "rationale": "Safe UK nursing practice for early mobilisation requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-211",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Older people and frailty",
      "question": "In relation to falls risk, what is the safest nursing action?",
      "options": {
        "A": "Ask an untrained person to manage the problem independently",
        "B": "Act outside competence to avoid delaying care",
        "C": "Assess the patient, follow local policy, document clearly and escalate concerns when indicated",
        "D": "Give treatment without checking consent, identity or relevant risks"
      },
      "correct_answer": "C",
      "rationale": "Safe UK nursing practice for falls risk requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-212",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Older people and frailty",
      "question": "A patient scenario raises concern about falls risk. What should the nurse do first?",
      "options": {
        "A": "Prioritise immediate safety using ABCDE or relevant assessment, then seek senior help if needed",
        "B": "Reassure the patient and take no further action despite deterioration",
        "C": "Ask an untrained person to manage the problem independently",
        "D": "Ignore the concern unless the patient complains repeatedly"
      },
      "correct_answer": "A",
      "rationale": "Safe UK nursing practice for falls risk requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-213",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Cardiovascular nursing",
      "question": "A patient prescribed digoxin reports nausea and visual disturbances. What should the nurse consider?",
      "options": {
        "A": "A possible sign of digoxin toxicity requiring assessment",
        "B": "A normal expected effect requiring no action",
        "C": "Evidence that the dose should be doubled",
        "D": "A reason to stop all medication permanently"
      },
      "correct_answer": "A",
      "rationale": "Digoxin toxicity may present with gastrointestinal symptoms and visual disturbance; assessment and escalation are required."
    },
    {
      "id": "UKN-Y2-214",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Older people and frailty",
      "question": "Which response best demonstrates safe practice regarding polypharmacy?",
      "options": {
        "A": "Ask an untrained person to manage the problem independently",
        "B": "Give treatment without checking consent, identity or relevant risks",
        "C": "Communicate clearly, maintain dignity and check understanding before proceeding",
        "D": "Act outside competence to avoid delaying care"
      },
      "correct_answer": "C",
      "rationale": "Safe UK nursing practice for polypharmacy requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-215",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Older people and frailty",
      "question": "A patient scenario raises concern about frailty recognition. What should the nurse do first?",
      "options": {
        "A": "Ignore the concern unless the patient complains repeatedly",
        "B": "Ask an untrained person to manage the problem independently",
        "C": "Prioritise immediate safety using ABCDE or relevant assessment, then seek senior help if needed",
        "D": "Give treatment without checking consent, identity or relevant risks"
      },
      "correct_answer": "C",
      "rationale": "Safe UK nursing practice for frailty recognition requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-216",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Older people and frailty",
      "question": "In relation to frailty recognition, what is the safest nursing action?",
      "options": {
        "A": "Assess the patient, follow local policy, document clearly and escalate concerns when indicated",
        "B": "Give treatment without checking consent, identity or relevant risks",
        "C": "Act outside competence to avoid delaying care",
        "D": "Ignore the concern unless the patient complains repeatedly"
      },
      "correct_answer": "A",
      "rationale": "Safe UK nursing practice for frailty recognition requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-217",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Older people and frailty",
      "question": "Which response best demonstrates safe practice regarding delirium prevention?",
      "options": {
        "A": "Act outside competence to avoid delaying care",
        "B": "Document only at the end of the week",
        "C": "Communicate clearly, maintain dignity and check understanding before proceeding",
        "D": "Ask an untrained person to manage the problem independently"
      },
      "correct_answer": "C",
      "rationale": "Safe UK nursing practice for delirium prevention requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-218",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Renal nursing",
      "question": "Which blood result is most closely associated with acute kidney injury?",
      "options": {
        "A": "Rising creatinine",
        "B": "Reduced cholesterol",
        "C": "Raised haemoglobin",
        "D": "Low body temperature"
      },
      "correct_answer": "A",
      "rationale": "Creatinine is used with urine output and clinical assessment when identifying acute kidney injury."
    },
    {
      "id": "UKN-Y2-219",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Older people and frailty",
      "question": "In relation to continence assessment, what is the safest nursing action?",
      "options": {
        "A": "Ignore the concern unless the patient complains repeatedly",
        "B": "Assess the patient, follow local policy, document clearly and escalate concerns when indicated",
        "C": "Act outside competence to avoid delaying care",
        "D": "Document only at the end of the week"
      },
      "correct_answer": "B",
      "rationale": "Safe UK nursing practice for continence assessment requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-220",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Older people and frailty",
      "question": "A patient scenario raises concern about continence assessment. What should the nurse do first?",
      "options": {
        "A": "Reassure the patient and take no further action despite deterioration",
        "B": "Document only at the end of the week",
        "C": "Prioritise immediate safety using ABCDE or relevant assessment, then seek senior help if needed",
        "D": "Ask an untrained person to manage the problem independently"
      },
      "correct_answer": "C",
      "rationale": "Safe UK nursing practice for continence assessment requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-221",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Neurology",
      "question": "A patient develops sudden facial droop and arm weakness. What is the priority?",
      "options": {
        "A": "Arrange routine review next week",
        "B": "Treat as possible stroke and escalate urgently",
        "C": "Encourage sleep and reassess tomorrow",
        "D": "Offer a high sugar meal"
      },
      "correct_answer": "B",
      "rationale": "Sudden focal neurological symptoms require urgent stroke assessment."
    },
    {
      "id": "UKN-Y2-222",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Older people and frailty",
      "question": "Which response best demonstrates safe practice regarding nutrition and hydration?",
      "options": {
        "A": "Reassure the patient and take no further action despite deterioration",
        "B": "Act outside competence to avoid delaying care",
        "C": "Communicate clearly, maintain dignity and check understanding before proceeding",
        "D": "Ignore the concern unless the patient complains repeatedly"
      },
      "correct_answer": "C",
      "rationale": "Safe UK nursing practice for nutrition and hydration requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-223",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Older people and frailty",
      "question": "A patient scenario raises concern about skin integrity. What should the nurse do first?",
      "options": {
        "A": "Act outside competence to avoid delaying care",
        "B": "Prioritise immediate safety using ABCDE or relevant assessment, then seek senior help if needed",
        "C": "Ask an untrained person to manage the problem independently",
        "D": "Reassure the patient and take no further action despite deterioration"
      },
      "correct_answer": "B",
      "rationale": "Safe UK nursing practice for skin integrity requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-224",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Older people and frailty",
      "question": "In relation to skin integrity, what is the safest nursing action?",
      "options": {
        "A": "Reassure the patient and take no further action despite deterioration",
        "B": "Ignore the concern unless the patient complains repeatedly",
        "C": "Assess the patient, follow local policy, document clearly and escalate concerns when indicated",
        "D": "Document only at the end of the week"
      },
      "correct_answer": "C",
      "rationale": "Safe UK nursing practice for skin integrity requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-225",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Older people and frailty",
      "question": "Which response best demonstrates safe practice regarding sensory impairment communication?",
      "options": {
        "A": "Ask an untrained person to manage the problem independently",
        "B": "Act outside competence to avoid delaying care",
        "C": "Document only at the end of the week",
        "D": "Communicate clearly, maintain dignity and check understanding before proceeding"
      },
      "correct_answer": "D",
      "rationale": "Safe UK nursing practice for sensory impairment communication requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-226",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Clinical assessment",
      "question": "Which finding may indicate fluid overload?",
      "options": {
        "A": "Crackles on chest auscultation and increasing breathlessness",
        "B": "Dry mucous membranes only",
        "C": "Excessive thirst only",
        "D": "Low urine specific gravity only"
      },
      "correct_answer": "A",
      "rationale": "Fluid overload can cause pulmonary congestion and respiratory symptoms."
    },
    {
      "id": "UKN-Y2-227",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Older people and frailty",
      "question": "In relation to dementia-friendly care, what is the safest nursing action?",
      "options": {
        "A": "Ask an untrained person to manage the problem independently",
        "B": "Assess the patient, follow local policy, document clearly and escalate concerns when indicated",
        "C": "Document only at the end of the week",
        "D": "Give treatment without checking consent, identity or relevant risks"
      },
      "correct_answer": "B",
      "rationale": "Safe UK nursing practice for dementia-friendly care requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-228",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Older people and frailty",
      "question": "A patient scenario raises concern about dementia-friendly care. What should the nurse do first?",
      "options": {
        "A": "Reassure the patient and take no further action despite deterioration",
        "B": "Prioritise immediate safety using ABCDE or relevant assessment, then seek senior help if needed",
        "C": "Document only at the end of the week",
        "D": "Ask an untrained person to manage the problem independently"
      },
      "correct_answer": "B",
      "rationale": "Safe UK nursing practice for dementia-friendly care requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-229",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Respiratory nursing",
      "question": "Why are peak flow measurements used in asthma care?",
      "options": {
        "A": "To estimate airflow limitation",
        "B": "To diagnose fractures",
        "C": "To measure blood glucose",
        "D": "To replace all clinical observations"
      },
      "correct_answer": "A",
      "rationale": "Peak expiratory flow helps monitor airway obstruction and response to treatment."
    },
    {
      "id": "UKN-Y2-230",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Older people and frailty",
      "question": "Which response best demonstrates safe practice regarding discharge planning?",
      "options": {
        "A": "Act outside competence to avoid delaying care",
        "B": "Ask an untrained person to manage the problem independently",
        "C": "Give treatment without checking consent, identity or relevant risks",
        "D": "Communicate clearly, maintain dignity and check understanding before proceeding"
      },
      "correct_answer": "D",
      "rationale": "Safe UK nursing practice for discharge planning requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-231",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Maternal and reproductive health basics",
      "question": "In relation to ectopic pregnancy red flags, what is the safest nursing action?",
      "options": {
        "A": "Act outside competence to avoid delaying care",
        "B": "Assess the patient, follow local policy, document clearly and escalate concerns when indicated",
        "C": "Document only at the end of the week",
        "D": "Ignore the concern unless the patient complains repeatedly"
      },
      "correct_answer": "B",
      "rationale": "Safe UK nursing practice for ectopic pregnancy red flags requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-232",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Maternal and reproductive health basics",
      "question": "A patient scenario raises concern about ectopic pregnancy red flags. What should the nurse do first?",
      "options": {
        "A": "Act outside competence to avoid delaying care",
        "B": "Prioritise immediate safety using ABCDE or relevant assessment, then seek senior help if needed",
        "C": "Give treatment without checking consent, identity or relevant risks",
        "D": "Ignore the concern unless the patient complains repeatedly"
      },
      "correct_answer": "B",
      "rationale": "Safe UK nursing practice for ectopic pregnancy red flags requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-233",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Cardiovascular nursing",
      "question": "A patient prescribed digoxin reports nausea and visual disturbances. What should the nurse consider?",
      "options": {
        "A": "A possible sign of digoxin toxicity requiring assessment",
        "B": "A normal expected effect requiring no action",
        "C": "Evidence that the dose should be doubled",
        "D": "A reason to stop all medication permanently"
      },
      "correct_answer": "A",
      "rationale": "Digoxin toxicity may present with gastrointestinal symptoms and visual disturbance; assessment and escalation are required."
    },
    {
      "id": "UKN-Y2-234",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Maternal and reproductive health basics",
      "question": "Which response best demonstrates safe practice regarding postpartum haemorrhage concern?",
      "options": {
        "A": "Act outside competence to avoid delaying care",
        "B": "Communicate clearly, maintain dignity and check understanding before proceeding",
        "C": "Document only at the end of the week",
        "D": "Give treatment without checking consent, identity or relevant risks"
      },
      "correct_answer": "B",
      "rationale": "Safe UK nursing practice for postpartum haemorrhage concern requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-235",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Maternal and reproductive health basics",
      "question": "A patient scenario raises concern about pregnancy medication caution. What should the nurse do first?",
      "options": {
        "A": "Prioritise immediate safety using ABCDE or relevant assessment, then seek senior help if needed",
        "B": "Ask an untrained person to manage the problem independently",
        "C": "Ignore the concern unless the patient complains repeatedly",
        "D": "Document only at the end of the week"
      },
      "correct_answer": "A",
      "rationale": "Safe UK nursing practice for pregnancy medication caution requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-236",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Maternal and reproductive health basics",
      "question": "In relation to pregnancy medication caution, what is the safest nursing action?",
      "options": {
        "A": "Assess the patient, follow local policy, document clearly and escalate concerns when indicated",
        "B": "Give treatment without checking consent, identity or relevant risks",
        "C": "Ask an untrained person to manage the problem independently",
        "D": "Ignore the concern unless the patient complains repeatedly"
      },
      "correct_answer": "A",
      "rationale": "Safe UK nursing practice for pregnancy medication caution requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-237",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Maternal and reproductive health basics",
      "question": "Which response best demonstrates safe practice regarding safeguarding in pregnancy?",
      "options": {
        "A": "Ask an untrained person to manage the problem independently",
        "B": "Ignore the concern unless the patient complains repeatedly",
        "C": "Communicate clearly, maintain dignity and check understanding before proceeding",
        "D": "Reassure the patient and take no further action despite deterioration"
      },
      "correct_answer": "C",
      "rationale": "Safe UK nursing practice for safeguarding in pregnancy requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-238",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Renal nursing",
      "question": "Which blood result is most closely associated with acute kidney injury?",
      "options": {
        "A": "Rising creatinine",
        "B": "Reduced cholesterol",
        "C": "Raised haemoglobin",
        "D": "Low body temperature"
      },
      "correct_answer": "A",
      "rationale": "Creatinine is used with urine output and clinical assessment when identifying acute kidney injury."
    },
    {
      "id": "UKN-Y2-239",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Maternal and reproductive health basics",
      "question": "In relation to pre-eclampsia symptoms, what is the safest nursing action?",
      "options": {
        "A": "Assess the patient, follow local policy, document clearly and escalate concerns when indicated",
        "B": "Ask an untrained person to manage the problem independently",
        "C": "Document only at the end of the week",
        "D": "Give treatment without checking consent, identity or relevant risks"
      },
      "correct_answer": "A",
      "rationale": "Safe UK nursing practice for pre-eclampsia symptoms requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-240",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Maternal and reproductive health basics",
      "question": "A patient scenario raises concern about pre-eclampsia symptoms. What should the nurse do first?",
      "options": {
        "A": "Ask an untrained person to manage the problem independently",
        "B": "Ignore the concern unless the patient complains repeatedly",
        "C": "Prioritise immediate safety using ABCDE or relevant assessment, then seek senior help if needed",
        "D": "Document only at the end of the week"
      },
      "correct_answer": "C",
      "rationale": "Safe UK nursing practice for pre-eclampsia symptoms requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-241",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Neurology",
      "question": "A patient develops sudden facial droop and arm weakness. What is the priority?",
      "options": {
        "A": "Arrange routine review next week",
        "B": "Treat as possible stroke and escalate urgently",
        "C": "Encourage sleep and reassess tomorrow",
        "D": "Offer a high sugar meal"
      },
      "correct_answer": "B",
      "rationale": "Sudden focal neurological symptoms require urgent stroke assessment."
    },
    {
      "id": "UKN-Y2-242",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Maternal and reproductive health basics",
      "question": "Which response best demonstrates safe practice regarding contraception advice referral?",
      "options": {
        "A": "Ignore the concern unless the patient complains repeatedly",
        "B": "Act outside competence to avoid delaying care",
        "C": "Document only at the end of the week",
        "D": "Communicate clearly, maintain dignity and check understanding before proceeding"
      },
      "correct_answer": "D",
      "rationale": "Safe UK nursing practice for contraception advice referral requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-243",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Maternal and reproductive health basics",
      "question": "A patient scenario raises concern about urinary symptoms in pregnancy. What should the nurse do first?",
      "options": {
        "A": "Ignore the concern unless the patient complains repeatedly",
        "B": "Prioritise immediate safety using ABCDE or relevant assessment, then seek senior help if needed",
        "C": "Give treatment without checking consent, identity or relevant risks",
        "D": "Document only at the end of the week"
      },
      "correct_answer": "B",
      "rationale": "Safe UK nursing practice for urinary symptoms in pregnancy requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-244",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Maternal and reproductive health basics",
      "question": "In relation to urinary symptoms in pregnancy, what is the safest nursing action?",
      "options": {
        "A": "Reassure the patient and take no further action despite deterioration",
        "B": "Ignore the concern unless the patient complains repeatedly",
        "C": "Act outside competence to avoid delaying care",
        "D": "Assess the patient, follow local policy, document clearly and escalate concerns when indicated"
      },
      "correct_answer": "D",
      "rationale": "Safe UK nursing practice for urinary symptoms in pregnancy requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-245",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Maternal and reproductive health basics",
      "question": "Which response best demonstrates safe practice regarding reduced fetal movements escalation?",
      "options": {
        "A": "Communicate clearly, maintain dignity and check understanding before proceeding",
        "B": "Ignore the concern unless the patient complains repeatedly",
        "C": "Reassure the patient and take no further action despite deterioration",
        "D": "Act outside competence to avoid delaying care"
      },
      "correct_answer": "A",
      "rationale": "Safe UK nursing practice for reduced fetal movements escalation requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-246",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Clinical assessment",
      "question": "Which finding may indicate fluid overload?",
      "options": {
        "A": "Crackles on chest auscultation and increasing breathlessness",
        "B": "Dry mucous membranes only",
        "C": "Excessive thirst only",
        "D": "Low urine specific gravity only"
      },
      "correct_answer": "A",
      "rationale": "Fluid overload can cause pulmonary congestion and respiratory symptoms."
    },
    {
      "id": "UKN-Y2-247",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Maternal and reproductive health basics",
      "question": "In relation to breastfeeding support, what is the safest nursing action?",
      "options": {
        "A": "Document only at the end of the week",
        "B": "Ignore the concern unless the patient complains repeatedly",
        "C": "Assess the patient, follow local policy, document clearly and escalate concerns when indicated",
        "D": "Ask an untrained person to manage the problem independently"
      },
      "correct_answer": "C",
      "rationale": "Safe UK nursing practice for breastfeeding support requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-248",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Maternal and reproductive health basics",
      "question": "A patient scenario raises concern about breastfeeding support. What should the nurse do first?",
      "options": {
        "A": "Reassure the patient and take no further action despite deterioration",
        "B": "Ignore the concern unless the patient complains repeatedly",
        "C": "Prioritise immediate safety using ABCDE or relevant assessment, then seek senior help if needed",
        "D": "Act outside competence to avoid delaying care"
      },
      "correct_answer": "C",
      "rationale": "Safe UK nursing practice for breastfeeding support requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-249",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Respiratory nursing",
      "question": "Why are peak flow measurements used in asthma care?",
      "options": {
        "A": "To estimate airflow limitation",
        "B": "To diagnose fractures",
        "C": "To measure blood glucose",
        "D": "To replace all clinical observations"
      },
      "correct_answer": "A",
      "rationale": "Peak expiratory flow helps monitor airway obstruction and response to treatment."
    },
    {
      "id": "UKN-Y2-250",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Maternal and reproductive health basics",
      "question": "Which response best demonstrates safe practice regarding postnatal mental health?",
      "options": {
        "A": "Ask an untrained person to manage the problem independently",
        "B": "Reassure the patient and take no further action despite deterioration",
        "C": "Communicate clearly, maintain dignity and check understanding before proceeding",
        "D": "Act outside competence to avoid delaying care"
      },
      "correct_answer": "C",
      "rationale": "Safe UK nursing practice for postnatal mental health requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-251",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Children and young people basics",
      "question": "In relation to paediatric observations, what is the safest nursing action?",
      "options": {
        "A": "Ignore the concern unless the patient complains repeatedly",
        "B": "Document only at the end of the week",
        "C": "Assess the patient, follow local policy, document clearly and escalate concerns when indicated",
        "D": "Give treatment without checking consent, identity or relevant risks"
      },
      "correct_answer": "C",
      "rationale": "Safe UK nursing practice for paediatric observations requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-252",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Children and young people basics",
      "question": "A patient scenario raises concern about paediatric observations. What should the nurse do first?",
      "options": {
        "A": "Give treatment without checking consent, identity or relevant risks",
        "B": "Document only at the end of the week",
        "C": "Prioritise immediate safety using ABCDE or relevant assessment, then seek senior help if needed",
        "D": "Ask an untrained person to manage the problem independently"
      },
      "correct_answer": "C",
      "rationale": "Safe UK nursing practice for paediatric observations requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-253",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Cardiovascular nursing",
      "question": "A patient prescribed digoxin reports nausea and visual disturbances. What should the nurse consider?",
      "options": {
        "A": "A possible sign of digoxin toxicity requiring assessment",
        "B": "A normal expected effect requiring no action",
        "C": "Evidence that the dose should be doubled",
        "D": "A reason to stop all medication permanently"
      },
      "correct_answer": "A",
      "rationale": "Digoxin toxicity may present with gastrointestinal symptoms and visual disturbance; assessment and escalation are required."
    },
    {
      "id": "UKN-Y2-254",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Children and young people basics",
      "question": "Which response best demonstrates safe practice regarding safeguarding child concern?",
      "options": {
        "A": "Communicate clearly, maintain dignity and check understanding before proceeding",
        "B": "Give treatment without checking consent, identity or relevant risks",
        "C": "Act outside competence to avoid delaying care",
        "D": "Ignore the concern unless the patient complains repeatedly"
      },
      "correct_answer": "A",
      "rationale": "Safe UK nursing practice for safeguarding child concern requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-255",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Children and young people basics",
      "question": "A patient scenario raises concern about fever and rash concern. What should the nurse do first?",
      "options": {
        "A": "Prioritise immediate safety using ABCDE or relevant assessment, then seek senior help if needed",
        "B": "Ignore the concern unless the patient complains repeatedly",
        "C": "Reassure the patient and take no further action despite deterioration",
        "D": "Document only at the end of the week"
      },
      "correct_answer": "A",
      "rationale": "Safe UK nursing practice for fever and rash concern requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-256",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Children and young people basics",
      "question": "In relation to fever and rash concern, what is the safest nursing action?",
      "options": {
        "A": "Ignore the concern unless the patient complains repeatedly",
        "B": "Assess the patient, follow local policy, document clearly and escalate concerns when indicated",
        "C": "Document only at the end of the week",
        "D": "Act outside competence to avoid delaying care"
      },
      "correct_answer": "B",
      "rationale": "Safe UK nursing practice for fever and rash concern requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-257",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Children and young people basics",
      "question": "Which response best demonstrates safe practice regarding weight-based medicines?",
      "options": {
        "A": "Give treatment without checking consent, identity or relevant risks",
        "B": "Document only at the end of the week",
        "C": "Ignore the concern unless the patient complains repeatedly",
        "D": "Communicate clearly, maintain dignity and check understanding before proceeding"
      },
      "correct_answer": "D",
      "rationale": "Safe UK nursing practice for weight-based medicines requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-258",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Renal nursing",
      "question": "Which blood result is most closely associated with acute kidney injury?",
      "options": {
        "A": "Rising creatinine",
        "B": "Reduced cholesterol",
        "C": "Raised haemoglobin",
        "D": "Low body temperature"
      },
      "correct_answer": "A",
      "rationale": "Creatinine is used with urine output and clinical assessment when identifying acute kidney injury."
    },
    {
      "id": "UKN-Y2-259",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Children and young people basics",
      "question": "In relation to family-centred care, what is the safest nursing action?",
      "options": {
        "A": "Act outside competence to avoid delaying care",
        "B": "Give treatment without checking consent, identity or relevant risks",
        "C": "Ignore the concern unless the patient complains repeatedly",
        "D": "Assess the patient, follow local policy, document clearly and escalate concerns when indicated"
      },
      "correct_answer": "D",
      "rationale": "Safe UK nursing practice for family-centred care requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-260",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Children and young people basics",
      "question": "A patient scenario raises concern about family-centred care. What should the nurse do first?",
      "options": {
        "A": "Document only at the end of the week",
        "B": "Act outside competence to avoid delaying care",
        "C": "Ask an untrained person to manage the problem independently",
        "D": "Prioritise immediate safety using ABCDE or relevant assessment, then seek senior help if needed"
      },
      "correct_answer": "D",
      "rationale": "Safe UK nursing practice for family-centred care requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-261",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Neurology",
      "question": "A patient develops sudden facial droop and arm weakness. What is the priority?",
      "options": {
        "A": "Arrange routine review next week",
        "B": "Treat as possible stroke and escalate urgently",
        "C": "Encourage sleep and reassess tomorrow",
        "D": "Offer a high sugar meal"
      },
      "correct_answer": "B",
      "rationale": "Sudden focal neurological symptoms require urgent stroke assessment."
    },
    {
      "id": "UKN-Y2-262",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Children and young people basics",
      "question": "Which response best demonstrates safe practice regarding consent and Gillick competence?",
      "options": {
        "A": "Ask an untrained person to manage the problem independently",
        "B": "Act outside competence to avoid delaying care",
        "C": "Document only at the end of the week",
        "D": "Communicate clearly, maintain dignity and check understanding before proceeding"
      },
      "correct_answer": "D",
      "rationale": "Safe UK nursing practice for consent and Gillick competence requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-263",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Children and young people basics",
      "question": "A patient scenario raises concern about dehydration signs child. What should the nurse do first?",
      "options": {
        "A": "Ask an untrained person to manage the problem independently",
        "B": "Act outside competence to avoid delaying care",
        "C": "Reassure the patient and take no further action despite deterioration",
        "D": "Prioritise immediate safety using ABCDE or relevant assessment, then seek senior help if needed"
      },
      "correct_answer": "D",
      "rationale": "Safe UK nursing practice for dehydration signs child requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-264",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Children and young people basics",
      "question": "In relation to dehydration signs child, what is the safest nursing action?",
      "options": {
        "A": "Assess the patient, follow local policy, document clearly and escalate concerns when indicated",
        "B": "Reassure the patient and take no further action despite deterioration",
        "C": "Ask an untrained person to manage the problem independently",
        "D": "Ignore the concern unless the patient complains repeatedly"
      },
      "correct_answer": "A",
      "rationale": "Safe UK nursing practice for dehydration signs child requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-265",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Children and young people basics",
      "question": "Which response best demonstrates safe practice regarding asthma inhaler technique child?",
      "options": {
        "A": "Ignore the concern unless the patient complains repeatedly",
        "B": "Reassure the patient and take no further action despite deterioration",
        "C": "Give treatment without checking consent, identity or relevant risks",
        "D": "Communicate clearly, maintain dignity and check understanding before proceeding"
      },
      "correct_answer": "D",
      "rationale": "Safe UK nursing practice for asthma inhaler technique child requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-266",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Clinical assessment",
      "question": "Which finding may indicate fluid overload?",
      "options": {
        "A": "Crackles on chest auscultation and increasing breathlessness",
        "B": "Dry mucous membranes only",
        "C": "Excessive thirst only",
        "D": "Low urine specific gravity only"
      },
      "correct_answer": "A",
      "rationale": "Fluid overload can cause pulmonary congestion and respiratory symptoms."
    },
    {
      "id": "UKN-Y2-267",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Children and young people basics",
      "question": "In relation to pain assessment child, what is the safest nursing action?",
      "options": {
        "A": "Reassure the patient and take no further action despite deterioration",
        "B": "Give treatment without checking consent, identity or relevant risks",
        "C": "Ignore the concern unless the patient complains repeatedly",
        "D": "Assess the patient, follow local policy, document clearly and escalate concerns when indicated"
      },
      "correct_answer": "D",
      "rationale": "Safe UK nursing practice for pain assessment child requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-268",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Children and young people basics",
      "question": "A patient scenario raises concern about pain assessment child. What should the nurse do first?",
      "options": {
        "A": "Ask an untrained person to manage the problem independently",
        "B": "Prioritise immediate safety using ABCDE or relevant assessment, then seek senior help if needed",
        "C": "Ignore the concern unless the patient complains repeatedly",
        "D": "Document only at the end of the week"
      },
      "correct_answer": "B",
      "rationale": "Safe UK nursing practice for pain assessment child requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-269",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Respiratory nursing",
      "question": "Why are peak flow measurements used in asthma care?",
      "options": {
        "A": "To estimate airflow limitation",
        "B": "To diagnose fractures",
        "C": "To measure blood glucose",
        "D": "To replace all clinical observations"
      },
      "correct_answer": "A",
      "rationale": "Peak expiratory flow helps monitor airway obstruction and response to treatment."
    },
    {
      "id": "UKN-Y2-270",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Children and young people basics",
      "question": "Which response best demonstrates safe practice regarding escalation to senior paediatric support?",
      "options": {
        "A": "Ignore the concern unless the patient complains repeatedly",
        "B": "Document only at the end of the week",
        "C": "Communicate clearly, maintain dignity and check understanding before proceeding",
        "D": "Ask an untrained person to manage the problem independently"
      },
      "correct_answer": "C",
      "rationale": "Safe UK nursing practice for escalation to senior paediatric support requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-271",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Learning disability and autism care",
      "question": "In relation to reasonable adjustments, what is the safest nursing action?",
      "options": {
        "A": "Ask an untrained person to manage the problem independently",
        "B": "Reassure the patient and take no further action despite deterioration",
        "C": "Assess the patient, follow local policy, document clearly and escalate concerns when indicated",
        "D": "Document only at the end of the week"
      },
      "correct_answer": "C",
      "rationale": "Safe UK nursing practice for reasonable adjustments requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-272",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Learning disability and autism care",
      "question": "A patient scenario raises concern about reasonable adjustments. What should the nurse do first?",
      "options": {
        "A": "Ignore the concern unless the patient complains repeatedly",
        "B": "Document only at the end of the week",
        "C": "Give treatment without checking consent, identity or relevant risks",
        "D": "Prioritise immediate safety using ABCDE or relevant assessment, then seek senior help if needed"
      },
      "correct_answer": "D",
      "rationale": "Safe UK nursing practice for reasonable adjustments requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-273",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Cardiovascular nursing",
      "question": "A patient prescribed digoxin reports nausea and visual disturbances. What should the nurse consider?",
      "options": {
        "A": "A possible sign of digoxin toxicity requiring assessment",
        "B": "A normal expected effect requiring no action",
        "C": "Evidence that the dose should be doubled",
        "D": "A reason to stop all medication permanently"
      },
      "correct_answer": "A",
      "rationale": "Digoxin toxicity may present with gastrointestinal symptoms and visual disturbance; assessment and escalation are required."
    },
    {
      "id": "UKN-Y2-274",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Learning disability and autism care",
      "question": "Which response best demonstrates safe practice regarding diagnostic overshadowing?",
      "options": {
        "A": "Act outside competence to avoid delaying care",
        "B": "Give treatment without checking consent, identity or relevant risks",
        "C": "Communicate clearly, maintain dignity and check understanding before proceeding",
        "D": "Ignore the concern unless the patient complains repeatedly"
      },
      "correct_answer": "C",
      "rationale": "Safe UK nursing practice for diagnostic overshadowing requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-275",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Learning disability and autism care",
      "question": "A patient scenario raises concern about communication passport. What should the nurse do first?",
      "options": {
        "A": "Give treatment without checking consent, identity or relevant risks",
        "B": "Ignore the concern unless the patient complains repeatedly",
        "C": "Document only at the end of the week",
        "D": "Prioritise immediate safety using ABCDE or relevant assessment, then seek senior help if needed"
      },
      "correct_answer": "D",
      "rationale": "Safe UK nursing practice for communication passport requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-276",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Learning disability and autism care",
      "question": "In relation to communication passport, what is the safest nursing action?",
      "options": {
        "A": "Act outside competence to avoid delaying care",
        "B": "Give treatment without checking consent, identity or relevant risks",
        "C": "Assess the patient, follow local policy, document clearly and escalate concerns when indicated",
        "D": "Document only at the end of the week"
      },
      "correct_answer": "C",
      "rationale": "Safe UK nursing practice for communication passport requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-277",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Learning disability and autism care",
      "question": "Which response best demonstrates safe practice regarding capacity assessment?",
      "options": {
        "A": "Document only at the end of the week",
        "B": "Act outside competence to avoid delaying care",
        "C": "Communicate clearly, maintain dignity and check understanding before proceeding",
        "D": "Reassure the patient and take no further action despite deterioration"
      },
      "correct_answer": "C",
      "rationale": "Safe UK nursing practice for capacity assessment requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-278",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Renal nursing",
      "question": "Which blood result is most closely associated with acute kidney injury?",
      "options": {
        "A": "Rising creatinine",
        "B": "Reduced cholesterol",
        "C": "Raised haemoglobin",
        "D": "Low body temperature"
      },
      "correct_answer": "A",
      "rationale": "Creatinine is used with urine output and clinical assessment when identifying acute kidney injury."
    },
    {
      "id": "UKN-Y2-279",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Learning disability and autism care",
      "question": "In relation to sensory environment, what is the safest nursing action?",
      "options": {
        "A": "Assess the patient, follow local policy, document clearly and escalate concerns when indicated",
        "B": "Ignore the concern unless the patient complains repeatedly",
        "C": "Act outside competence to avoid delaying care",
        "D": "Ask an untrained person to manage the problem independently"
      },
      "correct_answer": "A",
      "rationale": "Safe UK nursing practice for sensory environment requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-280",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Learning disability and autism care",
      "question": "A patient scenario raises concern about sensory environment. What should the nurse do first?",
      "options": {
        "A": "Prioritise immediate safety using ABCDE or relevant assessment, then seek senior help if needed",
        "B": "Document only at the end of the week",
        "C": "Give treatment without checking consent, identity or relevant risks",
        "D": "Act outside competence to avoid delaying care"
      },
      "correct_answer": "A",
      "rationale": "Safe UK nursing practice for sensory environment requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-281",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Neurology",
      "question": "A patient develops sudden facial droop and arm weakness. What is the priority?",
      "options": {
        "A": "Arrange routine review next week",
        "B": "Treat as possible stroke and escalate urgently",
        "C": "Encourage sleep and reassess tomorrow",
        "D": "Offer a high sugar meal"
      },
      "correct_answer": "B",
      "rationale": "Sudden focal neurological symptoms require urgent stroke assessment."
    },
    {
      "id": "UKN-Y2-282",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Learning disability and autism care",
      "question": "Which response best demonstrates safe practice regarding carer involvement with consent?",
      "options": {
        "A": "Act outside competence to avoid delaying care",
        "B": "Give treatment without checking consent, identity or relevant risks",
        "C": "Ignore the concern unless the patient complains repeatedly",
        "D": "Communicate clearly, maintain dignity and check understanding before proceeding"
      },
      "correct_answer": "D",
      "rationale": "Safe UK nursing practice for carer involvement with consent requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-283",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Learning disability and autism care",
      "question": "A patient scenario raises concern about annual health checks. What should the nurse do first?",
      "options": {
        "A": "Ask an untrained person to manage the problem independently",
        "B": "Prioritise immediate safety using ABCDE or relevant assessment, then seek senior help if needed",
        "C": "Document only at the end of the week",
        "D": "Ignore the concern unless the patient complains repeatedly"
      },
      "correct_answer": "B",
      "rationale": "Safe UK nursing practice for annual health checks requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-284",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Learning disability and autism care",
      "question": "In relation to annual health checks, what is the safest nursing action?",
      "options": {
        "A": "Give treatment without checking consent, identity or relevant risks",
        "B": "Ask an untrained person to manage the problem independently",
        "C": "Document only at the end of the week",
        "D": "Assess the patient, follow local policy, document clearly and escalate concerns when indicated"
      },
      "correct_answer": "D",
      "rationale": "Safe UK nursing practice for annual health checks requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-285",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Learning disability and autism care",
      "question": "Which response best demonstrates safe practice regarding pain expression differences?",
      "options": {
        "A": "Communicate clearly, maintain dignity and check understanding before proceeding",
        "B": "Document only at the end of the week",
        "C": "Act outside competence to avoid delaying care",
        "D": "Ignore the concern unless the patient complains repeatedly"
      },
      "correct_answer": "A",
      "rationale": "Safe UK nursing practice for pain expression differences requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-286",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Clinical assessment",
      "question": "Which finding may indicate fluid overload?",
      "options": {
        "A": "Crackles on chest auscultation and increasing breathlessness",
        "B": "Dry mucous membranes only",
        "C": "Excessive thirst only",
        "D": "Low urine specific gravity only"
      },
      "correct_answer": "A",
      "rationale": "Fluid overload can cause pulmonary congestion and respiratory symptoms."
    },
    {
      "id": "UKN-Y2-287",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Learning disability and autism care",
      "question": "In relation to hospital passport, what is the safest nursing action?",
      "options": {
        "A": "Give treatment without checking consent, identity or relevant risks",
        "B": "Ask an untrained person to manage the problem independently",
        "C": "Act outside competence to avoid delaying care",
        "D": "Assess the patient, follow local policy, document clearly and escalate concerns when indicated"
      },
      "correct_answer": "D",
      "rationale": "Safe UK nursing practice for hospital passport requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-288",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Learning disability and autism care",
      "question": "A patient scenario raises concern about hospital passport. What should the nurse do first?",
      "options": {
        "A": "Act outside competence to avoid delaying care",
        "B": "Prioritise immediate safety using ABCDE or relevant assessment, then seek senior help if needed",
        "C": "Give treatment without checking consent, identity or relevant risks",
        "D": "Reassure the patient and take no further action despite deterioration"
      },
      "correct_answer": "B",
      "rationale": "Safe UK nursing practice for hospital passport requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-289",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Respiratory nursing",
      "question": "Why are peak flow measurements used in asthma care?",
      "options": {
        "A": "To estimate airflow limitation",
        "B": "To diagnose fractures",
        "C": "To measure blood glucose",
        "D": "To replace all clinical observations"
      },
      "correct_answer": "A",
      "rationale": "Peak expiratory flow helps monitor airway obstruction and response to treatment."
    },
    {
      "id": "UKN-Y2-290",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Learning disability and autism care",
      "question": "Which response best demonstrates safe practice regarding respectful terminology?",
      "options": {
        "A": "Reassure the patient and take no further action despite deterioration",
        "B": "Communicate clearly, maintain dignity and check understanding before proceeding",
        "C": "Document only at the end of the week",
        "D": "Ask an untrained person to manage the problem independently"
      },
      "correct_answer": "B",
      "rationale": "Safe UK nursing practice for respectful terminology requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-291",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Public health and health promotion",
      "question": "In relation to smoking cessation, what is the safest nursing action?",
      "options": {
        "A": "Document only at the end of the week",
        "B": "Give treatment without checking consent, identity or relevant risks",
        "C": "Reassure the patient and take no further action despite deterioration",
        "D": "Assess the patient, follow local policy, document clearly and escalate concerns when indicated"
      },
      "correct_answer": "D",
      "rationale": "Safe UK nursing practice for smoking cessation requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-292",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Public health and health promotion",
      "question": "A patient scenario raises concern about smoking cessation. What should the nurse do first?",
      "options": {
        "A": "Prioritise immediate safety using ABCDE or relevant assessment, then seek senior help if needed",
        "B": "Act outside competence to avoid delaying care",
        "C": "Give treatment without checking consent, identity or relevant risks",
        "D": "Ignore the concern unless the patient complains repeatedly"
      },
      "correct_answer": "A",
      "rationale": "Safe UK nursing practice for smoking cessation requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-293",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Cardiovascular nursing",
      "question": "A patient prescribed digoxin reports nausea and visual disturbances. What should the nurse consider?",
      "options": {
        "A": "A possible sign of digoxin toxicity requiring assessment",
        "B": "A normal expected effect requiring no action",
        "C": "Evidence that the dose should be doubled",
        "D": "A reason to stop all medication permanently"
      },
      "correct_answer": "A",
      "rationale": "Digoxin toxicity may present with gastrointestinal symptoms and visual disturbance; assessment and escalation are required."
    },
    {
      "id": "UKN-Y2-294",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Public health and health promotion",
      "question": "Which response best demonstrates safe practice regarding alcohol brief advice?",
      "options": {
        "A": "Ignore the concern unless the patient complains repeatedly",
        "B": "Act outside competence to avoid delaying care",
        "C": "Communicate clearly, maintain dignity and check understanding before proceeding",
        "D": "Document only at the end of the week"
      },
      "correct_answer": "C",
      "rationale": "Safe UK nursing practice for alcohol brief advice requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-295",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Public health and health promotion",
      "question": "A patient scenario raises concern about vaccination. What should the nurse do first?",
      "options": {
        "A": "Act outside competence to avoid delaying care",
        "B": "Document only at the end of the week",
        "C": "Reassure the patient and take no further action despite deterioration",
        "D": "Prioritise immediate safety using ABCDE or relevant assessment, then seek senior help if needed"
      },
      "correct_answer": "D",
      "rationale": "Safe UK nursing practice for vaccination requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-296",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Public health and health promotion",
      "question": "In relation to vaccination, what is the safest nursing action?",
      "options": {
        "A": "Assess the patient, follow local policy, document clearly and escalate concerns when indicated",
        "B": "Ask an untrained person to manage the problem independently",
        "C": "Give treatment without checking consent, identity or relevant risks",
        "D": "Act outside competence to avoid delaying care"
      },
      "correct_answer": "A",
      "rationale": "Safe UK nursing practice for vaccination requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-297",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Public health and health promotion",
      "question": "Which response best demonstrates safe practice regarding screening programmes?",
      "options": {
        "A": "Ignore the concern unless the patient complains repeatedly",
        "B": "Document only at the end of the week",
        "C": "Communicate clearly, maintain dignity and check understanding before proceeding",
        "D": "Give treatment without checking consent, identity or relevant risks"
      },
      "correct_answer": "C",
      "rationale": "Safe UK nursing practice for screening programmes requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-298",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Renal nursing",
      "question": "Which blood result is most closely associated with acute kidney injury?",
      "options": {
        "A": "Rising creatinine",
        "B": "Reduced cholesterol",
        "C": "Raised haemoglobin",
        "D": "Low body temperature"
      },
      "correct_answer": "A",
      "rationale": "Creatinine is used with urine output and clinical assessment when identifying acute kidney injury."
    },
    {
      "id": "UKN-Y2-299",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Public health and health promotion",
      "question": "In relation to obesity support, what is the safest nursing action?",
      "options": {
        "A": "Document only at the end of the week",
        "B": "Ignore the concern unless the patient complains repeatedly",
        "C": "Assess the patient, follow local policy, document clearly and escalate concerns when indicated",
        "D": "Give treatment without checking consent, identity or relevant risks"
      },
      "correct_answer": "C",
      "rationale": "Safe UK nursing practice for obesity support requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-300",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Public health and health promotion",
      "question": "A patient scenario raises concern about obesity support. What should the nurse do first?",
      "options": {
        "A": "Give treatment without checking consent, identity or relevant risks",
        "B": "Ask an untrained person to manage the problem independently",
        "C": "Reassure the patient and take no further action despite deterioration",
        "D": "Prioritise immediate safety using ABCDE or relevant assessment, then seek senior help if needed"
      },
      "correct_answer": "D",
      "rationale": "Safe UK nursing practice for obesity support requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-301",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Neurology",
      "question": "A patient develops sudden facial droop and arm weakness. What is the priority?",
      "options": {
        "A": "Arrange routine review next week",
        "B": "Treat as possible stroke and escalate urgently",
        "C": "Encourage sleep and reassess tomorrow",
        "D": "Offer a high sugar meal"
      },
      "correct_answer": "B",
      "rationale": "Sudden focal neurological symptoms require urgent stroke assessment."
    },
    {
      "id": "UKN-Y2-302",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Public health and health promotion",
      "question": "Which response best demonstrates safe practice regarding physical activity?",
      "options": {
        "A": "Act outside competence to avoid delaying care",
        "B": "Ask an untrained person to manage the problem independently",
        "C": "Communicate clearly, maintain dignity and check understanding before proceeding",
        "D": "Ignore the concern unless the patient complains repeatedly"
      },
      "correct_answer": "C",
      "rationale": "Safe UK nursing practice for physical activity requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-303",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Public health and health promotion",
      "question": "A patient scenario raises concern about sexual health signposting. What should the nurse do first?",
      "options": {
        "A": "Reassure the patient and take no further action despite deterioration",
        "B": "Ignore the concern unless the patient complains repeatedly",
        "C": "Act outside competence to avoid delaying care",
        "D": "Prioritise immediate safety using ABCDE or relevant assessment, then seek senior help if needed"
      },
      "correct_answer": "D",
      "rationale": "Safe UK nursing practice for sexual health signposting requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-304",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Public health and health promotion",
      "question": "In relation to sexual health signposting, what is the safest nursing action?",
      "options": {
        "A": "Act outside competence to avoid delaying care",
        "B": "Document only at the end of the week",
        "C": "Give treatment without checking consent, identity or relevant risks",
        "D": "Assess the patient, follow local policy, document clearly and escalate concerns when indicated"
      },
      "correct_answer": "D",
      "rationale": "Safe UK nursing practice for sexual health signposting requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-305",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Public health and health promotion",
      "question": "Which response best demonstrates safe practice regarding health inequalities?",
      "options": {
        "A": "Reassure the patient and take no further action despite deterioration",
        "B": "Communicate clearly, maintain dignity and check understanding before proceeding",
        "C": "Document only at the end of the week",
        "D": "Act outside competence to avoid delaying care"
      },
      "correct_answer": "B",
      "rationale": "Safe UK nursing practice for health inequalities requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-306",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Clinical assessment",
      "question": "Which finding may indicate fluid overload?",
      "options": {
        "A": "Crackles on chest auscultation and increasing breathlessness",
        "B": "Dry mucous membranes only",
        "C": "Excessive thirst only",
        "D": "Low urine specific gravity only"
      },
      "correct_answer": "A",
      "rationale": "Fluid overload can cause pulmonary congestion and respiratory symptoms."
    },
    {
      "id": "UKN-Y2-307",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Public health and health promotion",
      "question": "In relation to Making Every Contact Count, what is the safest nursing action?",
      "options": {
        "A": "Give treatment without checking consent, identity or relevant risks",
        "B": "Assess the patient, follow local policy, document clearly and escalate concerns when indicated",
        "C": "Act outside competence to avoid delaying care",
        "D": "Document only at the end of the week"
      },
      "correct_answer": "B",
      "rationale": "Safe UK nursing practice for Making Every Contact Count requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-308",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Public health and health promotion",
      "question": "A patient scenario raises concern about Making Every Contact Count. What should the nurse do first?",
      "options": {
        "A": "Ignore the concern unless the patient complains repeatedly",
        "B": "Give treatment without checking consent, identity or relevant risks",
        "C": "Document only at the end of the week",
        "D": "Prioritise immediate safety using ABCDE or relevant assessment, then seek senior help if needed"
      },
      "correct_answer": "D",
      "rationale": "Safe UK nursing practice for Making Every Contact Count requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-309",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Respiratory nursing",
      "question": "Why are peak flow measurements used in asthma care?",
      "options": {
        "A": "To estimate airflow limitation",
        "B": "To diagnose fractures",
        "C": "To measure blood glucose",
        "D": "To replace all clinical observations"
      },
      "correct_answer": "A",
      "rationale": "Peak expiratory flow helps monitor airway obstruction and response to treatment."
    },
    {
      "id": "UKN-Y2-310",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Public health and health promotion",
      "question": "Which response best demonstrates safe practice regarding social determinants?",
      "options": {
        "A": "Give treatment without checking consent, identity or relevant risks",
        "B": "Document only at the end of the week",
        "C": "Act outside competence to avoid delaying care",
        "D": "Communicate clearly, maintain dignity and check understanding before proceeding"
      },
      "correct_answer": "D",
      "rationale": "Safe UK nursing practice for social determinants requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-311",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Evidence-based practice and research",
      "question": "In relation to hierarchy of evidence, what is the safest nursing action?",
      "options": {
        "A": "Ask an untrained person to manage the problem independently",
        "B": "Give treatment without checking consent, identity or relevant risks",
        "C": "Assess the patient, follow local policy, document clearly and escalate concerns when indicated",
        "D": "Document only at the end of the week"
      },
      "correct_answer": "C",
      "rationale": "Safe UK nursing practice for hierarchy of evidence requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-312",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Evidence-based practice and research",
      "question": "A patient scenario raises concern about hierarchy of evidence. What should the nurse do first?",
      "options": {
        "A": "Reassure the patient and take no further action despite deterioration",
        "B": "Prioritise immediate safety using ABCDE or relevant assessment, then seek senior help if needed",
        "C": "Ignore the concern unless the patient complains repeatedly",
        "D": "Document only at the end of the week"
      },
      "correct_answer": "B",
      "rationale": "Safe UK nursing practice for hierarchy of evidence requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-313",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Cardiovascular nursing",
      "question": "A patient prescribed digoxin reports nausea and visual disturbances. What should the nurse consider?",
      "options": {
        "A": "A possible sign of digoxin toxicity requiring assessment",
        "B": "A normal expected effect requiring no action",
        "C": "Evidence that the dose should be doubled",
        "D": "A reason to stop all medication permanently"
      },
      "correct_answer": "A",
      "rationale": "Digoxin toxicity may present with gastrointestinal symptoms and visual disturbance; assessment and escalation are required."
    },
    {
      "id": "UKN-Y2-314",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Evidence-based practice and research",
      "question": "Which response best demonstrates safe practice regarding informed consent research?",
      "options": {
        "A": "Ignore the concern unless the patient complains repeatedly",
        "B": "Give treatment without checking consent, identity or relevant risks",
        "C": "Communicate clearly, maintain dignity and check understanding before proceeding",
        "D": "Document only at the end of the week"
      },
      "correct_answer": "C",
      "rationale": "Safe UK nursing practice for informed consent research requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-315",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Evidence-based practice and research",
      "question": "A patient scenario raises concern about audit vs research. What should the nurse do first?",
      "options": {
        "A": "Give treatment without checking consent, identity or relevant risks",
        "B": "Ignore the concern unless the patient complains repeatedly",
        "C": "Prioritise immediate safety using ABCDE or relevant assessment, then seek senior help if needed",
        "D": "Act outside competence to avoid delaying care"
      },
      "correct_answer": "C",
      "rationale": "Safe UK nursing practice for audit vs research requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-316",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Evidence-based practice and research",
      "question": "In relation to audit vs research, what is the safest nursing action?",
      "options": {
        "A": "Ignore the concern unless the patient complains repeatedly",
        "B": "Reassure the patient and take no further action despite deterioration",
        "C": "Assess the patient, follow local policy, document clearly and escalate concerns when indicated",
        "D": "Act outside competence to avoid delaying care"
      },
      "correct_answer": "C",
      "rationale": "Safe UK nursing practice for audit vs research requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-317",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Evidence-based practice and research",
      "question": "Which response best demonstrates safe practice regarding confounding?",
      "options": {
        "A": "Act outside competence to avoid delaying care",
        "B": "Communicate clearly, maintain dignity and check understanding before proceeding",
        "C": "Reassure the patient and take no further action despite deterioration",
        "D": "Give treatment without checking consent, identity or relevant risks"
      },
      "correct_answer": "B",
      "rationale": "Safe UK nursing practice for confounding requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-318",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Renal nursing",
      "question": "Which blood result is most closely associated with acute kidney injury?",
      "options": {
        "A": "Rising creatinine",
        "B": "Reduced cholesterol",
        "C": "Raised haemoglobin",
        "D": "Low body temperature"
      },
      "correct_answer": "A",
      "rationale": "Creatinine is used with urine output and clinical assessment when identifying acute kidney injury."
    },
    {
      "id": "UKN-Y2-319",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Evidence-based practice and research",
      "question": "In relation to qualitative interviews, what is the safest nursing action?",
      "options": {
        "A": "Assess the patient, follow local policy, document clearly and escalate concerns when indicated",
        "B": "Give treatment without checking consent, identity or relevant risks",
        "C": "Ignore the concern unless the patient complains repeatedly",
        "D": "Document only at the end of the week"
      },
      "correct_answer": "A",
      "rationale": "Safe UK nursing practice for qualitative interviews requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-320",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Evidence-based practice and research",
      "question": "A patient scenario raises concern about qualitative interviews. What should the nurse do first?",
      "options": {
        "A": "Ignore the concern unless the patient complains repeatedly",
        "B": "Reassure the patient and take no further action despite deterioration",
        "C": "Act outside competence to avoid delaying care",
        "D": "Prioritise immediate safety using ABCDE or relevant assessment, then seek senior help if needed"
      },
      "correct_answer": "D",
      "rationale": "Safe UK nursing practice for qualitative interviews requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-321",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Neurology",
      "question": "A patient develops sudden facial droop and arm weakness. What is the priority?",
      "options": {
        "A": "Arrange routine review next week",
        "B": "Treat as possible stroke and escalate urgently",
        "C": "Encourage sleep and reassess tomorrow",
        "D": "Offer a high sugar meal"
      },
      "correct_answer": "B",
      "rationale": "Sudden focal neurological symptoms require urgent stroke assessment."
    },
    {
      "id": "UKN-Y2-322",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Evidence-based practice and research",
      "question": "Which response best demonstrates safe practice regarding randomised controlled trial?",
      "options": {
        "A": "Ignore the concern unless the patient complains repeatedly",
        "B": "Document only at the end of the week",
        "C": "Give treatment without checking consent, identity or relevant risks",
        "D": "Communicate clearly, maintain dignity and check understanding before proceeding"
      },
      "correct_answer": "D",
      "rationale": "Safe UK nursing practice for randomised controlled trial requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-323",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Evidence-based practice and research",
      "question": "A patient scenario raises concern about systematic review. What should the nurse do first?",
      "options": {
        "A": "Prioritise immediate safety using ABCDE or relevant assessment, then seek senior help if needed",
        "B": "Document only at the end of the week",
        "C": "Give treatment without checking consent, identity or relevant risks",
        "D": "Act outside competence to avoid delaying care"
      },
      "correct_answer": "A",
      "rationale": "Safe UK nursing practice for systematic review requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-324",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Evidence-based practice and research",
      "question": "In relation to systematic review, what is the safest nursing action?",
      "options": {
        "A": "Give treatment without checking consent, identity or relevant risks",
        "B": "Ask an untrained person to manage the problem independently",
        "C": "Assess the patient, follow local policy, document clearly and escalate concerns when indicated",
        "D": "Ignore the concern unless the patient complains repeatedly"
      },
      "correct_answer": "C",
      "rationale": "Safe UK nursing practice for systematic review requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-325",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Evidence-based practice and research",
      "question": "Which response best demonstrates safe practice regarding validity?",
      "options": {
        "A": "Ignore the concern unless the patient complains repeatedly",
        "B": "Give treatment without checking consent, identity or relevant risks",
        "C": "Communicate clearly, maintain dignity and check understanding before proceeding",
        "D": "Ask an untrained person to manage the problem independently"
      },
      "correct_answer": "C",
      "rationale": "Safe UK nursing practice for validity requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-326",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Clinical assessment",
      "question": "Which finding may indicate fluid overload?",
      "options": {
        "A": "Crackles on chest auscultation and increasing breathlessness",
        "B": "Dry mucous membranes only",
        "C": "Excessive thirst only",
        "D": "Low urine specific gravity only"
      },
      "correct_answer": "A",
      "rationale": "Fluid overload can cause pulmonary congestion and respiratory symptoms."
    },
    {
      "id": "UKN-Y2-327",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Evidence-based practice and research",
      "question": "In relation to reliability, what is the safest nursing action?",
      "options": {
        "A": "Assess the patient, follow local policy, document clearly and escalate concerns when indicated",
        "B": "Document only at the end of the week",
        "C": "Ignore the concern unless the patient complains repeatedly",
        "D": "Reassure the patient and take no further action despite deterioration"
      },
      "correct_answer": "A",
      "rationale": "Safe UK nursing practice for reliability requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-328",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Evidence-based practice and research",
      "question": "A patient scenario raises concern about reliability. What should the nurse do first?",
      "options": {
        "A": "Document only at the end of the week",
        "B": "Ask an untrained person to manage the problem independently",
        "C": "Ignore the concern unless the patient complains repeatedly",
        "D": "Prioritise immediate safety using ABCDE or relevant assessment, then seek senior help if needed"
      },
      "correct_answer": "D",
      "rationale": "Safe UK nursing practice for reliability requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-329",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Respiratory nursing",
      "question": "Why are peak flow measurements used in asthma care?",
      "options": {
        "A": "To estimate airflow limitation",
        "B": "To diagnose fractures",
        "C": "To measure blood glucose",
        "D": "To replace all clinical observations"
      },
      "correct_answer": "A",
      "rationale": "Peak expiratory flow helps monitor airway obstruction and response to treatment."
    },
    {
      "id": "UKN-Y2-330",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Evidence-based practice and research",
      "question": "Which response best demonstrates safe practice regarding applying evidence to practice?",
      "options": {
        "A": "Act outside competence to avoid delaying care",
        "B": "Ask an untrained person to manage the problem independently",
        "C": "Communicate clearly, maintain dignity and check understanding before proceeding",
        "D": "Give treatment without checking consent, identity or relevant risks"
      },
      "correct_answer": "C",
      "rationale": "Safe UK nursing practice for applying evidence to practice requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-331",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Communication and teamwork",
      "question": "In relation to SBAR handover, what is the safest nursing action?",
      "options": {
        "A": "Assess the patient, follow local policy, document clearly and escalate concerns when indicated",
        "B": "Reassure the patient and take no further action despite deterioration",
        "C": "Ask an untrained person to manage the problem independently",
        "D": "Act outside competence to avoid delaying care"
      },
      "correct_answer": "A",
      "rationale": "Safe UK nursing practice for SBAR handover requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-332",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Communication and teamwork",
      "question": "A patient scenario raises concern about SBAR handover. What should the nurse do first?",
      "options": {
        "A": "Reassure the patient and take no further action despite deterioration",
        "B": "Prioritise immediate safety using ABCDE or relevant assessment, then seek senior help if needed",
        "C": "Ignore the concern unless the patient complains repeatedly",
        "D": "Document only at the end of the week"
      },
      "correct_answer": "B",
      "rationale": "Safe UK nursing practice for SBAR handover requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-333",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Cardiovascular nursing",
      "question": "A patient prescribed digoxin reports nausea and visual disturbances. What should the nurse consider?",
      "options": {
        "A": "A possible sign of digoxin toxicity requiring assessment",
        "B": "A normal expected effect requiring no action",
        "C": "Evidence that the dose should be doubled",
        "D": "A reason to stop all medication permanently"
      },
      "correct_answer": "A",
      "rationale": "Digoxin toxicity may present with gastrointestinal symptoms and visual disturbance; assessment and escalation are required."
    },
    {
      "id": "UKN-Y2-334",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Communication and teamwork",
      "question": "Which response best demonstrates safe practice regarding closed-loop communication?",
      "options": {
        "A": "Give treatment without checking consent, identity or relevant risks",
        "B": "Ignore the concern unless the patient complains repeatedly",
        "C": "Act outside competence to avoid delaying care",
        "D": "Communicate clearly, maintain dignity and check understanding before proceeding"
      },
      "correct_answer": "D",
      "rationale": "Safe UK nursing practice for closed-loop communication requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-335",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Communication and teamwork",
      "question": "A patient scenario raises concern about active listening. What should the nurse do first?",
      "options": {
        "A": "Prioritise immediate safety using ABCDE or relevant assessment, then seek senior help if needed",
        "B": "Act outside competence to avoid delaying care",
        "C": "Ignore the concern unless the patient complains repeatedly",
        "D": "Give treatment without checking consent, identity or relevant risks"
      },
      "correct_answer": "A",
      "rationale": "Safe UK nursing practice for active listening requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-336",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Communication and teamwork",
      "question": "In relation to active listening, what is the safest nursing action?",
      "options": {
        "A": "Ask an untrained person to manage the problem independently",
        "B": "Assess the patient, follow local policy, document clearly and escalate concerns when indicated",
        "C": "Act outside competence to avoid delaying care",
        "D": "Reassure the patient and take no further action despite deterioration"
      },
      "correct_answer": "B",
      "rationale": "Safe UK nursing practice for active listening requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-337",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Communication and teamwork",
      "question": "Which response best demonstrates safe practice regarding interpreter use?",
      "options": {
        "A": "Communicate clearly, maintain dignity and check understanding before proceeding",
        "B": "Ignore the concern unless the patient complains repeatedly",
        "C": "Ask an untrained person to manage the problem independently",
        "D": "Reassure the patient and take no further action despite deterioration"
      },
      "correct_answer": "A",
      "rationale": "Safe UK nursing practice for interpreter use requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-338",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Renal nursing",
      "question": "Which blood result is most closely associated with acute kidney injury?",
      "options": {
        "A": "Rising creatinine",
        "B": "Reduced cholesterol",
        "C": "Raised haemoglobin",
        "D": "Low body temperature"
      },
      "correct_answer": "A",
      "rationale": "Creatinine is used with urine output and clinical assessment when identifying acute kidney injury."
    },
    {
      "id": "UKN-Y2-339",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Communication and teamwork",
      "question": "In relation to breaking bad news support, what is the safest nursing action?",
      "options": {
        "A": "Ask an untrained person to manage the problem independently",
        "B": "Give treatment without checking consent, identity or relevant risks",
        "C": "Assess the patient, follow local policy, document clearly and escalate concerns when indicated",
        "D": "Act outside competence to avoid delaying care"
      },
      "correct_answer": "C",
      "rationale": "Safe UK nursing practice for breaking bad news support requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-340",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Communication and teamwork",
      "question": "A patient scenario raises concern about breaking bad news support. What should the nurse do first?",
      "options": {
        "A": "Ask an untrained person to manage the problem independently",
        "B": "Act outside competence to avoid delaying care",
        "C": "Prioritise immediate safety using ABCDE or relevant assessment, then seek senior help if needed",
        "D": "Document only at the end of the week"
      },
      "correct_answer": "C",
      "rationale": "Safe UK nursing practice for breaking bad news support requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-341",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Neurology",
      "question": "A patient develops sudden facial droop and arm weakness. What is the priority?",
      "options": {
        "A": "Arrange routine review next week",
        "B": "Treat as possible stroke and escalate urgently",
        "C": "Encourage sleep and reassess tomorrow",
        "D": "Offer a high sugar meal"
      },
      "correct_answer": "B",
      "rationale": "Sudden focal neurological symptoms require urgent stroke assessment."
    },
    {
      "id": "UKN-Y2-342",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Communication and teamwork",
      "question": "Which response best demonstrates safe practice regarding handover safety?",
      "options": {
        "A": "Ask an untrained person to manage the problem independently",
        "B": "Ignore the concern unless the patient complains repeatedly",
        "C": "Communicate clearly, maintain dignity and check understanding before proceeding",
        "D": "Reassure the patient and take no further action despite deterioration"
      },
      "correct_answer": "C",
      "rationale": "Safe UK nursing practice for handover safety requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-343",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Communication and teamwork",
      "question": "A patient scenario raises concern about multidisciplinary team. What should the nurse do first?",
      "options": {
        "A": "Ask an untrained person to manage the problem independently",
        "B": "Ignore the concern unless the patient complains repeatedly",
        "C": "Prioritise immediate safety using ABCDE or relevant assessment, then seek senior help if needed",
        "D": "Document only at the end of the week"
      },
      "correct_answer": "C",
      "rationale": "Safe UK nursing practice for multidisciplinary team requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-344",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Communication and teamwork",
      "question": "In relation to multidisciplinary team, what is the safest nursing action?",
      "options": {
        "A": "Reassure the patient and take no further action despite deterioration",
        "B": "Ask an untrained person to manage the problem independently",
        "C": "Act outside competence to avoid delaying care",
        "D": "Assess the patient, follow local policy, document clearly and escalate concerns when indicated"
      },
      "correct_answer": "D",
      "rationale": "Safe UK nursing practice for multidisciplinary team requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-345",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Communication and teamwork",
      "question": "Which response best demonstrates safe practice regarding escalating conflict?",
      "options": {
        "A": "Reassure the patient and take no further action despite deterioration",
        "B": "Give treatment without checking consent, identity or relevant risks",
        "C": "Document only at the end of the week",
        "D": "Communicate clearly, maintain dignity and check understanding before proceeding"
      },
      "correct_answer": "D",
      "rationale": "Safe UK nursing practice for escalating conflict requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-346",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Clinical assessment",
      "question": "Which finding may indicate fluid overload?",
      "options": {
        "A": "Crackles on chest auscultation and increasing breathlessness",
        "B": "Dry mucous membranes only",
        "C": "Excessive thirst only",
        "D": "Low urine specific gravity only"
      },
      "correct_answer": "A",
      "rationale": "Fluid overload can cause pulmonary congestion and respiratory symptoms."
    },
    {
      "id": "UKN-Y2-347",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Communication and teamwork",
      "question": "In relation to documentation in teamwork, what is the safest nursing action?",
      "options": {
        "A": "Document only at the end of the week",
        "B": "Ignore the concern unless the patient complains repeatedly",
        "C": "Assess the patient, follow local policy, document clearly and escalate concerns when indicated",
        "D": "Act outside competence to avoid delaying care"
      },
      "correct_answer": "C",
      "rationale": "Safe UK nursing practice for documentation in teamwork requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-348",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Communication and teamwork",
      "question": "A patient scenario raises concern about documentation in teamwork. What should the nurse do first?",
      "options": {
        "A": "Give treatment without checking consent, identity or relevant risks",
        "B": "Act outside competence to avoid delaying care",
        "C": "Prioritise immediate safety using ABCDE or relevant assessment, then seek senior help if needed",
        "D": "Document only at the end of the week"
      },
      "correct_answer": "C",
      "rationale": "Safe UK nursing practice for documentation in teamwork requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-349",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Respiratory nursing",
      "question": "Why are peak flow measurements used in asthma care?",
      "options": {
        "A": "To estimate airflow limitation",
        "B": "To diagnose fractures",
        "C": "To measure blood glucose",
        "D": "To replace all clinical observations"
      },
      "correct_answer": "A",
      "rationale": "Peak expiratory flow helps monitor airway obstruction and response to treatment."
    },
    {
      "id": "UKN-Y2-350",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Communication and teamwork",
      "question": "Which response best demonstrates safe practice regarding patient teach-back?",
      "options": {
        "A": "Give treatment without checking consent, identity or relevant risks",
        "B": "Act outside competence to avoid delaying care",
        "C": "Reassure the patient and take no further action despite deterioration",
        "D": "Communicate clearly, maintain dignity and check understanding before proceeding"
      },
      "correct_answer": "D",
      "rationale": "Safe UK nursing practice for patient teach-back requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-351",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Fluids and electrolytes",
      "question": "In relation to dehydration, what is the safest nursing action?",
      "options": {
        "A": "Assess the patient, follow local policy, document clearly and escalate concerns when indicated",
        "B": "Give treatment without checking consent, identity or relevant risks",
        "C": "Ask an untrained person to manage the problem independently",
        "D": "Document only at the end of the week"
      },
      "correct_answer": "A",
      "rationale": "Safe UK nursing practice for dehydration requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-352",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Fluids and electrolytes",
      "question": "A patient scenario raises concern about dehydration. What should the nurse do first?",
      "options": {
        "A": "Prioritise immediate safety using ABCDE or relevant assessment, then seek senior help if needed",
        "B": "Document only at the end of the week",
        "C": "Give treatment without checking consent, identity or relevant risks",
        "D": "Ignore the concern unless the patient complains repeatedly"
      },
      "correct_answer": "A",
      "rationale": "Safe UK nursing practice for dehydration requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-353",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Cardiovascular nursing",
      "question": "A patient prescribed digoxin reports nausea and visual disturbances. What should the nurse consider?",
      "options": {
        "A": "A possible sign of digoxin toxicity requiring assessment",
        "B": "A normal expected effect requiring no action",
        "C": "Evidence that the dose should be doubled",
        "D": "A reason to stop all medication permanently"
      },
      "correct_answer": "A",
      "rationale": "Digoxin toxicity may present with gastrointestinal symptoms and visual disturbance; assessment and escalation are required."
    },
    {
      "id": "UKN-Y2-354",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Fluids and electrolytes",
      "question": "Which response best demonstrates safe practice regarding fluid overload?",
      "options": {
        "A": "Ignore the concern unless the patient complains repeatedly",
        "B": "Communicate clearly, maintain dignity and check understanding before proceeding",
        "C": "Give treatment without checking consent, identity or relevant risks",
        "D": "Act outside competence to avoid delaying care"
      },
      "correct_answer": "B",
      "rationale": "Safe UK nursing practice for fluid overload requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-355",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Fluids and electrolytes",
      "question": "A patient scenario raises concern about hyponatraemia. What should the nurse do first?",
      "options": {
        "A": "Ignore the concern unless the patient complains repeatedly",
        "B": "Give treatment without checking consent, identity or relevant risks",
        "C": "Prioritise immediate safety using ABCDE or relevant assessment, then seek senior help if needed",
        "D": "Document only at the end of the week"
      },
      "correct_answer": "C",
      "rationale": "Safe UK nursing practice for hyponatraemia requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-356",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Fluids and electrolytes",
      "question": "In relation to hyponatraemia, what is the safest nursing action?",
      "options": {
        "A": "Ask an untrained person to manage the problem independently",
        "B": "Ignore the concern unless the patient complains repeatedly",
        "C": "Assess the patient, follow local policy, document clearly and escalate concerns when indicated",
        "D": "Act outside competence to avoid delaying care"
      },
      "correct_answer": "C",
      "rationale": "Safe UK nursing practice for hyponatraemia requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-357",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Fluids and electrolytes",
      "question": "Which response best demonstrates safe practice regarding hyperkalaemia?",
      "options": {
        "A": "Communicate clearly, maintain dignity and check understanding before proceeding",
        "B": "Reassure the patient and take no further action despite deterioration",
        "C": "Act outside competence to avoid delaying care",
        "D": "Ask an untrained person to manage the problem independently"
      },
      "correct_answer": "A",
      "rationale": "Safe UK nursing practice for hyperkalaemia requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-358",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Renal nursing",
      "question": "Which blood result is most closely associated with acute kidney injury?",
      "options": {
        "A": "Rising creatinine",
        "B": "Reduced cholesterol",
        "C": "Raised haemoglobin",
        "D": "Low body temperature"
      },
      "correct_answer": "A",
      "rationale": "Creatinine is used with urine output and clinical assessment when identifying acute kidney injury."
    },
    {
      "id": "UKN-Y2-359",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Fluids and electrolytes",
      "question": "In relation to IV fluid monitoring, what is the safest nursing action?",
      "options": {
        "A": "Act outside competence to avoid delaying care",
        "B": "Document only at the end of the week",
        "C": "Assess the patient, follow local policy, document clearly and escalate concerns when indicated",
        "D": "Give treatment without checking consent, identity or relevant risks"
      },
      "correct_answer": "C",
      "rationale": "Safe UK nursing practice for IV fluid monitoring requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-360",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Fluids and electrolytes",
      "question": "A patient scenario raises concern about IV fluid monitoring. What should the nurse do first?",
      "options": {
        "A": "Document only at the end of the week",
        "B": "Give treatment without checking consent, identity or relevant risks",
        "C": "Ignore the concern unless the patient complains repeatedly",
        "D": "Prioritise immediate safety using ABCDE or relevant assessment, then seek senior help if needed"
      },
      "correct_answer": "D",
      "rationale": "Safe UK nursing practice for IV fluid monitoring requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-361",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Neurology",
      "question": "A patient develops sudden facial droop and arm weakness. What is the priority?",
      "options": {
        "A": "Arrange routine review next week",
        "B": "Treat as possible stroke and escalate urgently",
        "C": "Encourage sleep and reassess tomorrow",
        "D": "Offer a high sugar meal"
      },
      "correct_answer": "B",
      "rationale": "Sudden focal neurological symptoms require urgent stroke assessment."
    },
    {
      "id": "UKN-Y2-362",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Fluids and electrolytes",
      "question": "Which response best demonstrates safe practice regarding strict fluid balance?",
      "options": {
        "A": "Reassure the patient and take no further action despite deterioration",
        "B": "Communicate clearly, maintain dignity and check understanding before proceeding",
        "C": "Act outside competence to avoid delaying care",
        "D": "Ignore the concern unless the patient complains repeatedly"
      },
      "correct_answer": "B",
      "rationale": "Safe UK nursing practice for strict fluid balance requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-363",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Fluids and electrolytes",
      "question": "A patient scenario raises concern about daily weights. What should the nurse do first?",
      "options": {
        "A": "Ignore the concern unless the patient complains repeatedly",
        "B": "Document only at the end of the week",
        "C": "Prioritise immediate safety using ABCDE or relevant assessment, then seek senior help if needed",
        "D": "Give treatment without checking consent, identity or relevant risks"
      },
      "correct_answer": "C",
      "rationale": "Safe UK nursing practice for daily weights requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-364",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Fluids and electrolytes",
      "question": "In relation to daily weights, what is the safest nursing action?",
      "options": {
        "A": "Ask an untrained person to manage the problem independently",
        "B": "Ignore the concern unless the patient complains repeatedly",
        "C": "Assess the patient, follow local policy, document clearly and escalate concerns when indicated",
        "D": "Reassure the patient and take no further action despite deterioration"
      },
      "correct_answer": "C",
      "rationale": "Safe UK nursing practice for daily weights requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-365",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Fluids and electrolytes",
      "question": "Which response best demonstrates safe practice regarding oedema?",
      "options": {
        "A": "Give treatment without checking consent, identity or relevant risks",
        "B": "Communicate clearly, maintain dignity and check understanding before proceeding",
        "C": "Reassure the patient and take no further action despite deterioration",
        "D": "Document only at the end of the week"
      },
      "correct_answer": "B",
      "rationale": "Safe UK nursing practice for oedema requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-366",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Clinical assessment",
      "question": "Which finding may indicate fluid overload?",
      "options": {
        "A": "Crackles on chest auscultation and increasing breathlessness",
        "B": "Dry mucous membranes only",
        "C": "Excessive thirst only",
        "D": "Low urine specific gravity only"
      },
      "correct_answer": "A",
      "rationale": "Fluid overload can cause pulmonary congestion and respiratory symptoms."
    },
    {
      "id": "UKN-Y2-367",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Fluids and electrolytes",
      "question": "In relation to vomiting losses, what is the safest nursing action?",
      "options": {
        "A": "Ignore the concern unless the patient complains repeatedly",
        "B": "Assess the patient, follow local policy, document clearly and escalate concerns when indicated",
        "C": "Act outside competence to avoid delaying care",
        "D": "Reassure the patient and take no further action despite deterioration"
      },
      "correct_answer": "B",
      "rationale": "Safe UK nursing practice for vomiting losses requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-368",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Fluids and electrolytes",
      "question": "A patient scenario raises concern about vomiting losses. What should the nurse do first?",
      "options": {
        "A": "Prioritise immediate safety using ABCDE or relevant assessment, then seek senior help if needed",
        "B": "Reassure the patient and take no further action despite deterioration",
        "C": "Ask an untrained person to manage the problem independently",
        "D": "Give treatment without checking consent, identity or relevant risks"
      },
      "correct_answer": "A",
      "rationale": "Safe UK nursing practice for vomiting losses requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-369",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Respiratory nursing",
      "question": "Why are peak flow measurements used in asthma care?",
      "options": {
        "A": "To estimate airflow limitation",
        "B": "To diagnose fractures",
        "C": "To measure blood glucose",
        "D": "To replace all clinical observations"
      },
      "correct_answer": "A",
      "rationale": "Peak expiratory flow helps monitor airway obstruction and response to treatment."
    },
    {
      "id": "UKN-Y2-370",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Fluids and electrolytes",
      "question": "Which response best demonstrates safe practice regarding renal impairment fluids?",
      "options": {
        "A": "Ignore the concern unless the patient complains repeatedly",
        "B": "Ask an untrained person to manage the problem independently",
        "C": "Give treatment without checking consent, identity or relevant risks",
        "D": "Communicate clearly, maintain dignity and check understanding before proceeding"
      },
      "correct_answer": "D",
      "rationale": "Safe UK nursing practice for renal impairment fluids requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-371",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Haematology and oncology basics",
      "question": "In relation to anaemia symptoms, what is the safest nursing action?",
      "options": {
        "A": "Ask an untrained person to manage the problem independently",
        "B": "Ignore the concern unless the patient complains repeatedly",
        "C": "Document only at the end of the week",
        "D": "Assess the patient, follow local policy, document clearly and escalate concerns when indicated"
      },
      "correct_answer": "D",
      "rationale": "Safe UK nursing practice for anaemia symptoms requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-372",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Haematology and oncology basics",
      "question": "A patient scenario raises concern about anaemia symptoms. What should the nurse do first?",
      "options": {
        "A": "Ask an untrained person to manage the problem independently",
        "B": "Ignore the concern unless the patient complains repeatedly",
        "C": "Act outside competence to avoid delaying care",
        "D": "Prioritise immediate safety using ABCDE or relevant assessment, then seek senior help if needed"
      },
      "correct_answer": "D",
      "rationale": "Safe UK nursing practice for anaemia symptoms requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-373",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Cardiovascular nursing",
      "question": "A patient prescribed digoxin reports nausea and visual disturbances. What should the nurse consider?",
      "options": {
        "A": "A possible sign of digoxin toxicity requiring assessment",
        "B": "A normal expected effect requiring no action",
        "C": "Evidence that the dose should be doubled",
        "D": "A reason to stop all medication permanently"
      },
      "correct_answer": "A",
      "rationale": "Digoxin toxicity may present with gastrointestinal symptoms and visual disturbance; assessment and escalation are required."
    },
    {
      "id": "UKN-Y2-374",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Haematology and oncology basics",
      "question": "Which response best demonstrates safe practice regarding neutropenic sepsis?",
      "options": {
        "A": "Communicate clearly, maintain dignity and check understanding before proceeding",
        "B": "Document only at the end of the week",
        "C": "Reassure the patient and take no further action despite deterioration",
        "D": "Ignore the concern unless the patient complains repeatedly"
      },
      "correct_answer": "A",
      "rationale": "Safe UK nursing practice for neutropenic sepsis requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-375",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Haematology and oncology basics",
      "question": "A patient scenario raises concern about thrombocytopenia bleeding. What should the nurse do first?",
      "options": {
        "A": "Act outside competence to avoid delaying care",
        "B": "Give treatment without checking consent, identity or relevant risks",
        "C": "Prioritise immediate safety using ABCDE or relevant assessment, then seek senior help if needed",
        "D": "Document only at the end of the week"
      },
      "correct_answer": "C",
      "rationale": "Safe UK nursing practice for thrombocytopenia bleeding requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-376",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Haematology and oncology basics",
      "question": "In relation to thrombocytopenia bleeding, what is the safest nursing action?",
      "options": {
        "A": "Act outside competence to avoid delaying care",
        "B": "Assess the patient, follow local policy, document clearly and escalate concerns when indicated",
        "C": "Reassure the patient and take no further action despite deterioration",
        "D": "Ask an untrained person to manage the problem independently"
      },
      "correct_answer": "B",
      "rationale": "Safe UK nursing practice for thrombocytopenia bleeding requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-377",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Haematology and oncology basics",
      "question": "Which response best demonstrates safe practice regarding chemotherapy side effects?",
      "options": {
        "A": "Communicate clearly, maintain dignity and check understanding before proceeding",
        "B": "Give treatment without checking consent, identity or relevant risks",
        "C": "Ask an untrained person to manage the problem independently",
        "D": "Act outside competence to avoid delaying care"
      },
      "correct_answer": "A",
      "rationale": "Safe UK nursing practice for chemotherapy side effects requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-378",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Renal nursing",
      "question": "Which blood result is most closely associated with acute kidney injury?",
      "options": {
        "A": "Rising creatinine",
        "B": "Reduced cholesterol",
        "C": "Raised haemoglobin",
        "D": "Low body temperature"
      },
      "correct_answer": "A",
      "rationale": "Creatinine is used with urine output and clinical assessment when identifying acute kidney injury."
    },
    {
      "id": "UKN-Y2-379",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Haematology and oncology basics",
      "question": "In relation to central line infection, what is the safest nursing action?",
      "options": {
        "A": "Reassure the patient and take no further action despite deterioration",
        "B": "Assess the patient, follow local policy, document clearly and escalate concerns when indicated",
        "C": "Ignore the concern unless the patient complains repeatedly",
        "D": "Document only at the end of the week"
      },
      "correct_answer": "B",
      "rationale": "Safe UK nursing practice for central line infection requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-380",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Haematology and oncology basics",
      "question": "A patient scenario raises concern about central line infection. What should the nurse do first?",
      "options": {
        "A": "Prioritise immediate safety using ABCDE or relevant assessment, then seek senior help if needed",
        "B": "Give treatment without checking consent, identity or relevant risks",
        "C": "Document only at the end of the week",
        "D": "Reassure the patient and take no further action despite deterioration"
      },
      "correct_answer": "A",
      "rationale": "Safe UK nursing practice for central line infection requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-381",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Neurology",
      "question": "A patient develops sudden facial droop and arm weakness. What is the priority?",
      "options": {
        "A": "Arrange routine review next week",
        "B": "Treat as possible stroke and escalate urgently",
        "C": "Encourage sleep and reassess tomorrow",
        "D": "Offer a high sugar meal"
      },
      "correct_answer": "B",
      "rationale": "Sudden focal neurological symptoms require urgent stroke assessment."
    },
    {
      "id": "UKN-Y2-382",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Haematology and oncology basics",
      "question": "Which response best demonstrates safe practice regarding fatigue management?",
      "options": {
        "A": "Reassure the patient and take no further action despite deterioration",
        "B": "Act outside competence to avoid delaying care",
        "C": "Give treatment without checking consent, identity or relevant risks",
        "D": "Communicate clearly, maintain dignity and check understanding before proceeding"
      },
      "correct_answer": "D",
      "rationale": "Safe UK nursing practice for fatigue management requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-383",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Haematology and oncology basics",
      "question": "A patient scenario raises concern about mouth care chemotherapy. What should the nurse do first?",
      "options": {
        "A": "Document only at the end of the week",
        "B": "Ask an untrained person to manage the problem independently",
        "C": "Reassure the patient and take no further action despite deterioration",
        "D": "Prioritise immediate safety using ABCDE or relevant assessment, then seek senior help if needed"
      },
      "correct_answer": "D",
      "rationale": "Safe UK nursing practice for mouth care chemotherapy requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-384",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Haematology and oncology basics",
      "question": "In relation to mouth care chemotherapy, what is the safest nursing action?",
      "options": {
        "A": "Assess the patient, follow local policy, document clearly and escalate concerns when indicated",
        "B": "Ask an untrained person to manage the problem independently",
        "C": "Act outside competence to avoid delaying care",
        "D": "Document only at the end of the week"
      },
      "correct_answer": "A",
      "rationale": "Safe UK nursing practice for mouth care chemotherapy requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-385",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Haematology and oncology basics",
      "question": "Which response best demonstrates safe practice regarding lymphoedema?",
      "options": {
        "A": "Give treatment without checking consent, identity or relevant risks",
        "B": "Communicate clearly, maintain dignity and check understanding before proceeding",
        "C": "Act outside competence to avoid delaying care",
        "D": "Ignore the concern unless the patient complains repeatedly"
      },
      "correct_answer": "B",
      "rationale": "Safe UK nursing practice for lymphoedema requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-386",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Clinical assessment",
      "question": "Which finding may indicate fluid overload?",
      "options": {
        "A": "Crackles on chest auscultation and increasing breathlessness",
        "B": "Dry mucous membranes only",
        "C": "Excessive thirst only",
        "D": "Low urine specific gravity only"
      },
      "correct_answer": "A",
      "rationale": "Fluid overload can cause pulmonary congestion and respiratory symptoms."
    },
    {
      "id": "UKN-Y2-387",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Haematology and oncology basics",
      "question": "In relation to blood transfusion reaction, what is the safest nursing action?",
      "options": {
        "A": "Assess the patient, follow local policy, document clearly and escalate concerns when indicated",
        "B": "Reassure the patient and take no further action despite deterioration",
        "C": "Document only at the end of the week",
        "D": "Act outside competence to avoid delaying care"
      },
      "correct_answer": "A",
      "rationale": "Safe UK nursing practice for blood transfusion reaction requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-388",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Haematology and oncology basics",
      "question": "A patient scenario raises concern about blood transfusion reaction. What should the nurse do first?",
      "options": {
        "A": "Prioritise immediate safety using ABCDE or relevant assessment, then seek senior help if needed",
        "B": "Reassure the patient and take no further action despite deterioration",
        "C": "Ask an untrained person to manage the problem independently",
        "D": "Act outside competence to avoid delaying care"
      },
      "correct_answer": "A",
      "rationale": "Safe UK nursing practice for blood transfusion reaction requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-389",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Respiratory nursing",
      "question": "Why are peak flow measurements used in asthma care?",
      "options": {
        "A": "To estimate airflow limitation",
        "B": "To diagnose fractures",
        "C": "To measure blood glucose",
        "D": "To replace all clinical observations"
      },
      "correct_answer": "A",
      "rationale": "Peak expiratory flow helps monitor airway obstruction and response to treatment."
    },
    {
      "id": "UKN-Y2-390",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Haematology and oncology basics",
      "question": "Which response best demonstrates safe practice regarding palliative care referral?",
      "options": {
        "A": "Communicate clearly, maintain dignity and check understanding before proceeding",
        "B": "Reassure the patient and take no further action despite deterioration",
        "C": "Ignore the concern unless the patient complains repeatedly",
        "D": "Give treatment without checking consent, identity or relevant risks"
      },
      "correct_answer": "A",
      "rationale": "Safe UK nursing practice for palliative care referral requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-391",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Musculoskeletal and mobility",
      "question": "In relation to fracture neurovascular checks, what is the safest nursing action?",
      "options": {
        "A": "Ignore the concern unless the patient complains repeatedly",
        "B": "Give treatment without checking consent, identity or relevant risks",
        "C": "Document only at the end of the week",
        "D": "Assess the patient, follow local policy, document clearly and escalate concerns when indicated"
      },
      "correct_answer": "D",
      "rationale": "Safe UK nursing practice for fracture neurovascular checks requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-392",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Musculoskeletal and mobility",
      "question": "A patient scenario raises concern about fracture neurovascular checks. What should the nurse do first?",
      "options": {
        "A": "Reassure the patient and take no further action despite deterioration",
        "B": "Ask an untrained person to manage the problem independently",
        "C": "Prioritise immediate safety using ABCDE or relevant assessment, then seek senior help if needed",
        "D": "Give treatment without checking consent, identity or relevant risks"
      },
      "correct_answer": "C",
      "rationale": "Safe UK nursing practice for fracture neurovascular checks requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-393",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Cardiovascular nursing",
      "question": "A patient prescribed digoxin reports nausea and visual disturbances. What should the nurse consider?",
      "options": {
        "A": "A possible sign of digoxin toxicity requiring assessment",
        "B": "A normal expected effect requiring no action",
        "C": "Evidence that the dose should be doubled",
        "D": "A reason to stop all medication permanently"
      },
      "correct_answer": "A",
      "rationale": "Digoxin toxicity may present with gastrointestinal symptoms and visual disturbance; assessment and escalation are required."
    },
    {
      "id": "UKN-Y2-394",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Musculoskeletal and mobility",
      "question": "Which response best demonstrates safe practice regarding falls prevention?",
      "options": {
        "A": "Act outside competence to avoid delaying care",
        "B": "Ask an untrained person to manage the problem independently",
        "C": "Ignore the concern unless the patient complains repeatedly",
        "D": "Communicate clearly, maintain dignity and check understanding before proceeding"
      },
      "correct_answer": "D",
      "rationale": "Safe UK nursing practice for falls prevention requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-395",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Musculoskeletal and mobility",
      "question": "A patient scenario raises concern about hip fracture complications. What should the nurse do first?",
      "options": {
        "A": "Act outside competence to avoid delaying care",
        "B": "Prioritise immediate safety using ABCDE or relevant assessment, then seek senior help if needed",
        "C": "Give treatment without checking consent, identity or relevant risks",
        "D": "Ask an untrained person to manage the problem independently"
      },
      "correct_answer": "B",
      "rationale": "Safe UK nursing practice for hip fracture complications requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-396",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Musculoskeletal and mobility",
      "question": "In relation to hip fracture complications, what is the safest nursing action?",
      "options": {
        "A": "Reassure the patient and take no further action despite deterioration",
        "B": "Assess the patient, follow local policy, document clearly and escalate concerns when indicated",
        "C": "Ignore the concern unless the patient complains repeatedly",
        "D": "Document only at the end of the week"
      },
      "correct_answer": "B",
      "rationale": "Safe UK nursing practice for hip fracture complications requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-397",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Musculoskeletal and mobility",
      "question": "Which response best demonstrates safe practice regarding arthritis pain?",
      "options": {
        "A": "Communicate clearly, maintain dignity and check understanding before proceeding",
        "B": "Give treatment without checking consent, identity or relevant risks",
        "C": "Ask an untrained person to manage the problem independently",
        "D": "Ignore the concern unless the patient complains repeatedly"
      },
      "correct_answer": "A",
      "rationale": "Safe UK nursing practice for arthritis pain requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-398",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Renal nursing",
      "question": "Which blood result is most closely associated with acute kidney injury?",
      "options": {
        "A": "Rising creatinine",
        "B": "Reduced cholesterol",
        "C": "Raised haemoglobin",
        "D": "Low body temperature"
      },
      "correct_answer": "A",
      "rationale": "Creatinine is used with urine output and clinical assessment when identifying acute kidney injury."
    },
    {
      "id": "UKN-Y2-399",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Musculoskeletal and mobility",
      "question": "In relation to mobility aids safety, what is the safest nursing action?",
      "options": {
        "A": "Assess the patient, follow local policy, document clearly and escalate concerns when indicated",
        "B": "Act outside competence to avoid delaying care",
        "C": "Reassure the patient and take no further action despite deterioration",
        "D": "Ignore the concern unless the patient complains repeatedly"
      },
      "correct_answer": "A",
      "rationale": "Safe UK nursing practice for mobility aids safety requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-400",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Musculoskeletal and mobility",
      "question": "A patient scenario raises concern about mobility aids safety. What should the nurse do first?",
      "options": {
        "A": "Prioritise immediate safety using ABCDE or relevant assessment, then seek senior help if needed",
        "B": "Ask an untrained person to manage the problem independently",
        "C": "Ignore the concern unless the patient complains repeatedly",
        "D": "Document only at the end of the week"
      },
      "correct_answer": "A",
      "rationale": "Safe UK nursing practice for mobility aids safety requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-401",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Neurology",
      "question": "A patient develops sudden facial droop and arm weakness. What is the priority?",
      "options": {
        "A": "Arrange routine review next week",
        "B": "Treat as possible stroke and escalate urgently",
        "C": "Encourage sleep and reassess tomorrow",
        "D": "Offer a high sugar meal"
      },
      "correct_answer": "B",
      "rationale": "Sudden focal neurological symptoms require urgent stroke assessment."
    },
    {
      "id": "UKN-Y2-402",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Musculoskeletal and mobility",
      "question": "Which response best demonstrates safe practice regarding pressure risk with immobility?",
      "options": {
        "A": "Reassure the patient and take no further action despite deterioration",
        "B": "Act outside competence to avoid delaying care",
        "C": "Communicate clearly, maintain dignity and check understanding before proceeding",
        "D": "Ask an untrained person to manage the problem independently"
      },
      "correct_answer": "C",
      "rationale": "Safe UK nursing practice for pressure risk with immobility requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-403",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Musculoskeletal and mobility",
      "question": "A patient scenario raises concern about plaster cast tightness. What should the nurse do first?",
      "options": {
        "A": "Prioritise immediate safety using ABCDE or relevant assessment, then seek senior help if needed",
        "B": "Document only at the end of the week",
        "C": "Reassure the patient and take no further action despite deterioration",
        "D": "Act outside competence to avoid delaying care"
      },
      "correct_answer": "A",
      "rationale": "Safe UK nursing practice for plaster cast tightness requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-404",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Musculoskeletal and mobility",
      "question": "In relation to plaster cast tightness, what is the safest nursing action?",
      "options": {
        "A": "Reassure the patient and take no further action despite deterioration",
        "B": "Ignore the concern unless the patient complains repeatedly",
        "C": "Give treatment without checking consent, identity or relevant risks",
        "D": "Assess the patient, follow local policy, document clearly and escalate concerns when indicated"
      },
      "correct_answer": "D",
      "rationale": "Safe UK nursing practice for plaster cast tightness requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-405",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Musculoskeletal and mobility",
      "question": "Which response best demonstrates safe practice regarding osteoporosis risk?",
      "options": {
        "A": "Reassure the patient and take no further action despite deterioration",
        "B": "Communicate clearly, maintain dignity and check understanding before proceeding",
        "C": "Document only at the end of the week",
        "D": "Act outside competence to avoid delaying care"
      },
      "correct_answer": "B",
      "rationale": "Safe UK nursing practice for osteoporosis risk requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-406",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Clinical assessment",
      "question": "Which finding may indicate fluid overload?",
      "options": {
        "A": "Crackles on chest auscultation and increasing breathlessness",
        "B": "Dry mucous membranes only",
        "C": "Excessive thirst only",
        "D": "Low urine specific gravity only"
      },
      "correct_answer": "A",
      "rationale": "Fluid overload can cause pulmonary congestion and respiratory symptoms."
    },
    {
      "id": "UKN-Y2-407",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Musculoskeletal and mobility",
      "question": "In relation to manual handling, what is the safest nursing action?",
      "options": {
        "A": "Ignore the concern unless the patient complains repeatedly",
        "B": "Act outside competence to avoid delaying care",
        "C": "Assess the patient, follow local policy, document clearly and escalate concerns when indicated",
        "D": "Reassure the patient and take no further action despite deterioration"
      },
      "correct_answer": "C",
      "rationale": "Safe UK nursing practice for manual handling requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-408",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Musculoskeletal and mobility",
      "question": "A patient scenario raises concern about manual handling. What should the nurse do first?",
      "options": {
        "A": "Ignore the concern unless the patient complains repeatedly",
        "B": "Act outside competence to avoid delaying care",
        "C": "Ask an untrained person to manage the problem independently",
        "D": "Prioritise immediate safety using ABCDE or relevant assessment, then seek senior help if needed"
      },
      "correct_answer": "D",
      "rationale": "Safe UK nursing practice for manual handling requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-409",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Respiratory nursing",
      "question": "Why are peak flow measurements used in asthma care?",
      "options": {
        "A": "To estimate airflow limitation",
        "B": "To diagnose fractures",
        "C": "To measure blood glucose",
        "D": "To replace all clinical observations"
      },
      "correct_answer": "A",
      "rationale": "Peak expiratory flow helps monitor airway obstruction and response to treatment."
    },
    {
      "id": "UKN-Y2-410",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Musculoskeletal and mobility",
      "question": "Which response best demonstrates safe practice regarding post-fall assessment?",
      "options": {
        "A": "Ignore the concern unless the patient complains repeatedly",
        "B": "Give treatment without checking consent, identity or relevant risks",
        "C": "Communicate clearly, maintain dignity and check understanding before proceeding",
        "D": "Ask an untrained person to manage the problem independently"
      },
      "correct_answer": "C",
      "rationale": "Safe UK nursing practice for post-fall assessment requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-411",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Emergency and first response",
      "question": "In relation to ABCDE approach, what is the safest nursing action?",
      "options": {
        "A": "Reassure the patient and take no further action despite deterioration",
        "B": "Ignore the concern unless the patient complains repeatedly",
        "C": "Ask an untrained person to manage the problem independently",
        "D": "Assess the patient, follow local policy, document clearly and escalate concerns when indicated"
      },
      "correct_answer": "D",
      "rationale": "Safe UK nursing practice for ABCDE approach requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-412",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Emergency and first response",
      "question": "A patient scenario raises concern about ABCDE approach. What should the nurse do first?",
      "options": {
        "A": "Give treatment without checking consent, identity or relevant risks",
        "B": "Act outside competence to avoid delaying care",
        "C": "Ignore the concern unless the patient complains repeatedly",
        "D": "Prioritise immediate safety using ABCDE or relevant assessment, then seek senior help if needed"
      },
      "correct_answer": "D",
      "rationale": "Safe UK nursing practice for ABCDE approach requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-413",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Cardiovascular nursing",
      "question": "A patient prescribed digoxin reports nausea and visual disturbances. What should the nurse consider?",
      "options": {
        "A": "A possible sign of digoxin toxicity requiring assessment",
        "B": "A normal expected effect requiring no action",
        "C": "Evidence that the dose should be doubled",
        "D": "A reason to stop all medication permanently"
      },
      "correct_answer": "A",
      "rationale": "Digoxin toxicity may present with gastrointestinal symptoms and visual disturbance; assessment and escalation are required."
    },
    {
      "id": "UKN-Y2-414",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Emergency and first response",
      "question": "Which response best demonstrates safe practice regarding anaphylaxis recognition?",
      "options": {
        "A": "Reassure the patient and take no further action despite deterioration",
        "B": "Document only at the end of the week",
        "C": "Ask an untrained person to manage the problem independently",
        "D": "Communicate clearly, maintain dignity and check understanding before proceeding"
      },
      "correct_answer": "D",
      "rationale": "Safe UK nursing practice for anaphylaxis recognition requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-415",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Emergency and first response",
      "question": "A patient scenario raises concern about cardiac arrest call. What should the nurse do first?",
      "options": {
        "A": "Document only at the end of the week",
        "B": "Prioritise immediate safety using ABCDE or relevant assessment, then seek senior help if needed",
        "C": "Give treatment without checking consent, identity or relevant risks",
        "D": "Reassure the patient and take no further action despite deterioration"
      },
      "correct_answer": "B",
      "rationale": "Safe UK nursing practice for cardiac arrest call requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-416",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Emergency and first response",
      "question": "In relation to cardiac arrest call, what is the safest nursing action?",
      "options": {
        "A": "Ask an untrained person to manage the problem independently",
        "B": "Ignore the concern unless the patient complains repeatedly",
        "C": "Give treatment without checking consent, identity or relevant risks",
        "D": "Assess the patient, follow local policy, document clearly and escalate concerns when indicated"
      },
      "correct_answer": "D",
      "rationale": "Safe UK nursing practice for cardiac arrest call requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-417",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Emergency and first response",
      "question": "Which response best demonstrates safe practice regarding major haemorrhage?",
      "options": {
        "A": "Act outside competence to avoid delaying care",
        "B": "Ask an untrained person to manage the problem independently",
        "C": "Ignore the concern unless the patient complains repeatedly",
        "D": "Communicate clearly, maintain dignity and check understanding before proceeding"
      },
      "correct_answer": "D",
      "rationale": "Safe UK nursing practice for major haemorrhage requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-418",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Renal nursing",
      "question": "Which blood result is most closely associated with acute kidney injury?",
      "options": {
        "A": "Rising creatinine",
        "B": "Reduced cholesterol",
        "C": "Raised haemoglobin",
        "D": "Low body temperature"
      },
      "correct_answer": "A",
      "rationale": "Creatinine is used with urine output and clinical assessment when identifying acute kidney injury."
    },
    {
      "id": "UKN-Y2-419",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Emergency and first response",
      "question": "In relation to hypoglycaemia emergency, what is the safest nursing action?",
      "options": {
        "A": "Document only at the end of the week",
        "B": "Give treatment without checking consent, identity or relevant risks",
        "C": "Ignore the concern unless the patient complains repeatedly",
        "D": "Assess the patient, follow local policy, document clearly and escalate concerns when indicated"
      },
      "correct_answer": "D",
      "rationale": "Safe UK nursing practice for hypoglycaemia emergency requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-420",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Emergency and first response",
      "question": "A patient scenario raises concern about hypoglycaemia emergency. What should the nurse do first?",
      "options": {
        "A": "Give treatment without checking consent, identity or relevant risks",
        "B": "Prioritise immediate safety using ABCDE or relevant assessment, then seek senior help if needed",
        "C": "Document only at the end of the week",
        "D": "Reassure the patient and take no further action despite deterioration"
      },
      "correct_answer": "B",
      "rationale": "Safe UK nursing practice for hypoglycaemia emergency requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-421",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Neurology",
      "question": "A patient develops sudden facial droop and arm weakness. What is the priority?",
      "options": {
        "A": "Arrange routine review next week",
        "B": "Treat as possible stroke and escalate urgently",
        "C": "Encourage sleep and reassess tomorrow",
        "D": "Offer a high sugar meal"
      },
      "correct_answer": "B",
      "rationale": "Sudden focal neurological symptoms require urgent stroke assessment."
    },
    {
      "id": "UKN-Y2-422",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Emergency and first response",
      "question": "Which response best demonstrates safe practice regarding choking adult?",
      "options": {
        "A": "Give treatment without checking consent, identity or relevant risks",
        "B": "Ask an untrained person to manage the problem independently",
        "C": "Ignore the concern unless the patient complains repeatedly",
        "D": "Communicate clearly, maintain dignity and check understanding before proceeding"
      },
      "correct_answer": "D",
      "rationale": "Safe UK nursing practice for choking adult requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-423",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Emergency and first response",
      "question": "A patient scenario raises concern about seizure management. What should the nurse do first?",
      "options": {
        "A": "Document only at the end of the week",
        "B": "Prioritise immediate safety using ABCDE or relevant assessment, then seek senior help if needed",
        "C": "Ignore the concern unless the patient complains repeatedly",
        "D": "Give treatment without checking consent, identity or relevant risks"
      },
      "correct_answer": "B",
      "rationale": "Safe UK nursing practice for seizure management requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-424",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Emergency and first response",
      "question": "In relation to seizure management, what is the safest nursing action?",
      "options": {
        "A": "Assess the patient, follow local policy, document clearly and escalate concerns when indicated",
        "B": "Ignore the concern unless the patient complains repeatedly",
        "C": "Document only at the end of the week",
        "D": "Give treatment without checking consent, identity or relevant risks"
      },
      "correct_answer": "A",
      "rationale": "Safe UK nursing practice for seizure management requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-425",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Emergency and first response",
      "question": "Which response best demonstrates safe practice regarding sepsis escalation?",
      "options": {
        "A": "Give treatment without checking consent, identity or relevant risks",
        "B": "Communicate clearly, maintain dignity and check understanding before proceeding",
        "C": "Reassure the patient and take no further action despite deterioration",
        "D": "Act outside competence to avoid delaying care"
      },
      "correct_answer": "B",
      "rationale": "Safe UK nursing practice for sepsis escalation requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-426",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Clinical assessment",
      "question": "Which finding may indicate fluid overload?",
      "options": {
        "A": "Crackles on chest auscultation and increasing breathlessness",
        "B": "Dry mucous membranes only",
        "C": "Excessive thirst only",
        "D": "Low urine specific gravity only"
      },
      "correct_answer": "A",
      "rationale": "Fluid overload can cause pulmonary congestion and respiratory symptoms."
    },
    {
      "id": "UKN-Y2-427",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Emergency and first response",
      "question": "In relation to stroke pathway, what is the safest nursing action?",
      "options": {
        "A": "Give treatment without checking consent, identity or relevant risks",
        "B": "Reassure the patient and take no further action despite deterioration",
        "C": "Assess the patient, follow local policy, document clearly and escalate concerns when indicated",
        "D": "Act outside competence to avoid delaying care"
      },
      "correct_answer": "C",
      "rationale": "Safe UK nursing practice for stroke pathway requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-428",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Emergency and first response",
      "question": "A patient scenario raises concern about stroke pathway. What should the nurse do first?",
      "options": {
        "A": "Prioritise immediate safety using ABCDE or relevant assessment, then seek senior help if needed",
        "B": "Document only at the end of the week",
        "C": "Act outside competence to avoid delaying care",
        "D": "Give treatment without checking consent, identity or relevant risks"
      },
      "correct_answer": "A",
      "rationale": "Safe UK nursing practice for stroke pathway requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-429",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Respiratory nursing",
      "question": "Why are peak flow measurements used in asthma care?",
      "options": {
        "A": "To estimate airflow limitation",
        "B": "To diagnose fractures",
        "C": "To measure blood glucose",
        "D": "To replace all clinical observations"
      },
      "correct_answer": "A",
      "rationale": "Peak expiratory flow helps monitor airway obstruction and response to treatment."
    },
    {
      "id": "UKN-Y2-430",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Emergency and first response",
      "question": "Which response best demonstrates safe practice regarding oxygen in emergency?",
      "options": {
        "A": "Communicate clearly, maintain dignity and check understanding before proceeding",
        "B": "Ask an untrained person to manage the problem independently",
        "C": "Reassure the patient and take no further action despite deterioration",
        "D": "Act outside competence to avoid delaying care"
      },
      "correct_answer": "A",
      "rationale": "Safe UK nursing practice for oxygen in emergency requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-431",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "End of life and palliative care",
      "question": "In relation to advance care planning, what is the safest nursing action?",
      "options": {
        "A": "Ask an untrained person to manage the problem independently",
        "B": "Assess the patient, follow local policy, document clearly and escalate concerns when indicated",
        "C": "Document only at the end of the week",
        "D": "Act outside competence to avoid delaying care"
      },
      "correct_answer": "B",
      "rationale": "Safe UK nursing practice for advance care planning requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-432",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "End of life and palliative care",
      "question": "A patient scenario raises concern about advance care planning. What should the nurse do first?",
      "options": {
        "A": "Act outside competence to avoid delaying care",
        "B": "Ignore the concern unless the patient complains repeatedly",
        "C": "Prioritise immediate safety using ABCDE or relevant assessment, then seek senior help if needed",
        "D": "Ask an untrained person to manage the problem independently"
      },
      "correct_answer": "C",
      "rationale": "Safe UK nursing practice for advance care planning requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-433",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Cardiovascular nursing",
      "question": "A patient prescribed digoxin reports nausea and visual disturbances. What should the nurse consider?",
      "options": {
        "A": "A possible sign of digoxin toxicity requiring assessment",
        "B": "A normal expected effect requiring no action",
        "C": "Evidence that the dose should be doubled",
        "D": "A reason to stop all medication permanently"
      },
      "correct_answer": "A",
      "rationale": "Digoxin toxicity may present with gastrointestinal symptoms and visual disturbance; assessment and escalation are required."
    },
    {
      "id": "UKN-Y2-434",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "End of life and palliative care",
      "question": "Which response best demonstrates safe practice regarding DNACPR communication?",
      "options": {
        "A": "Communicate clearly, maintain dignity and check understanding before proceeding",
        "B": "Ignore the concern unless the patient complains repeatedly",
        "C": "Document only at the end of the week",
        "D": "Ask an untrained person to manage the problem independently"
      },
      "correct_answer": "A",
      "rationale": "Safe UK nursing practice for DNACPR communication requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-435",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "End of life and palliative care",
      "question": "A patient scenario raises concern about mouth care dying patient. What should the nurse do first?",
      "options": {
        "A": "Ignore the concern unless the patient complains repeatedly",
        "B": "Prioritise immediate safety using ABCDE or relevant assessment, then seek senior help if needed",
        "C": "Ask an untrained person to manage the problem independently",
        "D": "Give treatment without checking consent, identity or relevant risks"
      },
      "correct_answer": "B",
      "rationale": "Safe UK nursing practice for mouth care dying patient requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-436",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "End of life and palliative care",
      "question": "In relation to mouth care dying patient, what is the safest nursing action?",
      "options": {
        "A": "Document only at the end of the week",
        "B": "Reassure the patient and take no further action despite deterioration",
        "C": "Give treatment without checking consent, identity or relevant risks",
        "D": "Assess the patient, follow local policy, document clearly and escalate concerns when indicated"
      },
      "correct_answer": "D",
      "rationale": "Safe UK nursing practice for mouth care dying patient requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-437",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "End of life and palliative care",
      "question": "Which response best demonstrates safe practice regarding anticipatory medicines?",
      "options": {
        "A": "Communicate clearly, maintain dignity and check understanding before proceeding",
        "B": "Give treatment without checking consent, identity or relevant risks",
        "C": "Ignore the concern unless the patient complains repeatedly",
        "D": "Reassure the patient and take no further action despite deterioration"
      },
      "correct_answer": "A",
      "rationale": "Safe UK nursing practice for anticipatory medicines requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-438",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Renal nursing",
      "question": "Which blood result is most closely associated with acute kidney injury?",
      "options": {
        "A": "Rising creatinine",
        "B": "Reduced cholesterol",
        "C": "Raised haemoglobin",
        "D": "Low body temperature"
      },
      "correct_answer": "A",
      "rationale": "Creatinine is used with urine output and clinical assessment when identifying acute kidney injury."
    },
    {
      "id": "UKN-Y2-439",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "End of life and palliative care",
      "question": "In relation to family support, what is the safest nursing action?",
      "options": {
        "A": "Give treatment without checking consent, identity or relevant risks",
        "B": "Assess the patient, follow local policy, document clearly and escalate concerns when indicated",
        "C": "Document only at the end of the week",
        "D": "Ask an untrained person to manage the problem independently"
      },
      "correct_answer": "B",
      "rationale": "Safe UK nursing practice for family support requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-440",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "End of life and palliative care",
      "question": "A patient scenario raises concern about family support. What should the nurse do first?",
      "options": {
        "A": "Prioritise immediate safety using ABCDE or relevant assessment, then seek senior help if needed",
        "B": "Act outside competence to avoid delaying care",
        "C": "Ask an untrained person to manage the problem independently",
        "D": "Give treatment without checking consent, identity or relevant risks"
      },
      "correct_answer": "A",
      "rationale": "Safe UK nursing practice for family support requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-441",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Neurology",
      "question": "A patient develops sudden facial droop and arm weakness. What is the priority?",
      "options": {
        "A": "Arrange routine review next week",
        "B": "Treat as possible stroke and escalate urgently",
        "C": "Encourage sleep and reassess tomorrow",
        "D": "Offer a high sugar meal"
      },
      "correct_answer": "B",
      "rationale": "Sudden focal neurological symptoms require urgent stroke assessment."
    },
    {
      "id": "UKN-Y2-442",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "End of life and palliative care",
      "question": "Which response best demonstrates safe practice regarding recognising dying?",
      "options": {
        "A": "Document only at the end of the week",
        "B": "Communicate clearly, maintain dignity and check understanding before proceeding",
        "C": "Ask an untrained person to manage the problem independently",
        "D": "Ignore the concern unless the patient complains repeatedly"
      },
      "correct_answer": "B",
      "rationale": "Safe UK nursing practice for recognising dying requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-443",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "End of life and palliative care",
      "question": "A patient scenario raises concern about spiritual care. What should the nurse do first?",
      "options": {
        "A": "Act outside competence to avoid delaying care",
        "B": "Prioritise immediate safety using ABCDE or relevant assessment, then seek senior help if needed",
        "C": "Document only at the end of the week",
        "D": "Ignore the concern unless the patient complains repeatedly"
      },
      "correct_answer": "B",
      "rationale": "Safe UK nursing practice for spiritual care requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-444",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "End of life and palliative care",
      "question": "In relation to spiritual care, what is the safest nursing action?",
      "options": {
        "A": "Reassure the patient and take no further action despite deterioration",
        "B": "Assess the patient, follow local policy, document clearly and escalate concerns when indicated",
        "C": "Document only at the end of the week",
        "D": "Ignore the concern unless the patient complains repeatedly"
      },
      "correct_answer": "B",
      "rationale": "Safe UK nursing practice for spiritual care requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-445",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "End of life and palliative care",
      "question": "Which response best demonstrates safe practice regarding pain in palliative care?",
      "options": {
        "A": "Communicate clearly, maintain dignity and check understanding before proceeding",
        "B": "Ask an untrained person to manage the problem independently",
        "C": "Ignore the concern unless the patient complains repeatedly",
        "D": "Give treatment without checking consent, identity or relevant risks"
      },
      "correct_answer": "A",
      "rationale": "Safe UK nursing practice for pain in palliative care requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-446",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Clinical assessment",
      "question": "Which finding may indicate fluid overload?",
      "options": {
        "A": "Crackles on chest auscultation and increasing breathlessness",
        "B": "Dry mucous membranes only",
        "C": "Excessive thirst only",
        "D": "Low urine specific gravity only"
      },
      "correct_answer": "A",
      "rationale": "Fluid overload can cause pulmonary congestion and respiratory symptoms."
    },
    {
      "id": "UKN-Y2-447",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "End of life and palliative care",
      "question": "In relation to syringe driver awareness, what is the safest nursing action?",
      "options": {
        "A": "Document only at the end of the week",
        "B": "Reassure the patient and take no further action despite deterioration",
        "C": "Ask an untrained person to manage the problem independently",
        "D": "Assess the patient, follow local policy, document clearly and escalate concerns when indicated"
      },
      "correct_answer": "D",
      "rationale": "Safe UK nursing practice for syringe driver awareness requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-448",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "End of life and palliative care",
      "question": "A patient scenario raises concern about syringe driver awareness. What should the nurse do first?",
      "options": {
        "A": "Ask an untrained person to manage the problem independently",
        "B": "Give treatment without checking consent, identity or relevant risks",
        "C": "Ignore the concern unless the patient complains repeatedly",
        "D": "Prioritise immediate safety using ABCDE or relevant assessment, then seek senior help if needed"
      },
      "correct_answer": "D",
      "rationale": "Safe UK nursing practice for syringe driver awareness requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-449",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Respiratory nursing",
      "question": "Why are peak flow measurements used in asthma care?",
      "options": {
        "A": "To estimate airflow limitation",
        "B": "To diagnose fractures",
        "C": "To measure blood glucose",
        "D": "To replace all clinical observations"
      },
      "correct_answer": "A",
      "rationale": "Peak expiratory flow helps monitor airway obstruction and response to treatment."
    },
    {
      "id": "UKN-Y2-450",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "End of life and palliative care",
      "question": "Which response best demonstrates safe practice regarding bereavement support?",
      "options": {
        "A": "Give treatment without checking consent, identity or relevant risks",
        "B": "Communicate clearly, maintain dignity and check understanding before proceeding",
        "C": "Ask an untrained person to manage the problem independently",
        "D": "Act outside competence to avoid delaying care"
      },
      "correct_answer": "B",
      "rationale": "Safe UK nursing practice for bereavement support requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-451",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Safeguarding adults",
      "question": "In relation to neglect signs, what is the safest nursing action?",
      "options": {
        "A": "Ask an untrained person to manage the problem independently",
        "B": "Assess the patient, follow local policy, document clearly and escalate concerns when indicated",
        "C": "Ignore the concern unless the patient complains repeatedly",
        "D": "Act outside competence to avoid delaying care"
      },
      "correct_answer": "B",
      "rationale": "Safe UK nursing practice for neglect signs requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-452",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Safeguarding adults",
      "question": "A patient scenario raises concern about neglect signs. What should the nurse do first?",
      "options": {
        "A": "Document only at the end of the week",
        "B": "Prioritise immediate safety using ABCDE or relevant assessment, then seek senior help if needed",
        "C": "Act outside competence to avoid delaying care",
        "D": "Give treatment without checking consent, identity or relevant risks"
      },
      "correct_answer": "B",
      "rationale": "Safe UK nursing practice for neglect signs requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-453",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Cardiovascular nursing",
      "question": "A patient prescribed digoxin reports nausea and visual disturbances. What should the nurse consider?",
      "options": {
        "A": "A possible sign of digoxin toxicity requiring assessment",
        "B": "A normal expected effect requiring no action",
        "C": "Evidence that the dose should be doubled",
        "D": "A reason to stop all medication permanently"
      },
      "correct_answer": "A",
      "rationale": "Digoxin toxicity may present with gastrointestinal symptoms and visual disturbance; assessment and escalation are required."
    },
    {
      "id": "UKN-Y2-454",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Safeguarding adults",
      "question": "Which response best demonstrates safe practice regarding financial abuse?",
      "options": {
        "A": "Document only at the end of the week",
        "B": "Communicate clearly, maintain dignity and check understanding before proceeding",
        "C": "Give treatment without checking consent, identity or relevant risks",
        "D": "Ask an untrained person to manage the problem independently"
      },
      "correct_answer": "B",
      "rationale": "Safe UK nursing practice for financial abuse requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-455",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Safeguarding adults",
      "question": "A patient scenario raises concern about domestic abuse disclosure. What should the nurse do first?",
      "options": {
        "A": "Prioritise immediate safety using ABCDE or relevant assessment, then seek senior help if needed",
        "B": "Reassure the patient and take no further action despite deterioration",
        "C": "Document only at the end of the week",
        "D": "Ask an untrained person to manage the problem independently"
      },
      "correct_answer": "A",
      "rationale": "Safe UK nursing practice for domestic abuse disclosure requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-456",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Safeguarding adults",
      "question": "In relation to domestic abuse disclosure, what is the safest nursing action?",
      "options": {
        "A": "Document only at the end of the week",
        "B": "Assess the patient, follow local policy, document clearly and escalate concerns when indicated",
        "C": "Give treatment without checking consent, identity or relevant risks",
        "D": "Reassure the patient and take no further action despite deterioration"
      },
      "correct_answer": "B",
      "rationale": "Safe UK nursing practice for domestic abuse disclosure requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-457",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Safeguarding adults",
      "question": "Which response best demonstrates safe practice regarding mental capacity and safeguarding?",
      "options": {
        "A": "Act outside competence to avoid delaying care",
        "B": "Communicate clearly, maintain dignity and check understanding before proceeding",
        "C": "Ask an untrained person to manage the problem independently",
        "D": "Document only at the end of the week"
      },
      "correct_answer": "B",
      "rationale": "Safe UK nursing practice for mental capacity and safeguarding requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-458",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Renal nursing",
      "question": "Which blood result is most closely associated with acute kidney injury?",
      "options": {
        "A": "Rising creatinine",
        "B": "Reduced cholesterol",
        "C": "Raised haemoglobin",
        "D": "Low body temperature"
      },
      "correct_answer": "A",
      "rationale": "Creatinine is used with urine output and clinical assessment when identifying acute kidney injury."
    },
    {
      "id": "UKN-Y2-459",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Safeguarding adults",
      "question": "In relation to pressure ulcer safeguarding context, what is the safest nursing action?",
      "options": {
        "A": "Ask an untrained person to manage the problem independently",
        "B": "Reassure the patient and take no further action despite deterioration",
        "C": "Ignore the concern unless the patient complains repeatedly",
        "D": "Assess the patient, follow local policy, document clearly and escalate concerns when indicated"
      },
      "correct_answer": "D",
      "rationale": "Safe UK nursing practice for pressure ulcer safeguarding context requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-460",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Safeguarding adults",
      "question": "A patient scenario raises concern about pressure ulcer safeguarding context. What should the nurse do first?",
      "options": {
        "A": "Ask an untrained person to manage the problem independently",
        "B": "Reassure the patient and take no further action despite deterioration",
        "C": "Document only at the end of the week",
        "D": "Prioritise immediate safety using ABCDE or relevant assessment, then seek senior help if needed"
      },
      "correct_answer": "D",
      "rationale": "Safe UK nursing practice for pressure ulcer safeguarding context requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-461",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Neurology",
      "question": "A patient develops sudden facial droop and arm weakness. What is the priority?",
      "options": {
        "A": "Arrange routine review next week",
        "B": "Treat as possible stroke and escalate urgently",
        "C": "Encourage sleep and reassess tomorrow",
        "D": "Offer a high sugar meal"
      },
      "correct_answer": "B",
      "rationale": "Sudden focal neurological symptoms require urgent stroke assessment."
    },
    {
      "id": "UKN-Y2-462",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Safeguarding adults",
      "question": "Which response best demonstrates safe practice regarding modern slavery indicators?",
      "options": {
        "A": "Act outside competence to avoid delaying care",
        "B": "Give treatment without checking consent, identity or relevant risks",
        "C": "Reassure the patient and take no further action despite deterioration",
        "D": "Communicate clearly, maintain dignity and check understanding before proceeding"
      },
      "correct_answer": "D",
      "rationale": "Safe UK nursing practice for modern slavery indicators requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-463",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Safeguarding adults",
      "question": "A patient scenario raises concern about recording disclosure. What should the nurse do first?",
      "options": {
        "A": "Ask an untrained person to manage the problem independently",
        "B": "Act outside competence to avoid delaying care",
        "C": "Give treatment without checking consent, identity or relevant risks",
        "D": "Prioritise immediate safety using ABCDE or relevant assessment, then seek senior help if needed"
      },
      "correct_answer": "D",
      "rationale": "Safe UK nursing practice for recording disclosure requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-464",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Safeguarding adults",
      "question": "In relation to recording disclosure, what is the safest nursing action?",
      "options": {
        "A": "Reassure the patient and take no further action despite deterioration",
        "B": "Assess the patient, follow local policy, document clearly and escalate concerns when indicated",
        "C": "Ask an untrained person to manage the problem independently",
        "D": "Ignore the concern unless the patient complains repeatedly"
      },
      "correct_answer": "B",
      "rationale": "Safe UK nursing practice for recording disclosure requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-465",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Safeguarding adults",
      "question": "Which response best demonstrates safe practice regarding whistleblowing?",
      "options": {
        "A": "Reassure the patient and take no further action despite deterioration",
        "B": "Give treatment without checking consent, identity or relevant risks",
        "C": "Act outside competence to avoid delaying care",
        "D": "Communicate clearly, maintain dignity and check understanding before proceeding"
      },
      "correct_answer": "D",
      "rationale": "Safe UK nursing practice for whistleblowing requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-466",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Clinical assessment",
      "question": "Which finding may indicate fluid overload?",
      "options": {
        "A": "Crackles on chest auscultation and increasing breathlessness",
        "B": "Dry mucous membranes only",
        "C": "Excessive thirst only",
        "D": "Low urine specific gravity only"
      },
      "correct_answer": "A",
      "rationale": "Fluid overload can cause pulmonary congestion and respiratory symptoms."
    },
    {
      "id": "UKN-Y2-467",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Safeguarding adults",
      "question": "In relation to advocacy, what is the safest nursing action?",
      "options": {
        "A": "Assess the patient, follow local policy, document clearly and escalate concerns when indicated",
        "B": "Act outside competence to avoid delaying care",
        "C": "Document only at the end of the week",
        "D": "Give treatment without checking consent, identity or relevant risks"
      },
      "correct_answer": "A",
      "rationale": "Safe UK nursing practice for advocacy requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-468",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Safeguarding adults",
      "question": "A patient scenario raises concern about advocacy. What should the nurse do first?",
      "options": {
        "A": "Give treatment without checking consent, identity or relevant risks",
        "B": "Prioritise immediate safety using ABCDE or relevant assessment, then seek senior help if needed",
        "C": "Document only at the end of the week",
        "D": "Ask an untrained person to manage the problem independently"
      },
      "correct_answer": "B",
      "rationale": "Safe UK nursing practice for advocacy requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-469",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Respiratory nursing",
      "question": "Why are peak flow measurements used in asthma care?",
      "options": {
        "A": "To estimate airflow limitation",
        "B": "To diagnose fractures",
        "C": "To measure blood glucose",
        "D": "To replace all clinical observations"
      },
      "correct_answer": "A",
      "rationale": "Peak expiratory flow helps monitor airway obstruction and response to treatment."
    },
    {
      "id": "UKN-Y2-470",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Safeguarding adults",
      "question": "Which response best demonstrates safe practice regarding multi-agency working?",
      "options": {
        "A": "Document only at the end of the week",
        "B": "Communicate clearly, maintain dignity and check understanding before proceeding",
        "C": "Ask an untrained person to manage the problem independently",
        "D": "Ignore the concern unless the patient complains repeatedly"
      },
      "correct_answer": "B",
      "rationale": "Safe UK nursing practice for multi-agency working requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-471",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Clinical skills and procedures",
      "question": "In relation to venepuncture safety, what is the safest nursing action?",
      "options": {
        "A": "Act outside competence to avoid delaying care",
        "B": "Assess the patient, follow local policy, document clearly and escalate concerns when indicated",
        "C": "Give treatment without checking consent, identity or relevant risks",
        "D": "Ignore the concern unless the patient complains repeatedly"
      },
      "correct_answer": "B",
      "rationale": "Safe UK nursing practice for venepuncture safety requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-472",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Clinical skills and procedures",
      "question": "A patient scenario raises concern about venepuncture safety. What should the nurse do first?",
      "options": {
        "A": "Ask an untrained person to manage the problem independently",
        "B": "Prioritise immediate safety using ABCDE or relevant assessment, then seek senior help if needed",
        "C": "Document only at the end of the week",
        "D": "Reassure the patient and take no further action despite deterioration"
      },
      "correct_answer": "B",
      "rationale": "Safe UK nursing practice for venepuncture safety requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-473",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Cardiovascular nursing",
      "question": "A patient prescribed digoxin reports nausea and visual disturbances. What should the nurse consider?",
      "options": {
        "A": "A possible sign of digoxin toxicity requiring assessment",
        "B": "A normal expected effect requiring no action",
        "C": "Evidence that the dose should be doubled",
        "D": "A reason to stop all medication permanently"
      },
      "correct_answer": "A",
      "rationale": "Digoxin toxicity may present with gastrointestinal symptoms and visual disturbance; assessment and escalation are required."
    },
    {
      "id": "UKN-Y2-474",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Clinical skills and procedures",
      "question": "Which response best demonstrates safe practice regarding cannula monitoring?",
      "options": {
        "A": "Communicate clearly, maintain dignity and check understanding before proceeding",
        "B": "Ask an untrained person to manage the problem independently",
        "C": "Document only at the end of the week",
        "D": "Reassure the patient and take no further action despite deterioration"
      },
      "correct_answer": "A",
      "rationale": "Safe UK nursing practice for cannula monitoring requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-475",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Clinical skills and procedures",
      "question": "A patient scenario raises concern about urinalysis interpretation. What should the nurse do first?",
      "options": {
        "A": "Prioritise immediate safety using ABCDE or relevant assessment, then seek senior help if needed",
        "B": "Ask an untrained person to manage the problem independently",
        "C": "Document only at the end of the week",
        "D": "Reassure the patient and take no further action despite deterioration"
      },
      "correct_answer": "A",
      "rationale": "Safe UK nursing practice for urinalysis interpretation requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-476",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Clinical skills and procedures",
      "question": "In relation to urinalysis interpretation, what is the safest nursing action?",
      "options": {
        "A": "Assess the patient, follow local policy, document clearly and escalate concerns when indicated",
        "B": "Ignore the concern unless the patient complains repeatedly",
        "C": "Act outside competence to avoid delaying care",
        "D": "Document only at the end of the week"
      },
      "correct_answer": "A",
      "rationale": "Safe UK nursing practice for urinalysis interpretation requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-477",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Clinical skills and procedures",
      "question": "Which response best demonstrates safe practice regarding specimen labelling?",
      "options": {
        "A": "Ignore the concern unless the patient complains repeatedly",
        "B": "Reassure the patient and take no further action despite deterioration",
        "C": "Act outside competence to avoid delaying care",
        "D": "Communicate clearly, maintain dignity and check understanding before proceeding"
      },
      "correct_answer": "D",
      "rationale": "Safe UK nursing practice for specimen labelling requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-478",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Renal nursing",
      "question": "Which blood result is most closely associated with acute kidney injury?",
      "options": {
        "A": "Rising creatinine",
        "B": "Reduced cholesterol",
        "C": "Raised haemoglobin",
        "D": "Low body temperature"
      },
      "correct_answer": "A",
      "rationale": "Creatinine is used with urine output and clinical assessment when identifying acute kidney injury."
    },
    {
      "id": "UKN-Y2-479",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Clinical skills and procedures",
      "question": "In relation to oxygen delivery devices, what is the safest nursing action?",
      "options": {
        "A": "Ignore the concern unless the patient complains repeatedly",
        "B": "Assess the patient, follow local policy, document clearly and escalate concerns when indicated",
        "C": "Ask an untrained person to manage the problem independently",
        "D": "Act outside competence to avoid delaying care"
      },
      "correct_answer": "B",
      "rationale": "Safe UK nursing practice for oxygen delivery devices requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-480",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Clinical skills and procedures",
      "question": "A patient scenario raises concern about oxygen delivery devices. What should the nurse do first?",
      "options": {
        "A": "Give treatment without checking consent, identity or relevant risks",
        "B": "Prioritise immediate safety using ABCDE or relevant assessment, then seek senior help if needed",
        "C": "Ask an untrained person to manage the problem independently",
        "D": "Reassure the patient and take no further action despite deterioration"
      },
      "correct_answer": "B",
      "rationale": "Safe UK nursing practice for oxygen delivery devices requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-481",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Neurology",
      "question": "A patient develops sudden facial droop and arm weakness. What is the priority?",
      "options": {
        "A": "Arrange routine review next week",
        "B": "Treat as possible stroke and escalate urgently",
        "C": "Encourage sleep and reassess tomorrow",
        "D": "Offer a high sugar meal"
      },
      "correct_answer": "B",
      "rationale": "Sudden focal neurological symptoms require urgent stroke assessment."
    },
    {
      "id": "UKN-Y2-482",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Clinical skills and procedures",
      "question": "Which response best demonstrates safe practice regarding NG tube safety?",
      "options": {
        "A": "Give treatment without checking consent, identity or relevant risks",
        "B": "Ask an untrained person to manage the problem independently",
        "C": "Ignore the concern unless the patient complains repeatedly",
        "D": "Communicate clearly, maintain dignity and check understanding before proceeding"
      },
      "correct_answer": "D",
      "rationale": "Safe UK nursing practice for NG tube safety requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-483",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Clinical skills and procedures",
      "question": "A patient scenario raises concern about blood glucose monitoring. What should the nurse do first?",
      "options": {
        "A": "Ask an untrained person to manage the problem independently",
        "B": "Document only at the end of the week",
        "C": "Prioritise immediate safety using ABCDE or relevant assessment, then seek senior help if needed",
        "D": "Reassure the patient and take no further action despite deterioration"
      },
      "correct_answer": "C",
      "rationale": "Safe UK nursing practice for blood glucose monitoring requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-484",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Clinical skills and procedures",
      "question": "In relation to blood glucose monitoring, what is the safest nursing action?",
      "options": {
        "A": "Ignore the concern unless the patient complains repeatedly",
        "B": "Assess the patient, follow local policy, document clearly and escalate concerns when indicated",
        "C": "Document only at the end of the week",
        "D": "Ask an untrained person to manage the problem independently"
      },
      "correct_answer": "B",
      "rationale": "Safe UK nursing practice for blood glucose monitoring requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-485",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Clinical skills and procedures",
      "question": "Which response best demonstrates safe practice regarding ECG lead placement basics?",
      "options": {
        "A": "Ignore the concern unless the patient complains repeatedly",
        "B": "Reassure the patient and take no further action despite deterioration",
        "C": "Give treatment without checking consent, identity or relevant risks",
        "D": "Communicate clearly, maintain dignity and check understanding before proceeding"
      },
      "correct_answer": "D",
      "rationale": "Safe UK nursing practice for ECG lead placement basics requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-486",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Clinical assessment",
      "question": "Which finding may indicate fluid overload?",
      "options": {
        "A": "Crackles on chest auscultation and increasing breathlessness",
        "B": "Dry mucous membranes only",
        "C": "Excessive thirst only",
        "D": "Low urine specific gravity only"
      },
      "correct_answer": "A",
      "rationale": "Fluid overload can cause pulmonary congestion and respiratory symptoms."
    },
    {
      "id": "UKN-Y2-487",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Clinical skills and procedures",
      "question": "In relation to catheterisation dignity, what is the safest nursing action?",
      "options": {
        "A": "Ignore the concern unless the patient complains repeatedly",
        "B": "Give treatment without checking consent, identity or relevant risks",
        "C": "Ask an untrained person to manage the problem independently",
        "D": "Assess the patient, follow local policy, document clearly and escalate concerns when indicated"
      },
      "correct_answer": "D",
      "rationale": "Safe UK nursing practice for catheterisation dignity requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-488",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Clinical skills and procedures",
      "question": "A patient scenario raises concern about catheterisation dignity. What should the nurse do first?",
      "options": {
        "A": "Act outside competence to avoid delaying care",
        "B": "Ask an untrained person to manage the problem independently",
        "C": "Prioritise immediate safety using ABCDE or relevant assessment, then seek senior help if needed",
        "D": "Ignore the concern unless the patient complains repeatedly"
      },
      "correct_answer": "C",
      "rationale": "Safe UK nursing practice for catheterisation dignity requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-489",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Respiratory nursing",
      "question": "Why are peak flow measurements used in asthma care?",
      "options": {
        "A": "To estimate airflow limitation",
        "B": "To diagnose fractures",
        "C": "To measure blood glucose",
        "D": "To replace all clinical observations"
      },
      "correct_answer": "A",
      "rationale": "Peak expiratory flow helps monitor airway obstruction and response to treatment."
    },
    {
      "id": "UKN-Y2-490",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Clinical skills and procedures",
      "question": "Which response best demonstrates safe practice regarding safe disposal sharps?",
      "options": {
        "A": "Ignore the concern unless the patient complains repeatedly",
        "B": "Communicate clearly, maintain dignity and check understanding before proceeding",
        "C": "Document only at the end of the week",
        "D": "Give treatment without checking consent, identity or relevant risks"
      },
      "correct_answer": "B",
      "rationale": "Safe UK nursing practice for safe disposal sharps requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-491",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Leadership and quality improvement",
      "question": "In relation to incident reporting, what is the safest nursing action?",
      "options": {
        "A": "Act outside competence to avoid delaying care",
        "B": "Document only at the end of the week",
        "C": "Ignore the concern unless the patient complains repeatedly",
        "D": "Assess the patient, follow local policy, document clearly and escalate concerns when indicated"
      },
      "correct_answer": "D",
      "rationale": "Safe UK nursing practice for incident reporting requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-492",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Leadership and quality improvement",
      "question": "A patient scenario raises concern about incident reporting. What should the nurse do first?",
      "options": {
        "A": "Give treatment without checking consent, identity or relevant risks",
        "B": "Document only at the end of the week",
        "C": "Ignore the concern unless the patient complains repeatedly",
        "D": "Prioritise immediate safety using ABCDE or relevant assessment, then seek senior help if needed"
      },
      "correct_answer": "D",
      "rationale": "Safe UK nursing practice for incident reporting requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-493",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Cardiovascular nursing",
      "question": "A patient prescribed digoxin reports nausea and visual disturbances. What should the nurse consider?",
      "options": {
        "A": "A possible sign of digoxin toxicity requiring assessment",
        "B": "A normal expected effect requiring no action",
        "C": "Evidence that the dose should be doubled",
        "D": "A reason to stop all medication permanently"
      },
      "correct_answer": "A",
      "rationale": "Digoxin toxicity may present with gastrointestinal symptoms and visual disturbance; assessment and escalation are required."
    },
    {
      "id": "UKN-Y2-494",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Leadership and quality improvement",
      "question": "Which response best demonstrates safe practice regarding clinical audit feedback?",
      "options": {
        "A": "Ask an untrained person to manage the problem independently",
        "B": "Communicate clearly, maintain dignity and check understanding before proceeding",
        "C": "Reassure the patient and take no further action despite deterioration",
        "D": "Act outside competence to avoid delaying care"
      },
      "correct_answer": "B",
      "rationale": "Safe UK nursing practice for clinical audit feedback requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-495",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Leadership and quality improvement",
      "question": "A patient scenario raises concern about quality improvement PDSA cycle. What should the nurse do first?",
      "options": {
        "A": "Document only at the end of the week",
        "B": "Prioritise immediate safety using ABCDE or relevant assessment, then seek senior help if needed",
        "C": "Ask an untrained person to manage the problem independently",
        "D": "Give treatment without checking consent, identity or relevant risks"
      },
      "correct_answer": "B",
      "rationale": "Safe UK nursing practice for quality improvement PDSA cycle requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-496",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Leadership and quality improvement",
      "question": "In relation to quality improvement PDSA cycle, what is the safest nursing action?",
      "options": {
        "A": "Assess the patient, follow local policy, document clearly and escalate concerns when indicated",
        "B": "Document only at the end of the week",
        "C": "Ignore the concern unless the patient complains repeatedly",
        "D": "Act outside competence to avoid delaying care"
      },
      "correct_answer": "A",
      "rationale": "Safe UK nursing practice for quality improvement PDSA cycle requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-497",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Leadership and quality improvement",
      "question": "Which response best demonstrates safe practice regarding student leadership?",
      "options": {
        "A": "Communicate clearly, maintain dignity and check understanding before proceeding",
        "B": "Give treatment without checking consent, identity or relevant risks",
        "C": "Reassure the patient and take no further action despite deterioration",
        "D": "Ask an untrained person to manage the problem independently"
      },
      "correct_answer": "A",
      "rationale": "Safe UK nursing practice for student leadership requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-498",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Renal nursing",
      "question": "Which blood result is most closely associated with acute kidney injury?",
      "options": {
        "A": "Rising creatinine",
        "B": "Reduced cholesterol",
        "C": "Raised haemoglobin",
        "D": "Low body temperature"
      },
      "correct_answer": "A",
      "rationale": "Creatinine is used with urine output and clinical assessment when identifying acute kidney injury."
    },
    {
      "id": "UKN-Y2-499",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Leadership and quality improvement",
      "question": "In relation to prioritising workload, what is the safest nursing action?",
      "options": {
        "A": "Reassure the patient and take no further action despite deterioration",
        "B": "Act outside competence to avoid delaying care",
        "C": "Assess the patient, follow local policy, document clearly and escalate concerns when indicated",
        "D": "Document only at the end of the week"
      },
      "correct_answer": "C",
      "rationale": "Safe UK nursing practice for prioritising workload requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    },
    {
      "id": "UKN-Y2-500",
      "level": "Second year undergraduate nursing (UK)",
      "domain": "Leadership and quality improvement",
      "question": "A patient scenario raises concern about prioritising workload. What should the nurse do first?",
      "options": {
        "A": "Ask an untrained person to manage the problem independently",
        "B": "Prioritise immediate safety using ABCDE or relevant assessment, then seek senior help if needed",
        "C": "Give treatment without checking consent, identity or relevant risks",
        "D": "Act outside competence to avoid delaying care"
      },
      "correct_answer": "B",
      "rationale": "Safe UK nursing practice for prioritising workload requires assessment, person-centred communication, working within competence, documentation and timely escalation when risk is present."
    }
  ]
}